// @generated by protobuf-ts 2.9.0 with parameter generate_dependencies,force_optimize_code_size,long_type_string,ts_nocheck
// @generated from protobuf file "app/v1/app.proto" (package "viam.app.v1", syntax proto3)
// tslint:disable
// @ts-nocheck
import { ServiceType } from "@protobuf-ts/runtime-rpc";
import { MessageType } from "@protobuf-ts/runtime";
import { PackageType } from "../packages/v1/packages";
import { ModelFramework } from "../mltraining/v1/ml_training";
import { ModelType } from "../mltraining/v1/ml_training";
import { Value } from "../../google/protobuf/struct";
import { LogEntry } from "../../common/v1/common";
import { Struct } from "../../google/protobuf/struct";
import { Timestamp } from "../../google/protobuf/timestamp";
/**
 * @generated from protobuf message viam.app.v1.Robot
 */
export interface Robot {
    /**
     * @generated from protobuf field: string id = 1;
     */
    id: string;
    /**
     * @generated from protobuf field: string name = 2;
     */
    name: string;
    /**
     * @generated from protobuf field: string location = 3;
     */
    location: string;
    /**
     * @generated from protobuf field: google.protobuf.Timestamp last_access = 4;
     */
    lastAccess?: Timestamp;
    /**
     * @generated from protobuf field: google.protobuf.Timestamp created_on = 5;
     */
    createdOn?: Timestamp;
    /**
     * @generated from protobuf field: viam.app.v1.OnlineState online_state = 6;
     */
    onlineState: OnlineState;
    /**
     * @generated from protobuf field: int64 seconds_since_online = 7;
     */
    secondsSinceOnline: string;
}
/**
 * @generated from protobuf message viam.app.v1.RobotPart
 */
export interface RobotPart {
    /**
     * @generated from protobuf field: string id = 1;
     */
    id: string;
    /**
     * @generated from protobuf field: string name = 2;
     */
    name: string;
    /**
     * dns_name part name used for fqdn and local fqdn. Anytime the Name is updated this should be sanitized and updated as well.
     *
     * @generated from protobuf field: string dns_name = 10;
     */
    dnsName: string;
    /**
     * @generated from protobuf field: string secret = 3;
     */
    secret: string;
    /**
     * @generated from protobuf field: string robot = 4;
     */
    robot: string;
    /**
     * Store the location_id to allow for unique indexes across parts and locations. This filed MUST be updated each time the robots location
     * changes.
     *
     * @generated from protobuf field: string location_id = 12;
     */
    locationId: string;
    /**
     * @generated from protobuf field: google.protobuf.Struct robot_config = 5;
     */
    robotConfig?: Struct;
    /**
     * @generated from protobuf field: google.protobuf.Timestamp last_access = 6;
     */
    lastAccess?: Timestamp;
    /**
     * @generated from protobuf field: google.protobuf.Struct user_supplied_info = 7;
     */
    userSuppliedInfo?: Struct;
    /**
     * @generated from protobuf field: bool main_part = 8;
     */
    mainPart: boolean;
    /**
     * @generated from protobuf field: string fqdn = 9;
     */
    fqdn: string;
    /**
     * @generated from protobuf field: string local_fqdn = 11;
     */
    localFqdn: string;
    /**
     * @generated from protobuf field: google.protobuf.Timestamp created_on = 13;
     */
    createdOn?: Timestamp;
    /**
     * List of secrets allowed for authentication.
     *
     * @generated from protobuf field: repeated viam.app.v1.SharedSecret secrets = 14;
     */
    secrets: SharedSecret[];
    /**
     * latest timestamp when a robot part was updated
     *
     * @generated from protobuf field: google.protobuf.Timestamp last_updated = 15;
     */
    lastUpdated?: Timestamp;
    /**
     * @generated from protobuf field: viam.app.v1.OnlineState online_state = 16;
     */
    onlineState: OnlineState;
    /**
     * @generated from protobuf field: int64 seconds_since_online = 17;
     */
    secondsSinceOnline: string;
    /**
     * robot_config_json is the raw JSON string of the robot config, preserving user-defined key order.
     *
     * @generated from protobuf field: optional string robot_config_json = 18;
     */
    robotConfigJson?: string;
}
/**
 * @generated from protobuf message viam.app.v1.RobotPartHistoryEntry
 */
export interface RobotPartHistoryEntry {
    /**
     * @generated from protobuf field: string part = 1;
     */
    part: string;
    /**
     * @generated from protobuf field: string robot = 2;
     */
    robot: string;
    /**
     * @generated from protobuf field: google.protobuf.Timestamp when = 3;
     */
    when?: Timestamp;
    /**
     * @generated from protobuf field: viam.app.v1.RobotPart old = 4;
     */
    old?: RobotPart;
    /**
     * @generated from protobuf field: viam.app.v1.AuthenticatorInfo edited_by = 5;
     */
    editedBy?: AuthenticatorInfo;
}
/**
 * @generated from protobuf message viam.app.v1.AuthenticatorInfo
 */
export interface AuthenticatorInfo {
    /**
     * @generated from protobuf field: viam.app.v1.AuthenticationType type = 1;
     */
    type: AuthenticationType;
    /**
     * @generated from protobuf field: string value = 2;
     */
    value: string;
    /**
     * @generated from protobuf field: bool is_deactivated = 3;
     */
    isDeactivated: boolean;
}
/**
 * @generated from protobuf message viam.app.v1.ListOrganizationsRequest
 */
export interface ListOrganizationsRequest {
}
/**
 * An empty list means that all methods are allowed.
 *
 * @generated from protobuf message viam.app.v1.AllowedLoginMethods
 */
export interface AllowedLoginMethods {
    /**
     * @generated from protobuf field: repeated viam.app.v1.LoginMethod methods = 1;
     */
    methods: LoginMethod[];
}
/**
 * @generated from protobuf message viam.app.v1.Organization
 */
export interface Organization {
    /**
     * @generated from protobuf field: string id = 1;
     */
    id: string;
    /**
     * @generated from protobuf field: string name = 2;
     */
    name: string;
    /**
     * @generated from protobuf field: google.protobuf.Timestamp created_on = 3;
     */
    createdOn?: Timestamp;
    /**
     * @generated from protobuf field: string public_namespace = 4;
     */
    publicNamespace: string;
    /**
     * GCS region of the organization. Locations created under this org will have their GCS region set to this by default and packages
     * associated with this org will be stored in this region.
     *
     * @generated from protobuf field: string default_region = 5;
     */
    defaultRegion: string;
    /**
     * @generated from protobuf field: optional string cid = 6;
     */
    cid?: string;
    /**
     * @generated from protobuf field: optional viam.app.v1.FragmentImportList default_fragments = 7;
     */
    defaultFragments?: FragmentImportList;
    /**
     * @generated from protobuf field: optional viam.app.v1.AllowedLoginMethods allowed_login_methods = 8;
     */
    allowedLoginMethods?: AllowedLoginMethods;
}
/**
 * @generated from protobuf message viam.app.v1.OrganizationMember
 */
export interface OrganizationMember {
    /**
     * @generated from protobuf field: string user_id = 1;
     */
    userId: string;
    /**
     * @generated from protobuf field: repeated string emails = 2;
     */
    emails: string[];
    /**
     * @generated from protobuf field: google.protobuf.Timestamp date_added = 3;
     */
    dateAdded?: Timestamp;
    /**
     * @generated from protobuf field: optional google.protobuf.Timestamp last_login = 4;
     */
    lastLogin?: Timestamp;
    /**
     * @generated from protobuf field: optional google.protobuf.Timestamp last_access = 5;
     */
    lastAccess?: Timestamp;
}
/**
 * @generated from protobuf message viam.app.v1.ListOrganizationsResponse
 */
export interface ListOrganizationsResponse {
    /**
     * @generated from protobuf field: repeated viam.app.v1.Organization organizations = 1;
     */
    organizations: Organization[];
}
/**
 * @generated from protobuf message viam.app.v1.OrganizationInvite
 */
export interface OrganizationInvite {
    /**
     * @generated from protobuf field: string organization_id = 1;
     */
    organizationId: string;
    /**
     * @generated from protobuf field: string email = 2;
     */
    email: string;
    /**
     * @generated from protobuf field: google.protobuf.Timestamp created_on = 3;
     */
    createdOn?: Timestamp;
    /**
     * @generated from protobuf field: repeated viam.app.v1.Authorization authorizations = 4;
     */
    authorizations: Authorization[];
}
/**
 * @generated from protobuf message viam.app.v1.CreateOrganizationRequest
 */
export interface CreateOrganizationRequest {
    /**
     * @generated from protobuf field: string name = 1;
     */
    name: string;
}
/**
 * @generated from protobuf message viam.app.v1.CreateOrganizationResponse
 */
export interface CreateOrganizationResponse {
    /**
     * @generated from protobuf field: viam.app.v1.Organization organization = 1;
     */
    organization?: Organization;
}
/**
 * @generated from protobuf message viam.app.v1.GetOrganizationRequest
 */
export interface GetOrganizationRequest {
    /**
     * @generated from protobuf field: string organization_id = 1;
     */
    organizationId: string;
}
/**
 * @generated from protobuf message viam.app.v1.GetOrganizationResponse
 */
export interface GetOrganizationResponse {
    /**
     * @generated from protobuf field: viam.app.v1.Organization organization = 1;
     */
    organization?: Organization;
}
/**
 * @generated from protobuf message viam.app.v1.GetOrganizationNamespaceAvailabilityRequest
 */
export interface GetOrganizationNamespaceAvailabilityRequest {
    /**
     * @generated from protobuf field: string public_namespace = 1;
     */
    publicNamespace: string;
    /**
     * @generated from protobuf field: string organization_id = 2;
     */
    organizationId: string;
}
/**
 * @generated from protobuf message viam.app.v1.GetOrganizationNamespaceAvailabilityResponse
 */
export interface GetOrganizationNamespaceAvailabilityResponse {
    /**
     * @generated from protobuf field: bool available = 1;
     */
    available: boolean;
}
/**
 * @generated from protobuf message viam.app.v1.FragmentImportList
 */
export interface FragmentImportList {
    /**
     * @generated from protobuf field: repeated viam.app.v1.FragmentImport fragments = 1;
     */
    fragments: FragmentImport[];
}
/**
 * @generated from protobuf message viam.app.v1.UpdateOrganizationRequest
 */
export interface UpdateOrganizationRequest {
    /**
     * @generated from protobuf field: string organization_id = 1;
     */
    organizationId: string;
    /**
     * @generated from protobuf field: optional string name = 2;
     */
    name?: string;
    /**
     * @generated from protobuf field: optional string public_namespace = 3;
     */
    publicNamespace?: string;
    /**
     * The new GCS region to associate the org with.
     *
     * @generated from protobuf field: optional string region = 4;
     */
    region?: string;
    /**
     * @generated from protobuf field: optional string cid = 5;
     */
    cid?: string;
    /**
     * @generated from protobuf field: optional viam.app.v1.FragmentImportList default_fragments = 6;
     */
    defaultFragments?: FragmentImportList;
    /**
     * @generated from protobuf field: optional viam.app.v1.AllowedLoginMethods allowed_login_methods = 7;
     */
    allowedLoginMethods?: AllowedLoginMethods;
}
/**
 * @generated from protobuf message viam.app.v1.UpdateOrganizationResponse
 */
export interface UpdateOrganizationResponse {
    /**
     * @generated from protobuf field: viam.app.v1.Organization organization = 1;
     */
    organization?: Organization;
}
/**
 * @generated from protobuf message viam.app.v1.UpdateOrganizationNamespaceRequest
 */
export interface UpdateOrganizationNamespaceRequest {
    /**
     * @generated from protobuf field: string organization_id = 1;
     */
    organizationId: string;
    /**
     * @generated from protobuf field: string new_public_namespace = 2;
     */
    newPublicNamespace: string;
}
/**
 * @generated from protobuf message viam.app.v1.UpdateOrganizationNamespaceResponse
 */
export interface UpdateOrganizationNamespaceResponse {
    /**
     * @generated from protobuf field: viam.app.v1.Organization organization = 1;
     */
    organization?: Organization;
}
/**
 * @generated from protobuf message viam.app.v1.DeleteOrganizationRequest
 */
export interface DeleteOrganizationRequest {
    /**
     * @generated from protobuf field: string organization_id = 1;
     */
    organizationId: string;
}
/**
 * @generated from protobuf message viam.app.v1.DeleteOrganizationResponse
 */
export interface DeleteOrganizationResponse {
}
/**
 * @generated from protobuf message viam.app.v1.GetOrganizationMetadataRequest
 */
export interface GetOrganizationMetadataRequest {
    /**
     * @generated from protobuf field: string organization_id = 1;
     */
    organizationId: string;
}
/**
 * @generated from protobuf message viam.app.v1.GetOrganizationMetadataResponse
 */
export interface GetOrganizationMetadataResponse {
    /**
     * @generated from protobuf field: google.protobuf.Struct data = 1;
     */
    data?: Struct;
}
/**
 * @generated from protobuf message viam.app.v1.UpdateOrganizationMetadataRequest
 */
export interface UpdateOrganizationMetadataRequest {
    /**
     * @generated from protobuf field: string organization_id = 1;
     */
    organizationId: string;
    /**
     * @generated from protobuf field: google.protobuf.Struct data = 2;
     */
    data?: Struct;
}
/**
 * @generated from protobuf message viam.app.v1.UpdateOrganizationMetadataResponse
 */
export interface UpdateOrganizationMetadataResponse {
}
/**
 * @generated from protobuf message viam.app.v1.ListOrganizationMembersRequest
 */
export interface ListOrganizationMembersRequest {
    /**
     * @generated from protobuf field: string organization_id = 1;
     */
    organizationId: string;
}
/**
 * @generated from protobuf message viam.app.v1.ListOrganizationMembersResponse
 */
export interface ListOrganizationMembersResponse {
    /**
     * @generated from protobuf field: string organization_id = 1;
     */
    organizationId: string;
    /**
     * @generated from protobuf field: repeated viam.app.v1.OrganizationMember members = 2;
     */
    members: OrganizationMember[];
    /**
     * @generated from protobuf field: repeated viam.app.v1.OrganizationInvite invites = 3;
     */
    invites: OrganizationInvite[];
}
/**
 * @generated from protobuf message viam.app.v1.CreateOrganizationInviteRequest
 */
export interface CreateOrganizationInviteRequest {
    /**
     * @generated from protobuf field: string organization_id = 1;
     */
    organizationId: string;
    /**
     * @generated from protobuf field: string email = 2;
     */
    email: string;
    /**
     * @generated from protobuf field: repeated viam.app.v1.Authorization authorizations = 3;
     */
    authorizations: Authorization[];
    /**
     * Set to true (the default) to send an email to the recipient of an invite. The user must accept the email to be added to the associated authorizations.
     * When set to false, the user automatically receives the associated authorization on the next login of the user with the associated email address.
     *
     * @generated from protobuf field: optional bool send_email_invite = 4;
     */
    sendEmailInvite?: boolean;
}
/**
 * @generated from protobuf message viam.app.v1.CreateOrganizationInviteResponse
 */
export interface CreateOrganizationInviteResponse {
    /**
     * @generated from protobuf field: viam.app.v1.OrganizationInvite invite = 1;
     */
    invite?: OrganizationInvite;
}
/**
 * @generated from protobuf message viam.app.v1.UpdateOrganizationInviteAuthorizationsRequest
 */
export interface UpdateOrganizationInviteAuthorizationsRequest {
    /**
     * @generated from protobuf field: string organization_id = 1;
     */
    organizationId: string;
    /**
     * @generated from protobuf field: string email = 2;
     */
    email: string;
    /**
     * @generated from protobuf field: repeated viam.app.v1.Authorization add_authorizations = 3;
     */
    addAuthorizations: Authorization[];
    /**
     * @generated from protobuf field: repeated viam.app.v1.Authorization remove_authorizations = 4;
     */
    removeAuthorizations: Authorization[];
}
/**
 * @generated from protobuf message viam.app.v1.UpdateOrganizationInviteAuthorizationsResponse
 */
export interface UpdateOrganizationInviteAuthorizationsResponse {
    /**
     * @generated from protobuf field: viam.app.v1.OrganizationInvite invite = 1;
     */
    invite?: OrganizationInvite;
}
/**
 * @generated from protobuf message viam.app.v1.DeleteOrganizationInviteRequest
 */
export interface DeleteOrganizationInviteRequest {
    /**
     * @generated from protobuf field: string organization_id = 1;
     */
    organizationId: string;
    /**
     * @generated from protobuf field: string email = 2;
     */
    email: string;
}
/**
 * @generated from protobuf message viam.app.v1.DeleteOrganizationInviteResponse
 */
export interface DeleteOrganizationInviteResponse {
}
/**
 * @generated from protobuf message viam.app.v1.ResendOrganizationInviteRequest
 */
export interface ResendOrganizationInviteRequest {
    /**
     * @generated from protobuf field: string organization_id = 1;
     */
    organizationId: string;
    /**
     * @generated from protobuf field: string email = 2;
     */
    email: string;
    /**
     * Set to true (the default) to send an email to the recipient of an invite. The user must accept the email to be added to the associated authorizations.
     * When set to false, the user automatically receives the associated authorization on the next login of the user with the associated email address.
     *
     * @generated from protobuf field: optional bool send_email_invite = 3;
     */
    sendEmailInvite?: boolean;
}
/**
 * @generated from protobuf message viam.app.v1.ResendOrganizationInviteResponse
 */
export interface ResendOrganizationInviteResponse {
    /**
     * @generated from protobuf field: viam.app.v1.OrganizationInvite invite = 1;
     */
    invite?: OrganizationInvite;
}
/**
 * @generated from protobuf message viam.app.v1.DeleteOrganizationMemberRequest
 */
export interface DeleteOrganizationMemberRequest {
    /**
     * @generated from protobuf field: string organization_id = 1;
     */
    organizationId: string;
    /**
     * @generated from protobuf field: string user_id = 2;
     */
    userId: string;
}
/**
 * @generated from protobuf message viam.app.v1.DeleteOrganizationMemberResponse
 */
export interface DeleteOrganizationMemberResponse {
}
// Third Party Org Services

/**
 * @generated from protobuf message viam.app.v1.BillingAddress
 */
export interface BillingAddress {
    /**
     * @generated from protobuf field: string address_line_1 = 1;
     */
    addressLine1: string;
    /**
     * @generated from protobuf field: optional string address_line_2 = 2;
     */
    addressLine2?: string;
    /**
     * @generated from protobuf field: string city = 3;
     */
    city: string;
    /**
     * @generated from protobuf field: string state = 4;
     */
    state: string;
    /**
     * @generated from protobuf field: string zipcode = 5;
     */
    zipcode: string;
    /**
     * @generated from protobuf field: string country = 6;
     */
    country: string;
}
/**
 * @generated from protobuf message viam.app.v1.EnableBillingServiceRequest
 */
export interface EnableBillingServiceRequest {
    /**
     * @generated from protobuf field: string org_id = 1;
     */
    orgId: string;
    /**
     * @generated from protobuf field: viam.app.v1.BillingAddress billing_address = 2;
     */
    billingAddress?: BillingAddress;
}
/**
 * @generated from protobuf message viam.app.v1.EnableBillingServiceResponse
 */
export interface EnableBillingServiceResponse {
}
/**
 * @generated from protobuf message viam.app.v1.UpdateBillingServiceRequest
 */
export interface UpdateBillingServiceRequest {
    /**
     * @generated from protobuf field: string org_id = 1;
     */
    orgId: string;
    /**
     * @generated from protobuf field: viam.app.v1.BillingAddress billing_address = 2;
     */
    billingAddress?: BillingAddress;
}
/**
 * @generated from protobuf message viam.app.v1.UpdateBillingServiceResponse
 */
export interface UpdateBillingServiceResponse {
}
/**
 * @generated from protobuf message viam.app.v1.GetBillingServiceConfigRequest
 */
export interface GetBillingServiceConfigRequest {
    /**
     * @generated from protobuf field: string org_id = 1;
     */
    orgId: string;
}
/**
 * @generated from protobuf message viam.app.v1.GetBillingServiceConfigResponse
 */
export interface GetBillingServiceConfigResponse {
    /**
     * @generated from protobuf field: viam.app.v1.BillingAddress billing_address = 1;
     */
    billingAddress?: BillingAddress;
    /**
     * @generated from protobuf field: string support_email = 2;
     */
    supportEmail: string;
    /**
     * @generated from protobuf field: string logo_url = 3;
     */
    logoUrl: string;
    /**
     * @generated from protobuf field: string billing_dashboard_url = 4;
     */
    billingDashboardUrl: string;
}
/**
 * @generated from protobuf message viam.app.v1.DisableBillingServiceRequest
 */
export interface DisableBillingServiceRequest {
    /**
     * @generated from protobuf field: string org_id = 1;
     */
    orgId: string;
}
/**
 * @generated from protobuf message viam.app.v1.DisableBillingServiceResponse
 */
export interface DisableBillingServiceResponse {
}
/**
 * @generated from protobuf message viam.app.v1.OrganizationSetSupportEmailRequest
 */
export interface OrganizationSetSupportEmailRequest {
    /**
     * @generated from protobuf field: string org_id = 1;
     */
    orgId: string;
    /**
     * @generated from protobuf field: string email = 2;
     */
    email: string;
}
/**
 * @generated from protobuf message viam.app.v1.OrganizationSetSupportEmailResponse
 */
export interface OrganizationSetSupportEmailResponse {
}
/**
 * @generated from protobuf message viam.app.v1.OrganizationGetSupportEmailRequest
 */
export interface OrganizationGetSupportEmailRequest {
    /**
     * @generated from protobuf field: string org_id = 1;
     */
    orgId: string;
}
/**
 * @generated from protobuf message viam.app.v1.OrganizationGetSupportEmailResponse
 */
export interface OrganizationGetSupportEmailResponse {
    /**
     * @generated from protobuf field: string email = 1;
     */
    email: string;
}
// Location
// 

/**
 * Used for rendering an organization's information on the frontend (limited
 * to id, name, or both).
 *
 * @generated from protobuf message viam.app.v1.OrganizationIdentity
 */
export interface OrganizationIdentity {
    /**
     * Organization ID.
     *
     * @generated from protobuf field: string id = 1;
     */
    id: string;
    /**
     * Organization name.
     *
     * @generated from protobuf field: string name = 2;
     */
    name: string;
}
/**
 * @generated from protobuf message viam.app.v1.LocationOrganization
 */
export interface LocationOrganization {
    /**
     * Organization ID the location is shared with.
     *
     * @generated from protobuf field: string organization_id = 1;
     */
    organizationId: string;
    /**
     * Whether the organization is the primary owner or not.
     *
     * @generated from protobuf field: bool primary = 2;
     */
    primary: boolean;
}
/**
 * @generated from protobuf message viam.app.v1.LocationAuth
 */
export interface LocationAuth {
    /**
     * Deprecated: use secrets field.
     *
     * @deprecated
     * @generated from protobuf field: string secret = 1 [deprecated = true];
     */
    secret: string;
    /**
     * Location ID containing this LocationAuth.
     *
     * @generated from protobuf field: string location_id = 2;
     */
    locationId: string;
    /**
     * List of secrets used to authenticate to the Location.
     *
     * @generated from protobuf field: repeated viam.app.v1.SharedSecret secrets = 3;
     */
    secrets: SharedSecret[];
}
/**
 * @generated from protobuf message viam.app.v1.StorageConfig
 */
export interface StorageConfig {
    /**
     * GCS region that data is stored in.
     *
     * @generated from protobuf field: string region = 1;
     */
    region: string;
}
/**
 * @generated from protobuf message viam.app.v1.Location
 */
export interface Location {
    /**
     * Location ID.
     *
     * @generated from protobuf field: string id = 1;
     */
    id: string;
    /**
     * Location name.
     *
     * @generated from protobuf field: string name = 2;
     */
    name: string;
    /**
     * Location ID of the parent location.
     *
     * @generated from protobuf field: string parent_location_id = 4;
     */
    parentLocationId: string;
    /**
     * Location authentication secrets.
     *
     * @generated from protobuf field: viam.app.v1.LocationAuth auth = 5;
     */
    auth?: LocationAuth;
    /**
     * Organizations that the location is shared with.
     *
     * @generated from protobuf field: repeated viam.app.v1.LocationOrganization organizations = 6;
     */
    organizations: LocationOrganization[];
    /**
     * Location creation timestamp.
     *
     * @generated from protobuf field: google.protobuf.Timestamp created_on = 3;
     */
    createdOn?: Timestamp;
    /**
     * @generated from protobuf field: int32 robot_count = 7;
     */
    robotCount: number;
    /**
     * Config for how data in this location is stored.
     *
     * @generated from protobuf field: viam.app.v1.StorageConfig config = 8;
     */
    config?: StorageConfig;
    /**
     * The organization that is the primary owner of the location.
     *
     * @generated from protobuf field: optional viam.app.v1.OrganizationIdentity primary_org_identity = 9;
     */
    primaryOrgIdentity?: OrganizationIdentity;
}
/**
 * SharedSecret is a secret used for LocationAuth and RobotParts.
 *
 * @generated from protobuf message viam.app.v1.SharedSecret
 */
export interface SharedSecret {
    /**
     * @generated from protobuf field: string id = 1;
     */
    id: string;
    /**
     * The payload of the secret. Used during authentication to the rpc framework.
     *
     * @generated from protobuf field: string secret = 2;
     */
    secret: string;
    /**
     * Date/time the secret was first created.
     *
     * @generated from protobuf field: google.protobuf.Timestamp created_on = 3;
     */
    createdOn?: Timestamp;
    /**
     * State of the shared secret. In most cases it should be enabled. We may support
     * disabling a specific secret while keeping it in the database.
     *
     * @generated from protobuf field: viam.app.v1.SharedSecret.State state = 4;
     */
    state: SharedSecret_State;
}
/**
 * @generated from protobuf enum viam.app.v1.SharedSecret.State
 */
export enum SharedSecret_State {
    /**
     * @generated from protobuf enum value: STATE_UNSPECIFIED = 0;
     */
    UNSPECIFIED = 0,
    /**
     * Secret is enabled and can be used in authentication.
     *
     * @generated from protobuf enum value: STATE_ENABLED = 1;
     */
    ENABLED = 1,
    /**
     * Secret is disabled and must not be used to authenticate to rpc.
     *
     * @generated from protobuf enum value: STATE_DISABLED = 2;
     */
    DISABLED = 2
}
/**
 * @generated from protobuf message viam.app.v1.CreateLocationRequest
 */
export interface CreateLocationRequest {
    /**
     * Organization ID to create the location under.
     *
     * @generated from protobuf field: string organization_id = 1;
     */
    organizationId: string;
    /**
     * Name of the location.
     *
     * @generated from protobuf field: string name = 2;
     */
    name: string;
    /**
     * The new parent location to move the location under.
     *
     * @generated from protobuf field: optional string parent_location_id = 3;
     */
    parentLocationId?: string;
}
/**
 * @generated from protobuf message viam.app.v1.CreateLocationResponse
 */
export interface CreateLocationResponse {
    /**
     * Location object is returned.
     *
     * @generated from protobuf field: viam.app.v1.Location location = 1;
     */
    location?: Location;
}
/**
 * @generated from protobuf message viam.app.v1.GetLocationRequest
 */
export interface GetLocationRequest {
    /**
     * Location ID of location to get.
     *
     * @generated from protobuf field: string location_id = 1;
     */
    locationId: string;
}
/**
 * @generated from protobuf message viam.app.v1.GetLocationResponse
 */
export interface GetLocationResponse {
    /**
     * Location object is returned.
     *
     * @generated from protobuf field: viam.app.v1.Location location = 1;
     */
    location?: Location;
}
/**
 * @generated from protobuf message viam.app.v1.UpdateLocationRequest
 */
export interface UpdateLocationRequest {
    /**
     * Location ID of location to update.
     *
     * @generated from protobuf field: string location_id = 1;
     */
    locationId: string;
    /**
     * The new name to be updated on location.
     *
     * @generated from protobuf field: optional string name = 2;
     */
    name?: string;
    /**
     * The new parent location to move the location under.
     *
     * @generated from protobuf field: optional string parent_location_id = 3;
     */
    parentLocationId?: string;
    /**
     * The new GCS region to associate the location with.
     *
     * @generated from protobuf field: optional string region = 4;
     */
    region?: string;
}
/**
 * @generated from protobuf message viam.app.v1.UpdateLocationResponse
 */
export interface UpdateLocationResponse {
    /**
     * Location object is returned.
     *
     * @generated from protobuf field: viam.app.v1.Location location = 1;
     */
    location?: Location;
}
/**
 * @generated from protobuf message viam.app.v1.DeleteLocationRequest
 */
export interface DeleteLocationRequest {
    /**
     * Location ID of location to delete.
     *
     * @generated from protobuf field: string location_id = 1;
     */
    locationId: string;
}
/**
 * @generated from protobuf message viam.app.v1.DeleteLocationResponse
 */
export interface DeleteLocationResponse {
}
/**
 * @generated from protobuf message viam.app.v1.GetLocationMetadataRequest
 */
export interface GetLocationMetadataRequest {
    /**
     * @generated from protobuf field: string location_id = 1;
     */
    locationId: string;
}
/**
 * @generated from protobuf message viam.app.v1.GetLocationMetadataResponse
 */
export interface GetLocationMetadataResponse {
    /**
     * @generated from protobuf field: google.protobuf.Struct data = 1;
     */
    data?: Struct;
}
/**
 * @generated from protobuf message viam.app.v1.UpdateLocationMetadataRequest
 */
export interface UpdateLocationMetadataRequest {
    /**
     * @generated from protobuf field: string location_id = 1;
     */
    locationId: string;
    /**
     * @generated from protobuf field: google.protobuf.Struct data = 2;
     */
    data?: Struct;
}
/**
 * @generated from protobuf message viam.app.v1.UpdateLocationMetadataResponse
 */
export interface UpdateLocationMetadataResponse {
}
/**
 * @generated from protobuf message viam.app.v1.GetOrganizationsWithAccessToLocationRequest
 */
export interface GetOrganizationsWithAccessToLocationRequest {
    /**
     * @generated from protobuf field: string location_id = 1;
     */
    locationId: string;
}
/**
 * @generated from protobuf message viam.app.v1.GetOrganizationsWithAccessToLocationResponse
 */
export interface GetOrganizationsWithAccessToLocationResponse {
    /**
     * @generated from protobuf field: repeated viam.app.v1.OrganizationIdentity organization_identities = 1;
     */
    organizationIdentities: OrganizationIdentity[];
}
/**
 * @generated from protobuf message viam.app.v1.ListLocationsRequest
 */
export interface ListLocationsRequest {
    /**
     * Organization ID under which to list all locations.
     *
     * @generated from protobuf field: string organization_id = 1;
     */
    organizationId: string;
}
/**
 * @generated from protobuf message viam.app.v1.ShareLocationRequest
 */
export interface ShareLocationRequest {
    /**
     * Location ID to be shared.
     *
     * @generated from protobuf field: string location_id = 1;
     */
    locationId: string;
    /**
     * Organization ID to share the location with.
     *
     * @generated from protobuf field: string organization_id = 2;
     */
    organizationId: string;
}
/**
 * @generated from protobuf message viam.app.v1.ShareLocationResponse
 */
export interface ShareLocationResponse {
}
/**
 * @generated from protobuf message viam.app.v1.UnshareLocationRequest
 */
export interface UnshareLocationRequest {
    /**
     * Location ID to be unshared.
     *
     * @generated from protobuf field: string location_id = 1;
     */
    locationId: string;
    /**
     * Organization ID to unshare the location with.
     *
     * @generated from protobuf field: string organization_id = 2;
     */
    organizationId: string;
}
/**
 * @generated from protobuf message viam.app.v1.UnshareLocationResponse
 */
export interface UnshareLocationResponse {
}
/**
 * @generated from protobuf message viam.app.v1.ListLocationsResponse
 */
export interface ListLocationsResponse {
    /**
     * @generated from protobuf field: repeated viam.app.v1.Location locations = 1;
     */
    locations: Location[];
}
/**
 * @generated from protobuf message viam.app.v1.CreateLocationSecretRequest
 */
export interface CreateLocationSecretRequest {
    /**
     * Location ID to create the secret in.
     *
     * @generated from protobuf field: string location_id = 1;
     */
    locationId: string;
}
/**
 * @generated from protobuf message viam.app.v1.CreateLocationSecretResponse
 */
export interface CreateLocationSecretResponse {
    /**
     * Location's auth after updates.
     *
     * @generated from protobuf field: viam.app.v1.LocationAuth auth = 1;
     */
    auth?: LocationAuth;
}
/**
 * @generated from protobuf message viam.app.v1.DeleteLocationSecretRequest
 */
export interface DeleteLocationSecretRequest {
    /**
     * @generated from protobuf field: string location_id = 1;
     */
    locationId: string;
    /**
     * @generated from protobuf field: string secret_id = 2;
     */
    secretId: string;
}
/**
 * @generated from protobuf message viam.app.v1.DeleteLocationSecretResponse
 */
export interface DeleteLocationSecretResponse {
}
/**
 * @generated from protobuf message viam.app.v1.LocationAuthRequest
 */
export interface LocationAuthRequest {
    /**
     * @generated from protobuf field: string location_id = 1;
     */
    locationId: string;
}
/**
 * @generated from protobuf message viam.app.v1.LocationAuthResponse
 */
export interface LocationAuthResponse {
    /**
     * @generated from protobuf field: viam.app.v1.LocationAuth auth = 1;
     */
    auth?: LocationAuth;
}
/**
 * @generated from protobuf message viam.app.v1.GetRobotRequest
 */
export interface GetRobotRequest {
    /**
     * @generated from protobuf field: string id = 1;
     */
    id: string;
}
/**
 * @generated from protobuf message viam.app.v1.GetRoverRentalRobotsRequest
 */
export interface GetRoverRentalRobotsRequest {
    /**
     * @generated from protobuf field: string org_id = 1;
     */
    orgId: string;
}
/**
 * @generated from protobuf message viam.app.v1.RoverRentalRobot
 */
export interface RoverRentalRobot {
    /**
     * @generated from protobuf field: string robot_id = 1;
     */
    robotId: string;
    /**
     * @generated from protobuf field: string location_id = 2;
     */
    locationId: string;
    /**
     * @generated from protobuf field: string robot_name = 3;
     */
    robotName: string;
    /**
     * @generated from protobuf field: string robot_main_part_id = 4;
     */
    robotMainPartId: string;
}
/**
 * @generated from protobuf message viam.app.v1.GetRoverRentalRobotsResponse
 */
export interface GetRoverRentalRobotsResponse {
    /**
     * @generated from protobuf field: repeated viam.app.v1.RoverRentalRobot robots = 1;
     */
    robots: RoverRentalRobot[];
}
/**
 * @generated from protobuf message viam.app.v1.GetRobotResponse
 */
export interface GetRobotResponse {
    /**
     * @generated from protobuf field: viam.app.v1.Robot robot = 1;
     */
    robot?: Robot;
}
/**
 * @generated from protobuf message viam.app.v1.GetRobotPartsRequest
 */
export interface GetRobotPartsRequest {
    /**
     * @generated from protobuf field: string robot_id = 1;
     */
    robotId: string;
}
/**
 * @generated from protobuf message viam.app.v1.GetRobotPartsResponse
 */
export interface GetRobotPartsResponse {
    /**
     * @generated from protobuf field: repeated viam.app.v1.RobotPart parts = 1;
     */
    parts: RobotPart[];
}
/**
 * @generated from protobuf message viam.app.v1.GetRobotPartRequest
 */
export interface GetRobotPartRequest {
    /**
     * @generated from protobuf field: string id = 1;
     */
    id: string;
}
/**
 * @generated from protobuf message viam.app.v1.GetRobotPartResponse
 */
export interface GetRobotPartResponse {
    /**
     * @generated from protobuf field: viam.app.v1.RobotPart part = 1;
     */
    part?: RobotPart;
    /**
     * @generated from protobuf field: string config_json = 2;
     */
    configJson: string;
}
/**
 * @generated from protobuf message viam.app.v1.GetRobotPartByNameAndLocationRequest
 */
export interface GetRobotPartByNameAndLocationRequest {
    /**
     * @generated from protobuf field: string name = 1;
     */
    name: string;
    /**
     * @generated from protobuf field: string location_id = 2;
     */
    locationId: string;
}
/**
 * @generated from protobuf message viam.app.v1.GetRobotPartByNameAndLocationResponse
 */
export interface GetRobotPartByNameAndLocationResponse {
    /**
     * @generated from protobuf field: viam.app.v1.RobotPart part = 1;
     */
    part?: RobotPart;
}
/**
 * @generated from protobuf message viam.app.v1.GetRobotPartLogsRequest
 */
export interface GetRobotPartLogsRequest {
    /**
     * @generated from protobuf field: string id = 1;
     */
    id: string;
    /**
     * TODO(https://viam.atlassian.net/browse/APP-3877): Remove this field
     *
     * @deprecated
     * @generated from protobuf field: bool errors_only = 2 [deprecated = true];
     */
    errorsOnly: boolean;
    /**
     * @generated from protobuf field: optional string filter = 3;
     */
    filter?: string;
    /**
     * @generated from protobuf field: optional string page_token = 4;
     */
    pageToken?: string;
    /**
     * logs of all levels are returned when the levels field is empty
     *
     * @generated from protobuf field: repeated string levels = 5;
     */
    levels: string[];
    /**
     * @generated from protobuf field: optional google.protobuf.Timestamp start = 6;
     */
    start?: Timestamp;
    /**
     * @generated from protobuf field: optional google.protobuf.Timestamp end = 7;
     */
    end?: Timestamp;
    /**
     * @generated from protobuf field: optional int64 limit = 8;
     */
    limit?: string;
    /**
     * @generated from protobuf field: optional string source = 9;
     */
    source?: string;
    /**
     * @generated from protobuf field: optional bool user_facing_only = 10;
     */
    userFacingOnly?: boolean;
    /**
     * logs are returned newest first when the order field is empty
     *
     * @generated from protobuf field: optional viam.app.v1.LogOrder order = 11;
     */
    order?: LogOrder;
    /**
     * range is a duration string in minutes, hours, or days (e.g. "10m", "10h", "10d")
     * that is resolved against whichever of start and end is present:
     *   end only:     [end - range, end]
     *   start only:   [start, start + range]
     *   neither:      [now - range, now]
     * Specifying range together with both start and end is an error.
     *
     * @generated from protobuf field: optional string range = 12;
     */
    range?: string;
}
/**
 * @generated from protobuf message viam.app.v1.GetRobotPartLogsResponse
 */
export interface GetRobotPartLogsResponse {
    /**
     * @generated from protobuf field: repeated viam.common.v1.LogEntry logs = 1;
     */
    logs: LogEntry[];
    /**
     * @generated from protobuf field: string next_page_token = 2;
     */
    nextPageToken: string;
}
/**
 * @generated from protobuf message viam.app.v1.TailRobotPartLogsRequest
 */
export interface TailRobotPartLogsRequest {
    /**
     * @generated from protobuf field: string id = 1;
     */
    id: string;
    /**
     * @generated from protobuf field: bool errors_only = 2;
     */
    errorsOnly: boolean;
    /**
     * @generated from protobuf field: optional string filter = 3;
     */
    filter?: string;
}
/**
 * @generated from protobuf message viam.app.v1.TailRobotPartLogsResponse
 */
export interface TailRobotPartLogsResponse {
    /**
     * @generated from protobuf field: repeated viam.common.v1.LogEntry logs = 1;
     */
    logs: LogEntry[];
}
/**
 * @generated from protobuf message viam.app.v1.GetRobotPartHistoryRequest
 */
export interface GetRobotPartHistoryRequest {
    /**
     * @generated from protobuf field: string id = 1;
     */
    id: string;
    /**
     * @generated from protobuf field: optional string page_token = 2;
     */
    pageToken?: string;
    /**
     * @generated from protobuf field: optional int64 page_limit = 3;
     */
    pageLimit?: string;
    /**
     * @generated from protobuf field: optional google.protobuf.Timestamp start = 4;
     */
    start?: Timestamp;
    /**
     * @generated from protobuf field: optional google.protobuf.Timestamp end = 5;
     */
    end?: Timestamp;
}
/**
 * @generated from protobuf message viam.app.v1.GetRobotPartHistoryResponse
 */
export interface GetRobotPartHistoryResponse {
    /**
     * @generated from protobuf field: repeated viam.app.v1.RobotPartHistoryEntry history = 1;
     */
    history: RobotPartHistoryEntry[];
    /**
     * @generated from protobuf field: string next_page_token = 2;
     */
    nextPageToken: string;
}
/**
 * @generated from protobuf message viam.app.v1.UpdateRobotPartRequest
 */
export interface UpdateRobotPartRequest {
    /**
     * @generated from protobuf field: string id = 1;
     */
    id: string;
    /**
     * @generated from protobuf field: string name = 2;
     */
    name: string;
    /**
     * @generated from protobuf field: google.protobuf.Struct robot_config = 3;
     */
    robotConfig?: Struct;
    /**
     * @generated from protobuf field: optional google.protobuf.Timestamp last_known_update = 4;
     */
    lastKnownUpdate?: Timestamp;
    /**
     * robot_config_json is the raw JSON string of the robot config, preserving user-defined key order.
     * When set, this takes precedence over robot_config for storage purposes.
     *
     * @generated from protobuf field: optional string robot_config_json = 5;
     */
    robotConfigJson?: string;
}
/**
 * @generated from protobuf message viam.app.v1.UpdateRobotPartResponse
 */
export interface UpdateRobotPartResponse {
    /**
     * @generated from protobuf field: viam.app.v1.RobotPart part = 1;
     */
    part?: RobotPart;
}
/**
 * @generated from protobuf message viam.app.v1.ConfigPropertyChange
 */
export interface ConfigPropertyChange {
    /**
     * @generated from protobuf field: string path = 1;
     */
    path: string;
    /**
     * @generated from protobuf field: google.protobuf.Value value = 2;
     */
    value?: Value;
}
/**
 * @generated from protobuf message viam.app.v1.SetConfigPropertyRequest
 */
export interface SetConfigPropertyRequest {
    /**
     * @generated from protobuf field: string robot_part_id = 1;
     */
    robotPartId: string;
    /**
     * @generated from protobuf field: repeated viam.app.v1.ConfigPropertyChange property_changes = 2;
     */
    propertyChanges: ConfigPropertyChange[];
}
/**
 * @generated from protobuf message viam.app.v1.ConfigPropertyChangeResult
 */
export interface ConfigPropertyChangeResult {
    /**
     * @generated from protobuf field: string path = 1;
     */
    path: string;
    /**
     * @generated from protobuf field: google.protobuf.Value value = 2;
     */
    value?: Value;
    /**
     * @generated from protobuf field: bool success = 3;
     */
    success: boolean;
    /**
     * @generated from protobuf field: string error = 4;
     */
    error: string;
}
/**
 * @generated from protobuf message viam.app.v1.SetConfigPropertyResponse
 */
export interface SetConfigPropertyResponse {
    /**
     * @generated from protobuf field: repeated viam.app.v1.ConfigPropertyChangeResult property_changes = 1;
     */
    propertyChanges: ConfigPropertyChangeResult[];
}
/**
 * @generated from protobuf message viam.app.v1.NewRobotPartRequest
 */
export interface NewRobotPartRequest {
    /**
     * @generated from protobuf field: string robot_id = 1;
     */
    robotId: string;
    /**
     * @generated from protobuf field: string part_name = 2;
     */
    partName: string;
}
/**
 * @generated from protobuf message viam.app.v1.NewRobotPartResponse
 */
export interface NewRobotPartResponse {
    /**
     * @generated from protobuf field: string part_id = 1;
     */
    partId: string;
}
/**
 * @generated from protobuf message viam.app.v1.DeleteRobotPartRequest
 */
export interface DeleteRobotPartRequest {
    /**
     * @generated from protobuf field: string part_id = 1;
     */
    partId: string;
}
/**
 * @generated from protobuf message viam.app.v1.GetRobotPartMetadataRequest
 */
export interface GetRobotPartMetadataRequest {
    /**
     * @generated from protobuf field: string id = 1;
     */
    id: string;
}
/**
 * @generated from protobuf message viam.app.v1.GetRobotPartMetadataResponse
 */
export interface GetRobotPartMetadataResponse {
    /**
     * @generated from protobuf field: google.protobuf.Struct data = 1;
     */
    data?: Struct;
}
/**
 * @generated from protobuf message viam.app.v1.UpdateRobotPartMetadataRequest
 */
export interface UpdateRobotPartMetadataRequest {
    /**
     * @generated from protobuf field: string id = 1;
     */
    id: string;
    /**
     * @generated from protobuf field: google.protobuf.Struct data = 2;
     */
    data?: Struct;
}
/**
 * @generated from protobuf message viam.app.v1.UpdateRobotPartMetadataResponse
 */
export interface UpdateRobotPartMetadataResponse {
}
/**
 * @generated from protobuf message viam.app.v1.GetRobotAPIKeysRequest
 */
export interface GetRobotAPIKeysRequest {
    /**
     * @generated from protobuf field: string robot_id = 1;
     */
    robotId: string;
}
/**
 * @generated from protobuf message viam.app.v1.APIKey
 */
export interface APIKey {
    /**
     * @generated from protobuf field: string id = 1;
     */
    id: string;
    /**
     * @generated from protobuf field: string key = 2;
     */
    key: string;
    /**
     * @generated from protobuf field: string name = 3;
     */
    name: string;
    /**
     * @generated from protobuf field: google.protobuf.Timestamp created_on = 4;
     */
    createdOn?: Timestamp;
}
/**
 * @generated from protobuf message viam.app.v1.GetRobotAPIKeysResponse
 */
export interface GetRobotAPIKeysResponse {
    /**
     * @generated from protobuf field: repeated viam.app.v1.APIKeyWithAuthorizations api_keys = 1;
     */
    apiKeys: APIKeyWithAuthorizations[];
}
/**
 * @generated from protobuf message viam.app.v1.DeleteRobotPartResponse
 */
export interface DeleteRobotPartResponse {
}
/**
 * @generated from protobuf message viam.app.v1.Fragment
 */
export interface Fragment {
    /**
     * @generated from protobuf field: string id = 1;
     */
    id: string;
    /**
     * @generated from protobuf field: string name = 2;
     */
    name: string;
    /**
     * @generated from protobuf field: google.protobuf.Struct fragment = 3;
     */
    fragment?: Struct;
    /**
     * @generated from protobuf field: string organization_owner = 4;
     */
    organizationOwner: string;
    /**
     * @generated from protobuf field: bool public = 5;
     */
    public: boolean;
    /**
     * @generated from protobuf field: google.protobuf.Timestamp created_on = 6;
     */
    createdOn?: Timestamp;
    /**
     * @generated from protobuf field: string organization_name = 7;
     */
    organizationName: string;
    /**
     * number of robot parts using this fragment
     *
     * @generated from protobuf field: int32 robot_part_count = 9;
     */
    robotPartCount: number;
    /**
     * number of organizations using this fragment
     *
     * @generated from protobuf field: int32 organization_count = 10;
     */
    organizationCount: number;
    /**
     * whether the organization(s) using this fragment is the same as the fragment org
     *
     * @generated from protobuf field: bool only_used_by_owner = 11;
     */
    onlyUsedByOwner: boolean;
    /**
     * the visibility of a fragment; public, private or unlisted
     *
     * @generated from protobuf field: viam.app.v1.FragmentVisibility visibility = 12;
     */
    visibility: FragmentVisibility;
    /**
     * latest timestamp when fragment was updated
     *
     * @generated from protobuf field: google.protobuf.Timestamp last_updated = 13;
     */
    lastUpdated?: Timestamp;
    /**
     * @generated from protobuf field: string revision = 14;
     */
    revision: string;
    /**
     * @generated from protobuf field: optional string public_namespace = 15;
     */
    publicNamespace?: string;
    /**
     * Fragment config JSON, preserving key order.
     *
     * @generated from protobuf field: optional string fragment_config_json = 16;
     */
    fragmentConfigJson?: string;
}
/**
 * @generated from protobuf message viam.app.v1.FragmentHistoryEntry
 */
export interface FragmentHistoryEntry {
    /**
     * @generated from protobuf field: string fragment = 1;
     */
    fragment: string;
    /**
     * @generated from protobuf field: google.protobuf.Timestamp edited_on = 2;
     */
    editedOn?: Timestamp;
    /**
     * @generated from protobuf field: viam.app.v1.Fragment old = 3;
     */
    old?: Fragment;
    /**
     * @generated from protobuf field: viam.app.v1.AuthenticatorInfo edited_by = 4;
     */
    editedBy?: AuthenticatorInfo;
    /**
     * @generated from protobuf field: string revision = 5;
     */
    revision: string;
    /**
     * @generated from protobuf field: google.protobuf.Struct config = 6;
     */
    config?: Struct;
}
/**
 * @generated from protobuf message viam.app.v1.FragmentRevision
 */
export interface FragmentRevision {
    /**
     * @generated from protobuf field: string revision = 1;
     */
    revision: string;
    /**
     * @generated from protobuf field: google.protobuf.Timestamp created_at = 2;
     */
    createdAt?: Timestamp;
}
/**
 * @generated from protobuf message viam.app.v1.FragmentTag
 */
export interface FragmentTag {
    /**
     * @generated from protobuf field: string tag = 1;
     */
    tag: string;
    /**
     * @generated from protobuf field: string revision = 2;
     */
    revision: string;
}
/**
 * @generated from protobuf message viam.app.v1.FragmentError
 */
export interface FragmentError {
    /**
     * @generated from protobuf field: viam.app.v1.FragmentErrorType error_type = 1;
     */
    errorType: FragmentErrorType;
    /**
     * @generated from protobuf field: string fragment_id = 2;
     */
    fragmentId: string;
    /**
     * @generated from protobuf field: string detail = 3;
     */
    detail: string;
}
/**
 * Cached fragment usage statistics
 *
 * @generated from protobuf message viam.app.v1.FragmentUsage
 */
export interface FragmentUsage {
    /**
     * @generated from protobuf field: string fragment_id = 1;
     */
    fragmentId: string;
    /**
     * @generated from protobuf field: int32 organizations = 2;
     */
    organizations: number;
    /**
     * @generated from protobuf field: int32 machines = 3;
     */
    machines: number;
    /**
     * @generated from protobuf field: int32 machines_in_current_org = 4;
     */
    machinesInCurrentOrg: number;
    /**
     * @generated from protobuf field: optional string version = 5;
     */
    version?: string; // revision or tag
}
/**
 * @generated from protobuf message viam.app.v1.FragmentImport
 */
export interface FragmentImport {
    /**
     * @generated from protobuf field: string fragment_id = 1;
     */
    fragmentId: string;
    /**
     * @generated from protobuf field: string version = 2;
     */
    version: string; // revision or tag
    /**
     * @generated from protobuf field: optional string prefix = 3;
     */
    prefix?: string; // namespace prefix
    /**
     * Deprecated: use fragment_variables
     *
     * @deprecated
     * @generated from protobuf field: map<string, string> variables = 4 [deprecated = true];
     */
    variables: {
        [key: string]: string;
    }; // key-value pairs for fragment variables
    /**
     * @generated from protobuf field: optional google.protobuf.Struct fragment_variables = 5;
     */
    fragmentVariables?: Struct;
}
/**
 * @generated from protobuf message viam.app.v1.ResolvedFragment
 */
export interface ResolvedFragment {
    /**
     * @generated from protobuf field: string fragment_id = 1;
     */
    fragmentId: string;
    /**
     * @generated from protobuf field: google.protobuf.Struct resolved_config = 2;
     */
    resolvedConfig?: Struct;
    /**
     * @generated from protobuf field: viam.app.v1.FragmentError error = 3;
     */
    error?: FragmentError;
    /**
     * @generated from protobuf field: string revision = 4;
     */
    revision: string;
}
/**
 * @generated from protobuf message viam.app.v1.ListFragmentsRequest
 */
export interface ListFragmentsRequest {
    /**
     * @generated from protobuf field: string organization_id = 1;
     */
    organizationId: string;
    /**
     * @generated from protobuf field: bool show_public = 2;
     */
    showPublic: boolean;
    /**
     * @generated from protobuf field: repeated viam.app.v1.FragmentVisibility fragment_visibility = 3;
     */
    fragmentVisibility: FragmentVisibility[];
}
/**
 * @generated from protobuf message viam.app.v1.ListFragmentsResponse
 */
export interface ListFragmentsResponse {
    /**
     * @generated from protobuf field: repeated viam.app.v1.Fragment fragments = 1;
     */
    fragments: Fragment[];
    /**
     * @generated from protobuf field: repeated viam.app.v1.FragmentUsage fragment_usages = 2;
     */
    fragmentUsages: FragmentUsage[];
}
/**
 * @generated from protobuf message viam.app.v1.GetFragmentRequest
 */
export interface GetFragmentRequest {
    /**
     * @generated from protobuf field: string id = 1;
     */
    id: string;
    /**
     * @generated from protobuf field: string current_organization_id = 2;
     */
    currentOrganizationId: string;
    /**
     * @generated from protobuf field: optional string version = 3;
     */
    version?: string; // revision or tag
}
/**
 * @generated from protobuf message viam.app.v1.GetFragmentResponse
 */
export interface GetFragmentResponse {
    /**
     * @generated from protobuf field: viam.app.v1.Fragment fragment = 1;
     */
    fragment?: Fragment;
    /**
     * @generated from protobuf field: viam.app.v1.FragmentUsage fragment_usage = 2;
     */
    fragmentUsage?: FragmentUsage;
    /**
     * @generated from protobuf field: repeated viam.app.v1.FragmentRevision revisions = 3;
     */
    revisions: FragmentRevision[];
    /**
     * @generated from protobuf field: repeated viam.app.v1.FragmentTag tags = 4;
     */
    tags: FragmentTag[];
}
/**
 * @generated from protobuf message viam.app.v1.CreateFragmentRequest
 */
export interface CreateFragmentRequest {
    /**
     * @generated from protobuf field: string name = 1;
     */
    name: string;
    /**
     * @generated from protobuf field: google.protobuf.Struct config = 2;
     */
    config?: Struct;
    /**
     * @generated from protobuf field: string organization_id = 3;
     */
    organizationId: string;
    /**
     * @generated from protobuf field: optional viam.app.v1.FragmentVisibility visibility = 4;
     */
    visibility?: FragmentVisibility;
}
/**
 * @generated from protobuf message viam.app.v1.CreateFragmentResponse
 */
export interface CreateFragmentResponse {
    /**
     * @generated from protobuf field: viam.app.v1.Fragment fragment = 1;
     */
    fragment?: Fragment;
}
/**
 * @generated from protobuf message viam.app.v1.UpdateFragmentRequest
 */
export interface UpdateFragmentRequest {
    /**
     * @generated from protobuf field: string id = 1;
     */
    id: string;
    /**
     * @generated from protobuf field: string name = 2;
     */
    name: string;
    /**
     * @generated from protobuf field: google.protobuf.Struct config = 3;
     */
    config?: Struct;
    /**
     * @generated from protobuf field: optional bool public = 4;
     */
    public?: boolean;
    /**
     * @generated from protobuf field: optional viam.app.v1.FragmentVisibility visibility = 5;
     */
    visibility?: FragmentVisibility;
    /**
     * @generated from protobuf field: optional google.protobuf.Timestamp last_known_update = 6;
     */
    lastKnownUpdate?: Timestamp;
    /**
     * Fragment config JSON, preserving key order. Takes precedence over config.
     *
     * @generated from protobuf field: optional string fragment_config_json = 7;
     */
    fragmentConfigJson?: string;
}
/**
 * @generated from protobuf message viam.app.v1.UpdateFragmentResponse
 */
export interface UpdateFragmentResponse {
    /**
     * @generated from protobuf field: viam.app.v1.Fragment fragment = 1;
     */
    fragment?: Fragment;
}
/**
 * @generated from protobuf message viam.app.v1.DeleteFragmentRequest
 */
export interface DeleteFragmentRequest {
    /**
     * @generated from protobuf field: string id = 1;
     */
    id: string;
}
/**
 * @generated from protobuf message viam.app.v1.DeleteFragmentResponse
 */
export interface DeleteFragmentResponse {
}
/**
 * @generated from protobuf message viam.app.v1.GetFragmentHistoryRequest
 */
export interface GetFragmentHistoryRequest {
    /**
     * @generated from protobuf field: string id = 1;
     */
    id: string;
    /**
     * @generated from protobuf field: optional string page_token = 2;
     */
    pageToken?: string;
    /**
     * @generated from protobuf field: optional int64 page_limit = 3;
     */
    pageLimit?: string;
}
/**
 * @generated from protobuf message viam.app.v1.GetFragmentHistoryResponse
 */
export interface GetFragmentHistoryResponse {
    /**
     * @generated from protobuf field: repeated viam.app.v1.FragmentHistoryEntry history = 1;
     */
    history: FragmentHistoryEntry[];
    /**
     * @generated from protobuf field: string next_page_token = 2;
     */
    nextPageToken: string;
}
/**
 * @generated from protobuf message viam.app.v1.GetFragmentUsageRequest
 */
export interface GetFragmentUsageRequest {
    /**
     * @generated from protobuf field: string fragment_id = 1;
     */
    fragmentId: string;
}
/**
 * @generated from protobuf message viam.app.v1.GetFragmentUsageResponse
 */
export interface GetFragmentUsageResponse {
    /**
     * @generated from protobuf field: repeated viam.app.v1.FragmentUsage version_usages = 1;
     */
    versionUsages: FragmentUsage[];
}
/**
 * @generated from protobuf message viam.app.v1.SetFragmentTagRequest
 */
export interface SetFragmentTagRequest {
    /**
     * @generated from protobuf field: string fragment_id = 1;
     */
    fragmentId: string;
    /**
     * @generated from protobuf field: string tag = 2;
     */
    tag: string;
    /**
     * @generated from protobuf field: string revision = 3;
     */
    revision: string;
}
/**
 * @generated from protobuf message viam.app.v1.SetFragmentTagResponse
 */
export interface SetFragmentTagResponse {
    /**
     * @generated from protobuf field: repeated viam.app.v1.FragmentTag tags = 1;
     */
    tags: FragmentTag[];
}
/**
 * @generated from protobuf message viam.app.v1.DeleteFragmentTagRequest
 */
export interface DeleteFragmentTagRequest {
    /**
     * @generated from protobuf field: string fragment_id = 1;
     */
    fragmentId: string;
    /**
     * @generated from protobuf field: string tag = 2;
     */
    tag: string;
}
/**
 * @generated from protobuf message viam.app.v1.DeleteFragmentTagResponse
 */
export interface DeleteFragmentTagResponse {
    /**
     * @generated from protobuf field: repeated viam.app.v1.FragmentTag tags = 1;
     */
    tags: FragmentTag[];
}
/**
 * @generated from protobuf message viam.app.v1.ListRobotsRequest
 */
export interface ListRobotsRequest {
    /**
     * @generated from protobuf field: string location_id = 1;
     */
    locationId: string;
}
/**
 * @generated from protobuf message viam.app.v1.ListRobotsForLocationsRequest
 */
export interface ListRobotsForLocationsRequest {
    /**
     * @generated from protobuf field: repeated string location_ids = 1;
     */
    locationIds: string[];
}
/**
 * @generated from protobuf message viam.app.v1.ListRobotsForOrgRequest
 */
export interface ListRobotsForOrgRequest {
    /**
     * @generated from protobuf field: string org_id = 1;
     */
    orgId: string;
}
/**
 * @generated from protobuf message viam.app.v1.AdditionalFragment
 */
export interface AdditionalFragment {
    /**
     * @generated from protobuf field: string fragment_id = 1;
     */
    fragmentId: string;
    /**
     * @generated from protobuf field: optional string version = 2;
     */
    version?: string;
}
/**
 * @generated from protobuf message viam.app.v1.ListNestedFragmentsRequest
 */
export interface ListNestedFragmentsRequest {
    /**
     * @generated from protobuf field: optional string fragment_id = 1;
     */
    fragmentId?: string;
    /**
     * @generated from protobuf field: repeated viam.app.v1.AdditionalFragment additional_fragments = 2;
     */
    additionalFragments: AdditionalFragment[];
}
/**
 * @generated from protobuf message viam.app.v1.ListNestedFragmentsResponse
 */
export interface ListNestedFragmentsResponse {
    /**
     * @generated from protobuf field: repeated viam.app.v1.Fragment fragments = 1;
     */
    fragments: Fragment[];
    /**
     * @generated from protobuf field: repeated viam.app.v1.ResolvedFragment resolved_fragments = 2;
     */
    resolvedFragments: ResolvedFragment[];
}
/**
 * @generated from protobuf message viam.app.v1.ListMachineFragmentsRequest
 */
export interface ListMachineFragmentsRequest {
    /**
     * the machine_id used to filter fragments defined in a machine's parts.
     * Also returns any fragments nested within the fragments defined in parts.
     *
     * @generated from protobuf field: string machine_id = 1;
     */
    machineId: string;
    /**
     * TODO(APP-7642): Mark this field as deprecated
     *
     * @generated from protobuf field: repeated string additional_fragment_ids = 2;
     */
    additionalFragmentIds: string[];
    /**
     * additional fragments to append to the response. useful when needing to view fragments that will be
     * provisionally added to the machine alongside existing fragments.
     *
     * @generated from protobuf field: repeated viam.app.v1.AdditionalFragment additional_fragments = 3;
     */
    additionalFragments: AdditionalFragment[];
}
/**
 * @generated from protobuf message viam.app.v1.ListMachineFragmentsResponse
 */
export interface ListMachineFragmentsResponse {
    /**
     * @generated from protobuf field: repeated viam.app.v1.Fragment fragments = 1;
     */
    fragments: Fragment[];
    /**
     * @generated from protobuf field: repeated viam.app.v1.ResolvedFragment resolved_fragments = 2;
     */
    resolvedFragments: ResolvedFragment[];
}
/**
 * @generated from protobuf message viam.app.v1.ListMachineSummariesRequest
 */
export interface ListMachineSummariesRequest {
    /**
     * Optional organization ID. If no value is set it will search among all the organanizations the caller has access to
     *
     * @generated from protobuf field: string organization_id = 1;
     */
    organizationId: string;
    /**
     * Optional list of fragment IDs to filter machines that use any of these fragments
     *
     * @generated from protobuf field: repeated string fragment_ids = 2;
     */
    fragmentIds: string[];
    /**
     * Optional list of location IDs to filter machines that are in any of these locations.
     *
     * @generated from protobuf field: repeated string location_ids = 3;
     */
    locationIds: string[];
    /**
     * Optional max number of machines to return; default to 100 if unset
     *
     * @generated from protobuf field: optional int32 limit = 4;
     */
    limit?: number;
}
/**
 * @generated from protobuf message viam.app.v1.ListMachineSummariesResponse
 */
export interface ListMachineSummariesResponse {
    /**
     * @generated from protobuf field: repeated viam.app.v1.LocationSummary location_summaries = 1;
     */
    locationSummaries: LocationSummary[];
}
/**
 * @generated from protobuf message viam.app.v1.LocationSummary
 */
export interface LocationSummary {
    /**
     * @generated from protobuf field: string location_id = 1;
     */
    locationId: string;
    /**
     * @generated from protobuf field: string location_name = 2;
     */
    locationName: string;
    /**
     * @generated from protobuf field: repeated viam.app.v1.MachineSummary machine_summaries = 3;
     */
    machineSummaries: MachineSummary[];
}
/**
 * @generated from protobuf message viam.app.v1.MachineSummary
 */
export interface MachineSummary {
    /**
     * @generated from protobuf field: string machine_id = 1;
     */
    machineId: string;
    /**
     * @generated from protobuf field: string machine_name = 2;
     */
    machineName: string;
    /**
     * @generated from protobuf field: repeated viam.app.v1.PartSummary part_summaries = 3;
     */
    partSummaries: PartSummary[];
}
/**
 * @generated from protobuf message viam.app.v1.FragmentSummary
 */
export interface FragmentSummary {
    /**
     * @generated from protobuf field: string id = 1;
     */
    id: string;
    /**
     * @generated from protobuf field: string name = 3;
     */
    name: string;
}
/**
 * @generated from protobuf message viam.app.v1.ViamServerVersion
 */
export interface ViamServerVersion {
    /**
     * @generated from protobuf oneof: version
     */
    version: {
        oneofKind: "major";
        /**
         * @generated from protobuf field: string major = 1;
         */
        major: string;
    } | {
        oneofKind: "minor";
        /**
         * @generated from protobuf field: string minor = 2;
         */
        minor: string;
    } | {
        oneofKind: undefined;
    };
}
/**
 * @generated from protobuf message viam.app.v1.ViamAgentVersion
 */
export interface ViamAgentVersion {
    /**
     * @generated from protobuf oneof: version
     */
    version: {
        oneofKind: "major";
        /**
         * @generated from protobuf field: string major = 1;
         */
        major: string;
    } | {
        oneofKind: "minor";
        /**
         * @generated from protobuf field: string minor = 2;
         */
        minor: string;
    } | {
        oneofKind: undefined;
    };
}
/**
 * @generated from protobuf message viam.app.v1.PartSummary
 */
export interface PartSummary {
    /**
     * @generated from protobuf field: string part_id = 1;
     */
    partId: string;
    /**
     * @generated from protobuf field: string part_name = 2;
     */
    partName: string;
    /**
     * @generated from protobuf field: bool is_main_part = 11;
     */
    isMainPart: boolean;
    /**
     * @generated from protobuf field: viam.app.v1.OnlineState online_state = 12;
     */
    onlineState: OnlineState;
    /**
     * @generated from protobuf field: int64 seconds_since_online = 13;
     */
    secondsSinceOnline: string;
    /**
     * @generated from protobuf field: optional google.protobuf.Timestamp last_access = 14;
     */
    lastAccess?: Timestamp;
    /**
     * @generated from protobuf field: optional google.protobuf.Timestamp last_online = 3;
     */
    lastOnline?: Timestamp;
    /**
     * @generated from protobuf field: optional viam.app.v1.ViamServerVersion viam_server_version = 4;
     */
    viamServerVersion?: ViamServerVersion;
    /**
     * @generated from protobuf field: optional viam.app.v1.ViamAgentVersion viam_agent_version = 5;
     */
    viamAgentVersion?: ViamAgentVersion;
    /**
     * @generated from protobuf field: optional string os = 6;
     */
    os?: string;
    /**
     * @generated from protobuf field: optional string platform = 7;
     */
    platform?: string;
    /**
     * @generated from protobuf field: optional string public_ip_address = 8;
     */
    publicIpAddress?: string;
    /**
     * @generated from protobuf field: optional string dns_name = 10;
     */
    dnsName?: string;
    /**
     * @generated from protobuf field: repeated viam.app.v1.FragmentSummary fragments = 9;
     */
    fragments: FragmentSummary[];
}
/**
 * @generated from protobuf message viam.app.v1.ListRobotsResponse
 */
export interface ListRobotsResponse {
    /**
     * @generated from protobuf field: repeated viam.app.v1.Robot robots = 1;
     */
    robots: Robot[];
}
/**
 * @generated from protobuf message viam.app.v1.ListRobotsForLocationsResponse
 */
export interface ListRobotsForLocationsResponse {
    /**
     * @generated from protobuf field: repeated viam.app.v1.Robot robots = 1;
     */
    robots: Robot[];
}
/**
 * @generated from protobuf message viam.app.v1.ListRobotsForOrgResponse
 */
export interface ListRobotsForOrgResponse {
    /**
     * @generated from protobuf field: repeated viam.app.v1.Robot robots = 1;
     */
    robots: Robot[];
}
/**
 * @generated from protobuf message viam.app.v1.NewRobotRequest
 */
export interface NewRobotRequest {
    /**
     * @generated from protobuf field: string name = 1;
     */
    name: string;
    /**
     * @generated from protobuf field: string location = 2;
     */
    location: string;
}
/**
 * @generated from protobuf message viam.app.v1.NewRobotResponse
 */
export interface NewRobotResponse {
    /**
     * @generated from protobuf field: string id = 1;
     */
    id: string;
}
/**
 * @generated from protobuf message viam.app.v1.UpdateRobotRequest
 */
export interface UpdateRobotRequest {
    /**
     * @generated from protobuf field: string id = 1;
     */
    id: string;
    /**
     * @generated from protobuf field: string name = 2;
     */
    name: string;
    /**
     * @generated from protobuf field: string location = 3;
     */
    location: string;
}
/**
 * @generated from protobuf message viam.app.v1.UpdateRobotResponse
 */
export interface UpdateRobotResponse {
    /**
     * @generated from protobuf field: viam.app.v1.Robot robot = 1;
     */
    robot?: Robot;
}
/**
 * @generated from protobuf message viam.app.v1.DeleteRobotRequest
 */
export interface DeleteRobotRequest {
    /**
     * @generated from protobuf field: string id = 1;
     */
    id: string;
}
/**
 * @generated from protobuf message viam.app.v1.DeleteRobotResponse
 */
export interface DeleteRobotResponse {
}
/**
 * @generated from protobuf message viam.app.v1.FavoriteMachine
 */
export interface FavoriteMachine {
    /**
     * @generated from protobuf field: viam.app.v1.Robot machine = 1;
     */
    machine?: Robot;
    /**
     * @generated from protobuf field: string organization_id = 2;
     */
    organizationId: string;
    /**
     * @generated from protobuf field: google.protobuf.Timestamp created_on = 3;
     */
    createdOn?: Timestamp;
}
/**
 * @generated from protobuf message viam.app.v1.AddFavoriteMachineRequest
 */
export interface AddFavoriteMachineRequest {
    /**
     * @generated from protobuf field: string machine_id = 1;
     */
    machineId: string;
}
/**
 * @generated from protobuf message viam.app.v1.AddFavoriteMachineResponse
 */
export interface AddFavoriteMachineResponse {
}
/**
 * @generated from protobuf message viam.app.v1.RemoveFavoriteMachineRequest
 */
export interface RemoveFavoriteMachineRequest {
    /**
     * @generated from protobuf field: string machine_id = 1;
     */
    machineId: string;
}
/**
 * @generated from protobuf message viam.app.v1.RemoveFavoriteMachineResponse
 */
export interface RemoveFavoriteMachineResponse {
}
/**
 * @generated from protobuf message viam.app.v1.ListFavoriteMachinesRequest
 */
export interface ListFavoriteMachinesRequest {
}
/**
 * @generated from protobuf message viam.app.v1.ListFavoriteMachinesResponse
 */
export interface ListFavoriteMachinesResponse {
    /**
     * @generated from protobuf field: repeated viam.app.v1.FavoriteMachine favorites = 1;
     */
    favorites: FavoriteMachine[];
}
/**
 * @generated from protobuf message viam.app.v1.GetRobotMetadataRequest
 */
export interface GetRobotMetadataRequest {
    /**
     * @generated from protobuf field: string id = 1;
     */
    id: string;
}
/**
 * @generated from protobuf message viam.app.v1.GetRobotMetadataResponse
 */
export interface GetRobotMetadataResponse {
    /**
     * @generated from protobuf field: google.protobuf.Struct data = 1;
     */
    data?: Struct;
}
/**
 * @generated from protobuf message viam.app.v1.UpdateRobotMetadataRequest
 */
export interface UpdateRobotMetadataRequest {
    /**
     * @generated from protobuf field: string id = 1;
     */
    id: string;
    /**
     * @generated from protobuf field: google.protobuf.Struct data = 2;
     */
    data?: Struct;
}
/**
 * @generated from protobuf message viam.app.v1.UpdateRobotMetadataResponse
 */
export interface UpdateRobotMetadataResponse {
}
/**
 * @generated from protobuf message viam.app.v1.MarkPartAsMainRequest
 */
export interface MarkPartAsMainRequest {
    /**
     * @generated from protobuf field: string part_id = 1;
     */
    partId: string;
}
/**
 * @generated from protobuf message viam.app.v1.MarkPartAsMainResponse
 */
export interface MarkPartAsMainResponse {
}
/**
 * @generated from protobuf message viam.app.v1.MarkPartForRestartRequest
 */
export interface MarkPartForRestartRequest {
    /**
     * @generated from protobuf field: string part_id = 1;
     */
    partId: string;
}
/**
 * @generated from protobuf message viam.app.v1.MarkPartForRestartResponse
 */
export interface MarkPartForRestartResponse {
}
/**
 * @generated from protobuf message viam.app.v1.CreateRobotPartSecretRequest
 */
export interface CreateRobotPartSecretRequest {
    /**
     * Robot Part ID to create the secret in.
     *
     * @generated from protobuf field: string part_id = 1;
     */
    partId: string;
}
/**
 * @generated from protobuf message viam.app.v1.CreateRobotPartSecretResponse
 */
export interface CreateRobotPartSecretResponse {
    /**
     * Location's auth after updates.
     *
     * @generated from protobuf field: viam.app.v1.RobotPart part = 1;
     */
    part?: RobotPart;
}
/**
 * @generated from protobuf message viam.app.v1.DeleteRobotPartSecretRequest
 */
export interface DeleteRobotPartSecretRequest {
    /**
     * @generated from protobuf field: string part_id = 1;
     */
    partId: string;
    /**
     * @generated from protobuf field: string secret_id = 2;
     */
    secretId: string;
}
/**
 * @generated from protobuf message viam.app.v1.DeleteRobotPartSecretResponse
 */
export interface DeleteRobotPartSecretResponse {
}
/**
 * @generated from protobuf message viam.app.v1.Authorization
 */
export interface Authorization {
    /**
     * @generated from protobuf field: string authorization_type = 1;
     */
    authorizationType: string;
    /**
     * @generated from protobuf field: string authorization_id = 2;
     */
    authorizationId: string;
    /**
     * @generated from protobuf field: string resource_type = 3;
     */
    resourceType: string;
    /**
     * @generated from protobuf field: string resource_id = 4;
     */
    resourceId: string;
    /**
     * @generated from protobuf field: string identity_id = 5;
     */
    identityId: string;
    /**
     * @generated from protobuf field: string organization_id = 6;
     */
    organizationId: string;
    /**
     * @generated from protobuf field: string identity_type = 7;
     */
    identityType: string;
}
/**
 * @generated from protobuf message viam.app.v1.AddRoleRequest
 */
export interface AddRoleRequest {
    /**
     * @generated from protobuf field: viam.app.v1.Authorization authorization = 1;
     */
    authorization?: Authorization;
}
/**
 * @generated from protobuf message viam.app.v1.AddRoleResponse
 */
export interface AddRoleResponse {
}
/**
 * @generated from protobuf message viam.app.v1.RemoveRoleRequest
 */
export interface RemoveRoleRequest {
    /**
     * @generated from protobuf field: viam.app.v1.Authorization authorization = 1;
     */
    authorization?: Authorization;
}
/**
 * @generated from protobuf message viam.app.v1.RemoveRoleResponse
 */
export interface RemoveRoleResponse {
}
/**
 * @generated from protobuf message viam.app.v1.ChangeRoleRequest
 */
export interface ChangeRoleRequest {
    /**
     * @generated from protobuf field: viam.app.v1.Authorization old_authorization = 1;
     */
    oldAuthorization?: Authorization;
    /**
     * @generated from protobuf field: viam.app.v1.Authorization new_authorization = 2;
     */
    newAuthorization?: Authorization;
}
/**
 * @generated from protobuf message viam.app.v1.ChangeRoleResponse
 */
export interface ChangeRoleResponse {
}
/**
 * @generated from protobuf message viam.app.v1.ListAuthorizationsRequest
 */
export interface ListAuthorizationsRequest {
    /**
     * @generated from protobuf field: string organization_id = 1;
     */
    organizationId: string;
    /**
     * @generated from protobuf field: repeated string resource_ids = 2;
     */
    resourceIds: string[]; // optional filter
}
/**
 * @generated from protobuf message viam.app.v1.ListAuthorizationsResponse
 */
export interface ListAuthorizationsResponse {
    /**
     * @generated from protobuf field: repeated viam.app.v1.Authorization authorizations = 1;
     */
    authorizations: Authorization[];
}
/**
 * @generated from protobuf message viam.app.v1.CheckPermissionsRequest
 */
export interface CheckPermissionsRequest {
    /**
     * @generated from protobuf field: repeated viam.app.v1.AuthorizedPermissions permissions = 1;
     */
    permissions: AuthorizedPermissions[];
}
/**
 * @generated from protobuf message viam.app.v1.AuthorizedPermissions
 */
export interface AuthorizedPermissions {
    /**
     * @generated from protobuf field: string resource_type = 1;
     */
    resourceType: string;
    /**
     * @generated from protobuf field: string resource_id = 2;
     */
    resourceId: string;
    /**
     * @generated from protobuf field: repeated string permissions = 3;
     */
    permissions: string[];
}
/**
 * @generated from protobuf message viam.app.v1.CheckPermissionsResponse
 */
export interface CheckPermissionsResponse {
    /**
     * @generated from protobuf field: repeated viam.app.v1.AuthorizedPermissions authorized_permissions = 1;
     */
    authorizedPermissions: AuthorizedPermissions[];
}
/**
 * @generated from protobuf message viam.app.v1.ModuleVersion
 */
export interface ModuleVersion {
    /**
     * The semver string that represents the major/minor/patch version of the module
     *
     * @generated from protobuf field: string version = 1;
     */
    version: string;
    /**
     * The uploads that are available for this module version
     *
     * @generated from protobuf field: repeated viam.app.v1.Uploads files = 2;
     */
    files: Uploads[];
    /**
     * The models that this verion of the module provides
     *
     * @generated from protobuf field: repeated viam.app.v1.Model models = 3;
     */
    models: Model[];
    /**
     * The entrypoint for this version of the module
     *
     * @generated from protobuf field: string entrypoint = 4;
     */
    entrypoint: string;
    /**
     * The path to a setup script that is run before a newly downloaded module starts.
     *
     * @generated from protobuf field: optional string first_run = 5;
     */
    firstRun?: string;
    /**
     * The markdown documentation for this version of the module
     *
     * @generated from protobuf field: optional string markdown_description = 6;
     */
    markdownDescription?: string;
    /**
     * A list of applications associated with the module
     *
     * @generated from protobuf field: repeated viam.app.v1.App apps = 7;
     */
    apps: App[];
    /**
     * When set, marks this specific version as deprecated
     *
     * @generated from protobuf field: optional viam.app.v1.DeprecatedStatus deprecated_status = 8;
     */
    deprecatedStatus?: DeprecatedStatus;
    /**
     * The minimum version of viam-server required to run this version of the module.
     *
     * @generated from protobuf field: optional string min_viam_server_version = 9;
     */
    minViamServerVersion?: string;
}
/**
 * @generated from protobuf message viam.app.v1.ModuleMetadata
 */
export interface ModuleMetadata {
    /**
     * A list of models that are available in the module
     *
     * @generated from protobuf field: repeated viam.app.v1.Model models = 1;
     */
    models: Model[];
    /**
     * A list of versions of the module that are available
     * When this is returned from the backend, the versions are sorted in ascending order by the semver version
     *
     * @generated from protobuf field: repeated viam.app.v1.ModuleVersion versions = 2;
     */
    versions: ModuleVersion[];
    /**
     * The executable to run to start the module program
     *
     * @generated from protobuf field: string entrypoint = 3;
     */
    entrypoint: string;
    /**
     * The path to a setup script that is run before a newly downloaded module starts.
     *
     * @generated from protobuf field: optional string first_run = 4;
     */
    firstRun?: string;
    /**
     * markdown content for the entire module
     *
     * @generated from protobuf field: optional string markdown_description = 5;
     */
    markdownDescription?: string;
    /**
     * A list of applications associated with the module
     *
     * @generated from protobuf field: repeated viam.app.v1.App apps = 6;
     */
    apps: App[];
    /**
     * Determines the type of module, either a registry module or an inline module.
     *
     * @generated from protobuf field: optional viam.app.v1.ModuleSourceType source_type = 7;
     */
    sourceType?: ModuleSourceType;
    /**
     * Specifies the language that the module is written in.
     *
     * @generated from protobuf field: optional viam.app.v1.ModuleLanguage language = 8;
     */
    language?: ModuleLanguage;
    /**
     * The minimum version of viam-server required to run the module.
     *
     * @generated from protobuf field: optional string min_viam_server_version = 9;
     */
    minViamServerVersion?: string;
}
/**
 * @generated from protobuf message viam.app.v1.MLModelVersion
 */
export interface MLModelVersion {
    /**
     * @generated from protobuf field: string version = 1;
     */
    version: string;
    /**
     * @generated from protobuf field: google.protobuf.Timestamp created_on = 2;
     */
    createdOn?: Timestamp;
}
/**
 * @generated from protobuf message viam.app.v1.MLModelMetadata
 */
export interface MLModelMetadata {
    /**
     * A list of package versions for a ML model
     *
     * @deprecated
     * @generated from protobuf field: repeated string versions = 1 [deprecated = true];
     */
    versions: string[];
    /**
     * @generated from protobuf field: viam.app.mltraining.v1.ModelType model_type = 2;
     */
    modelType: ModelType;
    /**
     * @generated from protobuf field: viam.app.mltraining.v1.ModelFramework model_framework = 3;
     */
    modelFramework: ModelFramework;
    /**
     * @generated from protobuf field: repeated viam.app.v1.MLModelVersion detailed_versions = 4;
     */
    detailedVersions: MLModelVersion[];
    /**
     * Colon-delimited triplets of components or services from the registry used when
     * model_framework is MODEL_FRAMEWORK_REGISTRY. This ties the ML model file to the
     * associated component or service that consumes the files and should be deployed
     * along with the model.
     *
     * @generated from protobuf field: repeated string deployment_modular_resources = 5;
     */
    deploymentModularResources: string[];
}
/**
 * @generated from protobuf message viam.app.v1.MLTrainingVersion
 */
export interface MLTrainingVersion {
    /**
     * @generated from protobuf field: string version = 1;
     */
    version: string;
    /**
     * @generated from protobuf field: google.protobuf.Timestamp created_on = 2;
     */
    createdOn?: Timestamp;
}
/**
 * @generated from protobuf message viam.app.v1.MLTrainingMetadata
 */
export interface MLTrainingMetadata {
    /**
     * A list of package versions for ML training source distribution
     *
     * @generated from protobuf field: repeated viam.app.v1.MLTrainingVersion versions = 5;
     */
    versions: MLTrainingVersion[];
    /**
     * @generated from protobuf field: viam.app.mltraining.v1.ModelType model_type = 2;
     */
    modelType: ModelType;
    /**
     * @generated from protobuf field: viam.app.mltraining.v1.ModelFramework model_framework = 3;
     */
    modelFramework: ModelFramework;
    /**
     * @generated from protobuf field: bool draft = 4;
     */
    draft: boolean;
    /**
     * Colon-delimited triplets of components or services from the registry used when
     * model_framework is MODEL_FRAMEWORK_REGISTRY. This ties the ML model file to the
     * associated component or service that consumes the files and should be deployed
     * along with the model.
     * Copied onto packages published by this training script.
     *
     * @generated from protobuf field: repeated string deployment_modular_resources = 6;
     */
    deploymentModularResources: string[];
}
/**
 * note: current project will only support deprecation of modules;
 * Training Script and ML Model aren't supported yet.
 *
 * @generated from protobuf message viam.app.v1.DeprecatedStatus
 */
export interface DeprecatedStatus {
    /**
     * time of deprecation
     *
     * @generated from protobuf field: google.protobuf.Timestamp deprecated_at = 1;
     */
    deprecatedAt?: Timestamp;
    /**
     * msg explaining reason for deprecation
     *
     * @generated from protobuf field: string message = 2;
     */
    message: string;
}
/**
 * RegistryItemBilling stores usage cost information for a registry item. Its shape mirrors the
 * billing block used by fragments so that billing jobs can consume registry item costs the same
 * way. For now only cost_per_month.per_machine is supported; the additional fields that fragment
 * billing supports (cost_per_year, tier_name, in_arrears, etc.) are intentionally omitted.
 *
 * @generated from protobuf message viam.app.v1.RegistryItemBilling
 */
export interface RegistryItemBilling {
    /**
     * @generated from protobuf oneof: frequency
     */
    frequency: {
        oneofKind: "costPerMonth";
        /**
         * The recurring monthly cost of the item, broken down by billable resource.
         *
         * @generated from protobuf field: viam.app.v1.RegistryItemCostByResource cost_per_month = 1;
         */
        costPerMonth: RegistryItemCostByResource;
    } | {
        oneofKind: "costPerYear";
        /**
         * The recurring yearly cost of the item, broken down by billable resource.
         *
         * @generated from protobuf field: viam.app.v1.RegistryItemCostByResource cost_per_year = 2;
         */
        costPerYear: RegistryItemCostByResource;
    } | {
        oneofKind: undefined;
    };
}
/**
 * RegistryItemCostByResource holds the cost of a registry item broken down by billable resource.
 * Only the per_machine resource is currently supported.
 *
 * @generated from protobuf message viam.app.v1.RegistryItemCostByResource
 */
export interface RegistryItemCostByResource {
    /**
     * The cost charged per machine using the item, in USD.
     *
     * @generated from protobuf field: double per_machine = 1;
     */
    perMachine: number;
}
/**
 * @generated from protobuf message viam.app.v1.RegistryItem
 */
export interface RegistryItem {
    /**
     * The id of the item, containing either:
     * namespace:item_name when a namespace exists on the org.
     * org_id:item_name when a namespace does not exist.
     *
     * @generated from protobuf field: string item_id = 1;
     */
    itemId: string;
    /**
     * The id of the organization that owns the item
     *
     * @generated from protobuf field: string organization_id = 2;
     */
    organizationId: string;
    /**
     * The public namespace of the organization that owns the module
     * This is empty if no public namespace is set
     *
     * @generated from protobuf field: string public_namespace = 3;
     */
    publicNamespace: string;
    /**
     * The name of the registry item
     *
     * @generated from protobuf field: string name = 4;
     */
    name: string;
    /**
     * The type of the item in the registry
     *
     * @generated from protobuf field: viam.app.packages.v1.PackageType type = 5;
     */
    type: PackageType;
    /**
     * The visibility of the registry item
     *
     * @generated from protobuf field: viam.app.v1.Visibility visibility = 6;
     */
    visibility: Visibility;
    /**
     * The url to reference for documentation, code, etc.
     *
     * @generated from protobuf field: string url = 7;
     */
    url: string;
    /**
     * A short description of the item that explains its purpose
     *
     * @generated from protobuf field: string description = 8;
     */
    description: string;
    /**
     * The total number of robots using this item
     *
     * @generated from protobuf field: int64 total_robot_usage = 9;
     */
    totalRobotUsage: string;
    /**
     * The total number of robots using this item outside of the owning org
     *
     * @generated from protobuf field: int64 total_external_robot_usage = 13;
     */
    totalExternalRobotUsage: string;
    /**
     * The total number of organizations using this item
     *
     * @generated from protobuf field: int64 total_organization_usage = 10;
     */
    totalOrganizationUsage: string;
    /**
     * The total number of organizations using this item outside of the owning org
     *
     * @generated from protobuf field: int64 total_external_organization_usage = 14;
     */
    totalExternalOrganizationUsage: string;
    /**
     * @generated from protobuf oneof: metadata
     */
    metadata: {
        oneofKind: "moduleMetadata";
        /**
         * @generated from protobuf field: viam.app.v1.ModuleMetadata module_metadata = 11;
         */
        moduleMetadata: ModuleMetadata;
    } | {
        oneofKind: "mlModelMetadata";
        /**
         * @generated from protobuf field: viam.app.v1.MLModelMetadata ml_model_metadata = 12;
         */
        mlModelMetadata: MLModelMetadata;
    } | {
        oneofKind: "mlTrainingMetadata";
        /**
         * @generated from protobuf field: viam.app.v1.MLTrainingMetadata ml_training_metadata = 18;
         */
        mlTrainingMetadata: MLTrainingMetadata;
    } | {
        oneofKind: undefined;
    };
    /**
     * When the item was created
     *
     * @generated from protobuf field: google.protobuf.Timestamp created_at = 15;
     */
    createdAt?: Timestamp;
    /**
     * When the item was last updated, either through an update or upload.
     *
     * @generated from protobuf field: google.protobuf.Timestamp updated_at = 16;
     */
    updatedAt?: Timestamp;
    /**
     * Whether the item is deprecated
     *
     * @generated from protobuf field: optional viam.app.v1.DeprecatedStatus deprecated_status = 17;
     */
    deprecatedStatus?: DeprecatedStatus;
    /**
     * Usage cost information used by billing jobs to bill for monthly usage of the item.
     * This is unset when no cost has been configured for the item.
     *
     * @generated from protobuf field: optional viam.app.v1.RegistryItemBilling billing = 19;
     */
    billing?: RegistryItemBilling;
}
/**
 * @generated from protobuf message viam.app.v1.GetRegistryItemRequest
 */
export interface GetRegistryItemRequest {
    /**
     * @generated from protobuf field: string item_id = 1;
     */
    itemId: string;
    /**
     * @generated from protobuf field: optional bool include_markdown_documentation = 2;
     */
    includeMarkdownDocumentation?: boolean;
}
/**
 * @generated from protobuf message viam.app.v1.GetRegistryItemResponse
 */
export interface GetRegistryItemResponse {
    /**
     * @generated from protobuf field: viam.app.v1.RegistryItem item = 1;
     */
    item?: RegistryItem;
}
/**
 * @generated from protobuf message viam.app.v1.CreateRegistryItemRequest
 */
export interface CreateRegistryItemRequest {
    /**
     * The organization to create the registry item under
     *
     * @generated from protobuf field: string organization_id = 1;
     */
    organizationId: string;
    /**
     * The name of the registry item, which must be unique within your org
     *
     * @generated from protobuf field: string name = 2;
     */
    name: string;
    /**
     * The type of the item in the registry
     *
     * @generated from protobuf field: viam.app.packages.v1.PackageType type = 3;
     */
    type: PackageType;
}
/**
 * @generated from protobuf message viam.app.v1.CreateRegistryItemResponse
 */
export interface CreateRegistryItemResponse {
}
/**
 * @generated from protobuf message viam.app.v1.UpdateRegistryItemRequest
 */
export interface UpdateRegistryItemRequest {
    /**
     * @generated from protobuf field: string item_id = 1;
     */
    itemId: string;
    /**
     * @generated from protobuf field: viam.app.packages.v1.PackageType type = 2;
     */
    type: PackageType;
    /**
     * @generated from protobuf field: string description = 3;
     */
    description: string;
    /**
     * @generated from protobuf field: viam.app.v1.Visibility visibility = 4;
     */
    visibility: Visibility;
    /**
     * @generated from protobuf field: optional string url = 5;
     */
    url?: string;
    /**
     * @generated from protobuf oneof: metadata
     */
    metadata: {
        oneofKind: "updateModuleMetadata";
        /**
         * @generated from protobuf field: viam.app.v1.UpdateModuleMetadata update_module_metadata = 6;
         */
        updateModuleMetadata: UpdateModuleMetadata;
    } | {
        oneofKind: "updateMlModelMetadata";
        /**
         * @generated from protobuf field: viam.app.v1.UpdateMLModelMetadata update_ml_model_metadata = 7;
         */
        updateMlModelMetadata: UpdateMLModelMetadata;
    } | {
        oneofKind: "updateMlTrainingMetadata";
        /**
         * @generated from protobuf field: viam.app.v1.UpdateMLTrainingMetadata update_ml_training_metadata = 8;
         */
        updateMlTrainingMetadata: UpdateMLTrainingMetadata;
    } | {
        oneofKind: undefined;
    };
    /**
     * @generated from protobuf field: optional string markdown_description = 9;
     */
    markdownDescription?: string;
    /**
     * The usage cost information to store on the item. When unset, the existing billing
     * configuration is left unchanged.
     *
     * @generated from protobuf field: optional viam.app.v1.RegistryItemBilling billing = 10;
     */
    billing?: RegistryItemBilling;
}
/**
 * @generated from protobuf message viam.app.v1.UpdateRegistryItemResponse
 */
export interface UpdateRegistryItemResponse {
}
/**
 * @generated from protobuf message viam.app.v1.ListRegistryItemsRequest
 */
export interface ListRegistryItemsRequest {
    /**
     * The id of the organization to return registry items for.
     *
     * @generated from protobuf field: optional string organization_id = 1;
     */
    organizationId?: string;
    /**
     * @generated from protobuf field: repeated viam.app.packages.v1.PackageType types = 2;
     */
    types: PackageType[];
    /**
     * @generated from protobuf field: repeated viam.app.v1.Visibility visibilities = 3;
     */
    visibilities: Visibility[];
    /**
     * @generated from protobuf field: repeated string platforms = 4;
     */
    platforms: string[];
    /**
     * @generated from protobuf field: repeated viam.app.v1.RegistryItemStatus statuses = 5;
     */
    statuses: RegistryItemStatus[];
    /**
     * @generated from protobuf field: optional string search_term = 6;
     */
    searchTerm?: string;
    /**
     * @generated from protobuf field: optional string page_token = 7;
     */
    pageToken?: string;
    /**
     * One or more public namespaces to return results for.
     *
     * @generated from protobuf field: repeated string public_namespaces = 8;
     */
    publicNamespaces: string[];
    /**
     * @generated from protobuf field: optional bool include_markdown_documentation = 9;
     */
    includeMarkdownDocumentation?: boolean;
    /**
     * @generated from protobuf field: repeated viam.app.v1.ModuleSourceType module_source_types = 10;
     */
    moduleSourceTypes: ModuleSourceType[];
    /**
     * @generated from protobuf field: repeated viam.app.v1.ModuleLanguage module_languages = 11;
     */
    moduleLanguages: ModuleLanguage[];
    /**
     * @generated from protobuf field: optional bool show_owned_deprecated = 12;
     */
    showOwnedDeprecated?: boolean;
}
/**
 * @generated from protobuf message viam.app.v1.ListRegistryItemsResponse
 */
export interface ListRegistryItemsResponse {
    /**
     * @generated from protobuf field: repeated viam.app.v1.RegistryItem items = 1;
     */
    items: RegistryItem[];
}
/**
 * @generated from protobuf message viam.app.v1.DeleteRegistryItemRequest
 */
export interface DeleteRegistryItemRequest {
    /**
     * The id of the item (formatted as prefix:name where prefix is the owner's orgid or namespace)
     *
     * @generated from protobuf field: string item_id = 1;
     */
    itemId: string;
}
/**
 * @generated from protobuf message viam.app.v1.DeleteRegistryItemResponse
 */
export interface DeleteRegistryItemResponse {
}
/**
 * @generated from protobuf message viam.app.v1.RenameRegistryItemRequest
 */
export interface RenameRegistryItemRequest {
    /**
     * @generated from protobuf field: string item_id = 1;
     */
    itemId: string;
    /**
     * @generated from protobuf field: string new_name = 2;
     */
    newName: string;
}
/**
 * @generated from protobuf message viam.app.v1.RenameRegistryItemResponse
 */
export interface RenameRegistryItemResponse {
    /**
     * @generated from protobuf field: viam.app.v1.RegistryItem item = 1;
     */
    item?: RegistryItem;
}
/**
 * @generated from protobuf message viam.app.v1.TransferRegistryItemRequest
 */
export interface TransferRegistryItemRequest {
    /**
     * @generated from protobuf field: string item_id = 1;
     */
    itemId: string;
    /**
     * @generated from protobuf field: string new_public_namespace = 2;
     */
    newPublicNamespace: string;
}
/**
 * @generated from protobuf message viam.app.v1.TransferRegistryItemResponse
 */
export interface TransferRegistryItemResponse {
}
/**
 * @generated from protobuf message viam.app.v1.DeprecateRegistryItemRequest
 */
export interface DeprecateRegistryItemRequest {
    /**
     * @generated from protobuf field: string item_id = 1;
     */
    itemId: string;
    /**
     * @generated from protobuf field: string message = 2;
     */
    message: string;
}
/**
 * @generated from protobuf message viam.app.v1.DeprecateRegistryItemResponse
 */
export interface DeprecateRegistryItemResponse {
}
/**
 * @generated from protobuf message viam.app.v1.UndeprecateRegistryItemRequest
 */
export interface UndeprecateRegistryItemRequest {
    /**
     * @generated from protobuf field: string item_id = 1;
     */
    itemId: string;
}
/**
 * @generated from protobuf message viam.app.v1.UndeprecateRegistryItemResponse
 */
export interface UndeprecateRegistryItemResponse {
}
/**
 * Modules
 *
 * @generated from protobuf message viam.app.v1.CreateModuleRequest
 */
export interface CreateModuleRequest {
    /**
     * The organization to create the module under
     *
     * @generated from protobuf field: string organization_id = 1;
     */
    organizationId: string;
    /**
     * The name of the module, which must be unique within your org
     *
     * @generated from protobuf field: string name = 2;
     */
    name: string;
}
/**
 * @generated from protobuf message viam.app.v1.CreateModuleResponse
 */
export interface CreateModuleResponse {
    /**
     * The id of the module (formatted as prefix:name where prefix is the module owner's orgid or namespace)
     *
     * @generated from protobuf field: string module_id = 1;
     */
    moduleId: string;
    /**
     * The detail page of the module
     *
     * @generated from protobuf field: string url = 2;
     */
    url: string;
}
/**
 * @generated from protobuf message viam.app.v1.UpdateModuleRequest
 */
export interface UpdateModuleRequest {
    /**
     * The id of the module (formatted as prefix:name where prefix is the module owner's orgid or namespace)
     *
     * @generated from protobuf field: string module_id = 1;
     */
    moduleId: string;
    /**
     * The visibility that should be set for the module
     *
     * @generated from protobuf field: viam.app.v1.Visibility visibility = 2;
     */
    visibility: Visibility;
    /**
     * The url to reference for documentation, code, etc.
     *
     * @generated from protobuf field: string url = 3;
     */
    url: string;
    /**
     * A short description of the module that explains its purpose
     *
     * @generated from protobuf field: string description = 4;
     */
    description: string;
    /**
     * A list of models that are available in the module
     *
     * @generated from protobuf field: repeated viam.app.v1.Model models = 5;
     */
    models: Model[];
    /**
     * The executable to run to start the module program
     *
     * @generated from protobuf field: string entrypoint = 6;
     */
    entrypoint: string;
    /**
     * The path to a setup script that is run before a newly downloaded module starts.
     *
     * @generated from protobuf field: optional string first_run = 7;
     */
    firstRun?: string;
    /**
     * A list of applications associated with the module
     *
     * @generated from protobuf field: repeated viam.app.v1.App apps = 8;
     */
    apps: App[];
    /**
     * longer documentation provided in markdown format
     *
     * @generated from protobuf field: optional string markdown_description = 9;
     */
    markdownDescription?: string;
}
/**
 * @generated from protobuf message viam.app.v1.AllowedOrgIDs
 */
export interface AllowedOrgIDs {
    /**
     * @generated from protobuf field: repeated string ids = 1;
     */
    ids: string[];
}
/**
 * @generated from protobuf message viam.app.v1.App
 */
export interface App {
    /**
     * The name of the application
     *
     * @generated from protobuf field: string name = 1;
     */
    name: string;
    /**
     * The type of the application
     *
     * @generated from protobuf field: string type = 2;
     */
    type: string;
    /**
     * The entrypoint of the application
     *
     * @generated from protobuf field: string entrypoint = 3;
     */
    entrypoint: string;
    /**
     * Optional: fragment IDs to filter machines in the picker
     *
     * @generated from protobuf field: repeated string fragment_ids = 4;
     */
    fragmentIds: string[];
    /**
     * Optional: path to a custom logo for branding
     *
     * @generated from protobuf field: optional string logo_path = 5;
     */
    logoPath?: string;
    /**
     * Optional: structured customizations for the app (e.g., machine picker headings)
     *
     * @generated from protobuf field: viam.app.v1.AppCustomizations customizations = 6;
     */
    customizations?: AppCustomizations;
    /**
     * Optional: list of org IDs that are allowed to use this app; if empty, all orgs are allowed
     *
     * @generated from protobuf field: optional viam.app.v1.AllowedOrgIDs allowed_org_ids = 7;
     */
    allowedOrgIds?: AllowedOrgIDs;
}
/**
 * @generated from protobuf message viam.app.v1.UpdateModuleResponse
 */
export interface UpdateModuleResponse {
    /**
     * The detail page of the module
     *
     * @generated from protobuf field: string url = 1;
     */
    url: string;
}
/**
 * @generated from protobuf message viam.app.v1.UpdateModuleMetadata
 */
export interface UpdateModuleMetadata {
    /**
     * A list of models that are available in the module
     *
     * @generated from protobuf field: repeated viam.app.v1.Model models = 1;
     */
    models: Model[];
    /**
     * The executable to run to start the module program
     *
     * @generated from protobuf field: string entrypoint = 2;
     */
    entrypoint: string;
    /**
     * A list of applications associated with the module
     *
     * @generated from protobuf field: repeated viam.app.v1.App apps = 3;
     */
    apps: App[];
    /**
     * Determines where the source code of module is managed, either externally or hosted by viam.
     *
     * @generated from protobuf field: optional viam.app.v1.ModuleSourceType source_type = 4;
     */
    sourceType?: ModuleSourceType;
    /**
     * The language the module is written in
     *
     * @generated from protobuf field: optional viam.app.v1.ModuleLanguage language = 5;
     */
    language?: ModuleLanguage;
    /**
     * The minimum version of viam-server required to run the module.
     *
     * @generated from protobuf field: optional string min_viam_server_version = 6;
     */
    minViamServerVersion?: string;
}
/**
 * @generated from protobuf message viam.app.v1.UpdateMLModelMetadata
 */
export interface UpdateMLModelMetadata {
    /**
     * @generated from protobuf field: viam.app.mltraining.v1.ModelType model_type = 1;
     */
    modelType: ModelType;
    /**
     * @generated from protobuf field: viam.app.mltraining.v1.ModelFramework model_framework = 2;
     */
    modelFramework: ModelFramework;
    /**
     * Colon-delimited triplets of components or services from the registry used when
     * model_framework is MODEL_FRAMEWORK_REGISTRY. This ties the ML model file to the
     * associated component or service that consumes the files and should be deployed
     * along with the model.
     *
     * @generated from protobuf field: repeated string deployment_modular_resources = 3;
     */
    deploymentModularResources: string[];
}
/**
 * @generated from protobuf message viam.app.v1.UpdateMLTrainingMetadata
 */
export interface UpdateMLTrainingMetadata {
    /**
     * @generated from protobuf field: viam.app.mltraining.v1.ModelType model_type = 1;
     */
    modelType: ModelType;
    /**
     * @generated from protobuf field: viam.app.mltraining.v1.ModelFramework model_framework = 2;
     */
    modelFramework: ModelFramework;
    /**
     * @generated from protobuf field: bool draft = 3;
     */
    draft: boolean;
    /**
     * Colon-delimited triplets of components or services from the registry used when
     * model_framework is MODEL_FRAMEWORK_REGISTRY. This ties the ML model file to the
     * associated component or service that consumes the files and should be deployed
     * along with the model.
     *
     * @generated from protobuf field: repeated string deployment_modular_resources = 4;
     */
    deploymentModularResources: string[];
}
/**
 * @generated from protobuf message viam.app.v1.Model
 */
export interface Model {
    /**
     * The colon-delimited-triplet of the api implemented by the model
     *
     * @generated from protobuf field: string api = 1;
     */
    api: string;
    /**
     * The colon-delimited-triplet of the model
     *
     * @generated from protobuf field: string model = 2;
     */
    model: string;
    /**
     * The markdown content describing the usage of the model
     *
     * @generated from protobuf field: optional string markdown_documentation = 3;
     */
    markdownDocumentation?: string;
    /**
     * A short description of the model that explains its purpose
     *
     * @generated from protobuf field: optional string description = 4;
     */
    description?: string;
    /**
     * A list of supported hardware names
     *
     * @generated from protobuf field: repeated string supported_hardware = 5;
     */
    supportedHardware: string[];
}
/**
 * @generated from protobuf message viam.app.v1.ModuleFileInfo
 */
export interface ModuleFileInfo {
    /**
     * The id of the module (formatted as prefix:name where prefix is the module owner's orgid or namespace)
     *
     * @generated from protobuf field: string module_id = 1;
     */
    moduleId: string;
    /**
     * The semver string that represents the new major/minor/patch version of the module
     *
     * @generated from protobuf field: string version = 2;
     */
    version: string;
    /**
     * The platform that the file is built to run on
     *
     * @generated from protobuf field: string platform = 3;
     */
    platform: string;
    /**
     * Platform tag constraints. When a robot requests its config, it uploads a platform and a list of
     * platform tags. The platform is checked against `platform` above, and the tags are checked against
     * this list.
     *
     * @generated from protobuf field: repeated string platform_tags = 5;
     */
    platformTags: string[];
}
/**
 * @generated from protobuf message viam.app.v1.UploadModuleFileRequest
 */
export interface UploadModuleFileRequest {
    /**
     * @generated from protobuf oneof: module_file
     */
    moduleFile: {
        oneofKind: "moduleFileInfo";
        /**
         * The information about the module file being uploaded
         *
         * @generated from protobuf field: viam.app.v1.ModuleFileInfo module_file_info = 1;
         */
        moduleFileInfo: ModuleFileInfo;
    } | {
        oneofKind: "file";
        /**
         * The file contents to be uploaded
         *
         * @generated from protobuf field: bytes file = 2;
         */
        file: Uint8Array;
    } | {
        oneofKind: undefined;
    };
}
/**
 * @generated from protobuf message viam.app.v1.UploadModuleFileResponse
 */
export interface UploadModuleFileResponse {
    /**
     * The detail page of the module
     *
     * @generated from protobuf field: string url = 1;
     */
    url: string;
}
/**
 * @generated from protobuf message viam.app.v1.GetModuleRequest
 */
export interface GetModuleRequest {
    /**
     * The id of the module (formatted as prefix:name where prefix is the module owner's orgid or namespace)
     *
     * @generated from protobuf field: string module_id = 1;
     */
    moduleId: string;
    /**
     * @generated from protobuf field: optional bool include_markdown_documentation = 2;
     */
    includeMarkdownDocumentation?: boolean;
}
/**
 * @generated from protobuf message viam.app.v1.GetModuleResponse
 */
export interface GetModuleResponse {
    /**
     * The module object
     *
     * @generated from protobuf field: viam.app.v1.Module module = 1;
     */
    module?: Module;
}
/**
 * @generated from protobuf message viam.app.v1.Module
 */
export interface Module {
    /**
     * The id of the module (formatted as prefix:name where prefix is the module owner's orgid or namespace)
     *
     * @generated from protobuf field: string module_id = 1;
     */
    moduleId: string;
    /**
     * The name of the module
     *
     * @generated from protobuf field: string name = 2;
     */
    name: string;
    /**
     * The visibility of the module
     *
     * @generated from protobuf field: viam.app.v1.Visibility visibility = 3;
     */
    visibility: Visibility;
    /**
     * The versions of the module that are available
     * When this is returned from the backend, the versions are sorted in ascending order by the semver version
     *
     * @generated from protobuf field: repeated viam.app.v1.VersionHistory versions = 4;
     */
    versions: VersionHistory[];
    /**
     * The url to reference for documentation, code, etc.
     *
     * @generated from protobuf field: string url = 5;
     */
    url: string;
    /**
     * A short description of the module that explains its purpose
     *
     * @generated from protobuf field: string description = 6;
     */
    description: string;
    /**
     * A list of models that are available in the module
     *
     * @generated from protobuf field: repeated viam.app.v1.Model models = 7;
     */
    models: Model[];
    /**
     * The total number of robots using this module
     *
     * @generated from protobuf field: int64 total_robot_usage = 8;
     */
    totalRobotUsage: string;
    /**
     * The total number of organizations using this module
     *
     * @generated from protobuf field: int64 total_organization_usage = 9;
     */
    totalOrganizationUsage: string;
    /**
     * The id of the organization that owns the module
     *
     * @generated from protobuf field: string organization_id = 10;
     */
    organizationId: string;
    /**
     * The executable to run to start the module program
     *
     * @generated from protobuf field: string entrypoint = 11;
     */
    entrypoint: string;
    /**
     * The public namespace of the organization that owns the module
     * This is empty if no public namespace is set
     *
     * @generated from protobuf field: string public_namespace = 12;
     */
    publicNamespace: string;
    /**
     * The path to a setup script that is run before a newly downloaded module starts.
     *
     * @generated from protobuf field: optional string first_run = 13;
     */
    firstRun?: string;
    /**
     * Longer documentation provided in markdown format
     *
     * @generated from protobuf field: optional string markdown_description = 14;
     */
    markdownDescription?: string;
    /**
     * A list of applications associated with the module
     *
     * @generated from protobuf field: repeated viam.app.v1.App apps = 15;
     */
    apps: App[];
    /**
     * Deprecated status of an individual module
     *
     * @generated from protobuf field: optional viam.app.v1.DeprecatedStatus deprecated_status = 16;
     */
    deprecatedStatus?: DeprecatedStatus;
}
/**
 * @generated from protobuf message viam.app.v1.VersionHistory
 */
export interface VersionHistory {
    /**
     * The semver string that represents the major/minor/patch version of the module
     *
     * @generated from protobuf field: string version = 1;
     */
    version: string;
    /**
     * The uploads that are available for this module version
     *
     * @generated from protobuf field: repeated viam.app.v1.Uploads files = 2;
     */
    files: Uploads[];
    /**
     * The models that this verion of the module provides
     *
     * @generated from protobuf field: repeated viam.app.v1.Model models = 3;
     */
    models: Model[];
    /**
     * The entrypoint for this version of the module
     *
     * @generated from protobuf field: string entrypoint = 4;
     */
    entrypoint: string;
    /**
     * The path to a setup script that is run before a newly downloaded module starts.
     *
     * @generated from protobuf field: optional string first_run = 5;
     */
    firstRun?: string;
    /**
     * The markdown documentation for this version of the module
     *
     * @generated from protobuf field: optional string markdown_description = 6;
     */
    markdownDescription?: string;
    /**
     * A list of applications associated with the module
     *
     * @generated from protobuf field: repeated viam.app.v1.App apps = 7;
     */
    apps: App[];
    /**
     * Deprecated status of an individual module version
     *
     * @generated from protobuf field: optional viam.app.v1.DeprecatedStatus deprecated_status = 8;
     */
    deprecatedStatus?: DeprecatedStatus;
}
/**
 * @generated from protobuf message viam.app.v1.Uploads
 */
export interface Uploads {
    /**
     * The OS and architecture the module is built to run on
     *
     * @generated from protobuf field: string platform = 1;
     */
    platform: string;
    /**
     * The time when the file was uploaded
     *
     * @generated from protobuf field: google.protobuf.Timestamp uploaded_at = 2;
     */
    uploadedAt?: Timestamp;
}
/**
 * @generated from protobuf message viam.app.v1.ListModulesRequest
 */
export interface ListModulesRequest {
    /**
     * The id of the organization to return private modules for.
     *
     * @generated from protobuf field: optional string organization_id = 1;
     */
    organizationId?: string;
    /**
     * @generated from protobuf field: optional bool include_markdown_documentation = 2;
     */
    includeMarkdownDocumentation?: boolean;
}
/**
 * @generated from protobuf message viam.app.v1.ListModulesResponse
 */
export interface ListModulesResponse {
    /**
     * A listed of modules. When authenticated, this API will return modules that are private for this org. Public modules are always returned.
     *
     * @generated from protobuf field: repeated viam.app.v1.Module modules = 1;
     */
    modules: Module[];
}
/**
 * Deprecates a specific version of a registry item.
 *
 * @generated from protobuf message viam.app.v1.DeprecateRegistryItemVersionRequest
 */
export interface DeprecateRegistryItemVersionRequest {
    /**
     * The id of the registry item
     *
     * @generated from protobuf field: string item_id = 1;
     */
    itemId: string;
    /**
     * The semver string of the version to deprecate.
     *
     * @generated from protobuf field: string version = 2;
     */
    version: string;
    /**
     * msg explaining reason for deprecation
     *
     * @generated from protobuf field: string message = 3;
     */
    message: string;
}
/**
 * @generated from protobuf message viam.app.v1.DeprecateRegistryItemVersionResponse
 */
export interface DeprecateRegistryItemVersionResponse {
}
/**
 * @generated from protobuf message viam.app.v1.UndeprecateRegistryItemVersionRequest
 */
export interface UndeprecateRegistryItemVersionRequest {
    /**
     * @generated from protobuf field: string item_id = 1;
     */
    itemId: string;
    /**
     * @generated from protobuf field: string version = 2;
     */
    version: string;
}
/**
 * @generated from protobuf message viam.app.v1.UndeprecateRegistryItemVersionResponse
 */
export interface UndeprecateRegistryItemVersionResponse {
}
/**
 * @generated from protobuf message viam.app.v1.GetUserIDByEmailRequest
 */
export interface GetUserIDByEmailRequest {
    /**
     * @generated from protobuf field: string email = 1;
     */
    email: string;
}
/**
 * @generated from protobuf message viam.app.v1.GetUserIDByEmailResponse
 */
export interface GetUserIDByEmailResponse {
    /**
     * @generated from protobuf field: string user_id = 1;
     */
    userId: string;
}
/**
 * @generated from protobuf message viam.app.v1.ListOrganizationsByUserRequest
 */
export interface ListOrganizationsByUserRequest {
    /**
     * @generated from protobuf field: string user_id = 1;
     */
    userId: string;
}
/**
 * @generated from protobuf message viam.app.v1.OrgDetails
 */
export interface OrgDetails {
    /**
     * @generated from protobuf field: string org_id = 1;
     */
    orgId: string;
    /**
     * @generated from protobuf field: string org_name = 2;
     */
    orgName: string;
    /**
     * @generated from protobuf field: optional string org_cid = 3;
     */
    orgCid?: string;
    /**
     * @generated from protobuf field: optional string public_namespace = 4;
     */
    publicNamespace?: string;
    /**
     * @generated from protobuf field: optional string billing_tier = 5;
     */
    billingTier?: string;
}
/**
 * @generated from protobuf message viam.app.v1.ListOrganizationsByUserResponse
 */
export interface ListOrganizationsByUserResponse {
    /**
     * @generated from protobuf field: repeated viam.app.v1.OrgDetails orgs = 1;
     */
    orgs: OrgDetails[];
}
/**
 * @generated from protobuf message viam.app.v1.SearchOrganizationsRequest
 */
export interface SearchOrganizationsRequest {
    /**
     * @generated from protobuf field: optional string org_id = 1;
     */
    orgId?: string;
    /**
     * @generated from protobuf field: optional string org_name = 2;
     */
    orgName?: string;
    /**
     * @generated from protobuf field: optional string cid = 3;
     */
    cid?: string;
    /**
     * @generated from protobuf field: optional string public_namespace = 4;
     */
    publicNamespace?: string;
}
/**
 * @generated from protobuf message viam.app.v1.SearchOrganizationsResponse
 */
export interface SearchOrganizationsResponse {
    /**
     * @generated from protobuf field: repeated viam.app.v1.OrgDetails organizations = 1;
     */
    organizations: OrgDetails[];
}
/**
 * @generated from protobuf message viam.app.v1.CreateKeyRequest
 */
export interface CreateKeyRequest {
    /**
     * @generated from protobuf field: repeated viam.app.v1.Authorization authorizations = 1;
     */
    authorizations: Authorization[];
    /**
     * @generated from protobuf field: string name = 2;
     */
    name: string;
}
/**
 * @generated from protobuf message viam.app.v1.CreateKeyResponse
 */
export interface CreateKeyResponse {
    /**
     * @generated from protobuf field: string key = 1;
     */
    key: string;
    /**
     * @generated from protobuf field: string id = 2;
     */
    id: string;
}
/**
 * @generated from protobuf message viam.app.v1.DeleteKeyRequest
 */
export interface DeleteKeyRequest {
    /**
     * @generated from protobuf field: string id = 1;
     */
    id: string;
}
/**
 * @generated from protobuf message viam.app.v1.DeleteKeyResponse
 */
export interface DeleteKeyResponse {
}
/**
 * @generated from protobuf message viam.app.v1.RenameKeyRequest
 */
export interface RenameKeyRequest {
    /**
     * @generated from protobuf field: string id = 1;
     */
    id: string;
    /**
     * @generated from protobuf field: string name = 2;
     */
    name: string;
}
/**
 * @generated from protobuf message viam.app.v1.RenameKeyResponse
 */
export interface RenameKeyResponse {
    /**
     * @generated from protobuf field: string id = 1;
     */
    id: string;
    /**
     * @generated from protobuf field: string name = 2;
     */
    name: string;
}
/**
 * @generated from protobuf message viam.app.v1.AuthorizationDetails
 */
export interface AuthorizationDetails {
    /**
     * @generated from protobuf field: string authorization_type = 1;
     */
    authorizationType: string;
    /**
     * @generated from protobuf field: string authorization_id = 2;
     */
    authorizationId: string;
    /**
     * @generated from protobuf field: string resource_type = 3;
     */
    resourceType: string;
    /**
     * @generated from protobuf field: string resource_id = 4;
     */
    resourceId: string;
    /**
     * @generated from protobuf field: string org_id = 5;
     */
    orgId: string;
}
/**
 * @generated from protobuf message viam.app.v1.APIKeyWithAuthorizations
 */
export interface APIKeyWithAuthorizations {
    /**
     * @generated from protobuf field: viam.app.v1.APIKey api_key = 1;
     */
    apiKey?: APIKey;
    /**
     * @generated from protobuf field: repeated viam.app.v1.AuthorizationDetails authorizations = 2;
     */
    authorizations: AuthorizationDetails[];
}
/**
 * @generated from protobuf message viam.app.v1.ListKeysRequest
 */
export interface ListKeysRequest {
    /**
     * @generated from protobuf field: string org_id = 1;
     */
    orgId: string;
}
/**
 * @generated from protobuf message viam.app.v1.ListKeysResponse
 */
export interface ListKeysResponse {
    /**
     * @generated from protobuf field: repeated viam.app.v1.APIKeyWithAuthorizations api_keys = 1;
     */
    apiKeys: APIKeyWithAuthorizations[];
}
/**
 * @generated from protobuf message viam.app.v1.RotateKeyRequest
 */
export interface RotateKeyRequest {
    /**
     * @generated from protobuf field: string id = 1;
     */
    id: string;
}
/**
 * @generated from protobuf message viam.app.v1.RotateKeyResponse
 */
export interface RotateKeyResponse {
    /**
     * @generated from protobuf field: string id = 1;
     */
    id: string;
    /**
     * @generated from protobuf field: string key = 2;
     */
    key: string;
}
/**
 * @generated from protobuf message viam.app.v1.CreateKeyFromExistingKeyAuthorizationsRequest
 */
export interface CreateKeyFromExistingKeyAuthorizationsRequest {
    /**
     * @generated from protobuf field: string id = 1;
     */
    id: string;
}
/**
 * @generated from protobuf message viam.app.v1.CreateKeyFromExistingKeyAuthorizationsResponse
 */
export interface CreateKeyFromExistingKeyAuthorizationsResponse {
    /**
     * @generated from protobuf field: string id = 1;
     */
    id: string;
    /**
     * @generated from protobuf field: string key = 2;
     */
    key: string;
}
/**
 * @generated from protobuf message viam.app.v1.GetAppContentRequest
 */
export interface GetAppContentRequest {
    /**
     * @generated from protobuf field: string public_namespace = 1;
     */
    publicNamespace: string;
    /**
     * @generated from protobuf field: string name = 2;
     */
    name: string;
}
/**
 * @generated from protobuf message viam.app.v1.GetAppContentResponse
 */
export interface GetAppContentResponse {
    /**
     * @generated from protobuf field: string blob_path = 1;
     */
    blobPath: string;
    /**
     * @generated from protobuf field: string entrypoint = 2;
     */
    entrypoint: string;
    /**
     * @generated from protobuf field: viam.app.v1.AppType app_type = 3;
     */
    appType: AppType;
    /**
     * @generated from protobuf field: bool public = 4;
     */
    public: boolean;
}
/**
 * @generated from protobuf message viam.app.v1.OrganizationSetLogoRequest
 */
export interface OrganizationSetLogoRequest {
    /**
     * @generated from protobuf field: string org_id = 1;
     */
    orgId: string;
    /**
     * @generated from protobuf field: bytes logo = 2;
     */
    logo: Uint8Array;
}
/**
 * @generated from protobuf message viam.app.v1.OrganizationSetLogoResponse
 */
export interface OrganizationSetLogoResponse {
}
/**
 * @generated from protobuf message viam.app.v1.OrganizationGetLogoRequest
 */
export interface OrganizationGetLogoRequest {
    /**
     * @generated from protobuf field: string org_id = 1;
     */
    orgId: string;
}
/**
 * @generated from protobuf message viam.app.v1.OrganizationGetLogoResponse
 */
export interface OrganizationGetLogoResponse {
    /**
     * @generated from protobuf field: string url = 1;
     */
    url: string;
}
/**
 * @generated from protobuf message viam.app.v1.EnableAuthServiceRequest
 */
export interface EnableAuthServiceRequest {
    /**
     * @generated from protobuf field: string org_id = 1;
     */
    orgId: string;
}
/**
 * @generated from protobuf message viam.app.v1.EnableAuthServiceResponse
 */
export interface EnableAuthServiceResponse {
}
/**
 * @generated from protobuf message viam.app.v1.DisableAuthServiceRequest
 */
export interface DisableAuthServiceRequest {
    /**
     * @generated from protobuf field: string org_id = 1;
     */
    orgId: string;
}
/**
 * @generated from protobuf message viam.app.v1.DisableAuthServiceResponse
 */
export interface DisableAuthServiceResponse {
}
/**
 * @generated from protobuf message viam.app.v1.CreateOAuthAppRequest
 */
export interface CreateOAuthAppRequest {
    /**
     * @generated from protobuf field: string org_id = 1;
     */
    orgId: string;
    /**
     * @generated from protobuf field: string client_name = 2;
     */
    clientName: string;
    /**
     * @generated from protobuf field: viam.app.v1.OAuthConfig oauth_config = 3;
     */
    oauthConfig?: OAuthConfig;
}
/**
 * @generated from protobuf message viam.app.v1.CreateOAuthAppResponse
 */
export interface CreateOAuthAppResponse {
    /**
     * @generated from protobuf field: string client_id = 1;
     */
    clientId: string;
    /**
     * @generated from protobuf field: string client_secret = 2;
     */
    clientSecret: string;
}
/**
 * @generated from protobuf message viam.app.v1.ReadOAuthAppRequest
 */
export interface ReadOAuthAppRequest {
    /**
     * @generated from protobuf field: string org_id = 1;
     */
    orgId: string;
    /**
     * @generated from protobuf field: string client_id = 2;
     */
    clientId: string;
}
/**
 * @generated from protobuf message viam.app.v1.ReadOAuthAppResponse
 */
export interface ReadOAuthAppResponse {
    /**
     * @generated from protobuf field: string client_name = 1;
     */
    clientName: string;
    /**
     * @generated from protobuf field: string client_secret = 2;
     */
    clientSecret: string;
    /**
     * @generated from protobuf field: viam.app.v1.OAuthConfig oauth_config = 3;
     */
    oauthConfig?: OAuthConfig;
}
/**
 * @generated from protobuf message viam.app.v1.UpdateOAuthAppRequest
 */
export interface UpdateOAuthAppRequest {
    /**
     * @generated from protobuf field: string org_id = 1;
     */
    orgId: string;
    /**
     * @generated from protobuf field: string client_id = 2;
     */
    clientId: string;
    /**
     * @generated from protobuf field: string client_name = 3;
     */
    clientName: string;
    /**
     * @generated from protobuf field: viam.app.v1.OAuthConfig oauth_config = 4;
     */
    oauthConfig?: OAuthConfig;
}
/**
 * @generated from protobuf message viam.app.v1.UpdateOAuthAppResponse
 */
export interface UpdateOAuthAppResponse {
}
/**
 * @generated from protobuf message viam.app.v1.DeleteOAuthAppRequest
 */
export interface DeleteOAuthAppRequest {
    /**
     * @generated from protobuf field: string org_id = 1;
     */
    orgId: string;
    /**
     * @generated from protobuf field: string client_id = 2;
     */
    clientId: string;
}
/**
 * @generated from protobuf message viam.app.v1.DeleteOAuthAppResponse
 */
export interface DeleteOAuthAppResponse {
}
/**
 * @generated from protobuf message viam.app.v1.ListOAuthAppsRequest
 */
export interface ListOAuthAppsRequest {
    /**
     * @generated from protobuf field: string org_id = 1;
     */
    orgId: string;
}
/**
 * @generated from protobuf message viam.app.v1.ListOAuthAppsResponse
 */
export interface ListOAuthAppsResponse {
    /**
     * @generated from protobuf field: repeated string client_ids = 1;
     */
    clientIds: string[];
}
/**
 * @generated from protobuf message viam.app.v1.CreateOAuthAppUserRequest
 */
export interface CreateOAuthAppUserRequest {
    /**
     * @generated from protobuf field: string org_id = 1;
     */
    orgId: string;
    /**
     * @generated from protobuf field: string application_id = 2;
     */
    applicationId: string;
    /**
     * @generated from protobuf field: string email = 3;
     */
    email: string;
    /**
     * @generated from protobuf field: string first_name = 4;
     */
    firstName: string;
    /**
     * @generated from protobuf field: string last_name = 5;
     */
    lastName: string;
    /**
     * @generated from protobuf field: string password = 6;
     */
    password: string;
}
/**
 * @generated from protobuf message viam.app.v1.CreateOAuthAppUserResponse
 */
export interface CreateOAuthAppUserResponse {
    /**
     * @generated from protobuf field: string auth_token = 1;
     */
    authToken: string;
    /**
     * @generated from protobuf field: string registration_id = 2;
     */
    registrationId: string;
    /**
     * @generated from protobuf field: string user_id = 3;
     */
    userId: string;
    /**
     * @generated from protobuf field: string refresh_token = 4;
     */
    refreshToken: string;
}
/**
 * @generated from protobuf message viam.app.v1.OAuthConfig
 */
export interface OAuthConfig {
    /**
     * @generated from protobuf field: viam.app.v1.ClientAuthentication client_authentication = 1;
     */
    clientAuthentication: ClientAuthentication;
    /**
     * @generated from protobuf field: viam.app.v1.PKCE pkce = 2;
     */
    pkce: PKCE;
    /**
     * @generated from protobuf field: viam.app.v1.URLValidation url_validation = 3;
     */
    urlValidation: URLValidation;
    /**
     * @generated from protobuf field: repeated string origin_uris = 4;
     */
    originUris: string[];
    /**
     * @generated from protobuf field: repeated string redirect_uris = 5;
     */
    redirectUris: string[];
    /**
     * @generated from protobuf field: string logout_uri = 6;
     */
    logoutUri: string;
    /**
     * @generated from protobuf field: repeated viam.app.v1.EnabledGrant enabled_grants = 7;
     */
    enabledGrants: EnabledGrant[];
    /**
     * @generated from protobuf field: string invite_redirect_uri = 8;
     */
    inviteRedirectUri: string;
}
/**
 * Branding and customization for app machine picker
 *
 * @generated from protobuf message viam.app.v1.GetAppBrandingRequest
 */
export interface GetAppBrandingRequest {
    /**
     * @generated from protobuf field: string public_namespace = 1;
     */
    publicNamespace: string;
    /**
     * @generated from protobuf field: string name = 2;
     */
    name: string;
}
/**
 * @generated from protobuf message viam.app.v1.TextOverrides
 */
export interface TextOverrides {
    /**
     * @generated from protobuf field: map<string, string> fields = 1;
     */
    fields: {
        [key: string]: string;
    };
}
/**
 * @generated from protobuf message viam.app.v1.GetAppBrandingResponse
 */
export interface GetAppBrandingResponse {
    /**
     * @generated from protobuf field: optional string logo_path = 1;
     */
    logoPath?: string;
    /**
     * @generated from protobuf field: map<string, viam.app.v1.TextOverrides> text_customizations = 2;
     */
    textCustomizations: {
        [key: string]: TextOverrides;
    };
    /**
     * @generated from protobuf field: repeated string fragment_ids = 3;
     */
    fragmentIds: string[];
    /**
     * @generated from protobuf field: repeated string allowed_org_ids = 4;
     */
    allowedOrgIds: string[];
}
/**
 * @generated from protobuf message viam.app.v1.AppCustomizations
 */
export interface AppCustomizations {
    /**
     * @generated from protobuf field: viam.app.v1.MachinePickerCustomizations machine_picker = 1;
     */
    machinePicker?: MachinePickerCustomizations;
}
/**
 * @generated from protobuf message viam.app.v1.MachinePickerCustomizations
 */
export interface MachinePickerCustomizations {
    /**
     * @generated from protobuf field: optional string heading = 1;
     */
    heading?: string;
    /**
     * @generated from protobuf field: optional string subheading = 2;
     */
    subheading?: string;
}
/**
 * @generated from protobuf message viam.app.v1.UploadDevicePushTokenRequest
 */
export interface UploadDevicePushTokenRequest {
    /**
     * @generated from protobuf field: string app_id = 1;
     */
    appId: string;
    /**
     * @generated from protobuf field: string device_token = 2;
     */
    deviceToken: string;
    /**
     * @generated from protobuf field: string device_uuid = 3;
     */
    deviceUuid: string;
}
/**
 * @generated from protobuf message viam.app.v1.UploadDevicePushTokenResponse
 */
export interface UploadDevicePushTokenResponse {
}
/**
 * @generated from protobuf message viam.app.v1.DeleteDevicePushTokenRequest
 */
export interface DeleteDevicePushTokenRequest {
    /**
     * @generated from protobuf field: string app_id = 1;
     */
    appId: string;
    /**
     * @generated from protobuf field: string device_uuid = 2;
     */
    deviceUuid: string;
}
/**
 * @generated from protobuf message viam.app.v1.DeleteDevicePushTokenResponse
 */
export interface DeleteDevicePushTokenResponse {
}
/**
 * @generated from protobuf message viam.app.v1.GetDevicePushTokensRequest
 */
export interface GetDevicePushTokensRequest {
    /**
     * @generated from protobuf field: string app_id = 1;
     */
    appId: string;
}
/**
 * @generated from protobuf message viam.app.v1.GetDevicePushTokensResponse
 */
export interface GetDevicePushTokensResponse {
    /**
     * @generated from protobuf field: repeated string device_tokens = 1;
     */
    deviceTokens: string[];
}
/**
 * @generated from protobuf message viam.app.v1.SetFirebaseConfigRequest
 */
export interface SetFirebaseConfigRequest {
    /**
     * @generated from protobuf field: string org_id = 1;
     */
    orgId: string;
    /**
     * @generated from protobuf field: string app_id = 2;
     */
    appId: string;
    /**
     * @generated from protobuf field: string config_json = 3;
     */
    configJson: string;
}
/**
 * @generated from protobuf message viam.app.v1.SetFirebaseConfigResponse
 */
export interface SetFirebaseConfigResponse {
}
/**
 * @generated from protobuf message viam.app.v1.GetFirebaseConfigRequest
 */
export interface GetFirebaseConfigRequest {
    /**
     * @generated from protobuf field: string org_id = 1;
     */
    orgId: string;
}
/**
 * @generated from protobuf message viam.app.v1.GetFirebaseConfigResponse
 */
export interface GetFirebaseConfigResponse {
    /**
     * @generated from protobuf field: string app_id = 1;
     */
    appId: string;
}
/**
 * @generated from protobuf message viam.app.v1.DeleteFirebaseConfigRequest
 */
export interface DeleteFirebaseConfigRequest {
    /**
     * @generated from protobuf field: string org_id = 1;
     */
    orgId: string;
    /**
     * @generated from protobuf field: string app_id = 2;
     */
    appId: string;
}
/**
 * @generated from protobuf message viam.app.v1.DeleteFirebaseConfigResponse
 */
export interface DeleteFirebaseConfigResponse {
}
/**
 * @generated from protobuf enum viam.app.v1.OnlineState
 */
export enum OnlineState {
    /**
     * @generated from protobuf enum value: ONLINE_STATE_UNSPECIFIED = 0;
     */
    UNSPECIFIED = 0,
    /**
     * @generated from protobuf enum value: ONLINE_STATE_ONLINE = 1;
     */
    ONLINE = 1,
    /**
     * @generated from protobuf enum value: ONLINE_STATE_OFFLINE = 2;
     */
    OFFLINE = 2,
    /**
     * @generated from protobuf enum value: ONLINE_STATE_AWAITING_SETUP = 3;
     */
    AWAITING_SETUP = 3
}
/**
 * @generated from protobuf enum viam.app.v1.AuthenticationType
 */
export enum AuthenticationType {
    /**
     * @generated from protobuf enum value: AUTHENTICATION_TYPE_UNSPECIFIED = 0;
     */
    UNSPECIFIED = 0,
    /**
     * @generated from protobuf enum value: AUTHENTICATION_TYPE_WEB_OAUTH = 1;
     */
    WEB_OAUTH = 1,
    /**
     * @generated from protobuf enum value: AUTHENTICATION_TYPE_API_KEY = 2;
     */
    API_KEY = 2,
    /**
     * @generated from protobuf enum value: AUTHENTICATION_TYPE_ROBOT_PART_SECRET = 3;
     */
    ROBOT_PART_SECRET = 3,
    /**
     * @generated from protobuf enum value: AUTHENTICATION_TYPE_LOCATION_SECRET = 4;
     */
    LOCATION_SECRET = 4
}
/**
 * LoginMethod is an interactive login mechanism an organization may allow.
 *
 * @generated from protobuf enum viam.app.v1.LoginMethod
 */
export enum LoginMethod {
    /**
     * @generated from protobuf enum value: LOGIN_METHOD_UNSPECIFIED = 0;
     */
    UNSPECIFIED = 0,
    /**
     * @generated from protobuf enum value: LOGIN_METHOD_PASSWORD = 1;
     */
    PASSWORD = 1,
    /**
     * @generated from protobuf enum value: LOGIN_METHOD_GOOGLE = 2;
     */
    GOOGLE = 2,
    /**
     * @generated from protobuf enum value: LOGIN_METHOD_GITHUB = 3;
     */
    GITHUB = 3,
    /**
     * @generated from protobuf enum value: LOGIN_METHOD_APPLE = 4;
     */
    APPLE = 4
}
/**
 * LogOrder is the order in which logs are returned, by time.
 *
 * @generated from protobuf enum viam.app.v1.LogOrder
 */
export enum LogOrder {
    /**
     * LOG_ORDER_UNSPECIFIED is treated as LOG_ORDER_DESCENDING.
     *
     * @generated from protobuf enum value: LOG_ORDER_UNSPECIFIED = 0;
     */
    UNSPECIFIED = 0,
    /**
     * oldest logs first
     *
     * @generated from protobuf enum value: LOG_ORDER_ASCENDING = 1;
     */
    ASCENDING = 1,
    /**
     * newest logs first
     *
     * @generated from protobuf enum value: LOG_ORDER_DESCENDING = 2;
     */
    DESCENDING = 2
}
/**
 * @generated from protobuf enum viam.app.v1.FragmentVisibility
 */
export enum FragmentVisibility {
    /**
     * @generated from protobuf enum value: FRAGMENT_VISIBILITY_UNSPECIFIED = 0;
     */
    UNSPECIFIED = 0,
    /**
     * @generated from protobuf enum value: FRAGMENT_VISIBILITY_PRIVATE = 1;
     */
    PRIVATE = 1,
    /**
     * @generated from protobuf enum value: FRAGMENT_VISIBILITY_PUBLIC = 2;
     */
    PUBLIC = 2,
    /**
     * @generated from protobuf enum value: FRAGMENT_VISIBILITY_PUBLIC_UNLISTED = 3;
     */
    PUBLIC_UNLISTED = 3
}
/**
 * @generated from protobuf enum viam.app.v1.FragmentErrorType
 */
export enum FragmentErrorType {
    /**
     * @generated from protobuf enum value: FRAGMENT_ERROR_TYPE_UNSPECIFIED = 0;
     */
    UNSPECIFIED = 0,
    /**
     * @generated from protobuf enum value: FRAGMENT_ERROR_TYPE_NO_ACCESS = 1;
     */
    NO_ACCESS = 1,
    /**
     * @generated from protobuf enum value: FRAGMENT_ERROR_TYPE_NESTING_LIMIT_EXCEEDED = 2;
     */
    NESTING_LIMIT_EXCEEDED = 2,
    /**
     * @generated from protobuf enum value: FRAGMENT_ERROR_TYPE_CHILD_ID_INVALID = 3;
     */
    CHILD_ID_INVALID = 3,
    /**
     * @generated from protobuf enum value: FRAGMENT_ERROR_TYPE_CYCLE_DETECTED = 4;
     */
    CYCLE_DETECTED = 4
}
/**
 * @generated from protobuf enum viam.app.v1.ModuleSourceType
 */
export enum ModuleSourceType {
    /**
     * @generated from protobuf enum value: MODULE_SOURCE_TYPE_UNSPECIFIED = 0;
     */
    UNSPECIFIED = 0,
    /**
     * Module source code is stored externally, such as in github.
     *
     * @generated from protobuf enum value: MODULE_SOURCE_TYPE_EXTERNAL = 1;
     */
    EXTERNAL = 1,
    /**
     * Module source code is versioned and managed within Viam.
     *
     * @generated from protobuf enum value: MODULE_SOURCE_TYPE_VIAM_HOSTED = 2;
     */
    VIAM_HOSTED = 2
}
/**
 * @generated from protobuf enum viam.app.v1.ModuleLanguage
 */
export enum ModuleLanguage {
    /**
     * @generated from protobuf enum value: MODULE_LANGUAGE_UNSPECIFIED = 0;
     */
    UNSPECIFIED = 0,
    /**
     * @generated from protobuf enum value: MODULE_LANGUAGE_GOLANG = 1;
     */
    GOLANG = 1,
    /**
     * @generated from protobuf enum value: MODULE_LANGUAGE_PYTHON = 2;
     */
    PYTHON = 2,
    /**
     * @generated from protobuf enum value: MODULE_LANGUAGE_CPP = 3;
     */
    CPP = 3
}
/**
 * @generated from protobuf enum viam.app.v1.RegistryItemStatus
 */
export enum RegistryItemStatus {
    /**
     * @generated from protobuf enum value: REGISTRY_ITEM_STATUS_UNSPECIFIED = 0;
     */
    UNSPECIFIED = 0,
    /**
     * @generated from protobuf enum value: REGISTRY_ITEM_STATUS_PUBLISHED = 1;
     */
    PUBLISHED = 1,
    /**
     * @generated from protobuf enum value: REGISTRY_ITEM_STATUS_IN_DEVELOPMENT = 2;
     */
    IN_DEVELOPMENT = 2
}
/**
 * @generated from protobuf enum viam.app.v1.Visibility
 */
export enum Visibility {
    /**
     * @generated from protobuf enum value: VISIBILITY_UNSPECIFIED = 0;
     */
    UNSPECIFIED = 0,
    /**
     * Private registry items are visible only within the owning org
     *
     * @generated from protobuf enum value: VISIBILITY_PRIVATE = 1;
     */
    PRIVATE = 1,
    /**
     * Public registry items are visible to everyone
     *
     * @generated from protobuf enum value: VISIBILITY_PUBLIC = 2;
     */
    PUBLIC = 2,
    /**
     * Public Unlisted registry items are usable in everyone's robot but are hidden from the registry page as if they are private
     *
     * @generated from protobuf enum value: VISIBILITY_PUBLIC_UNLISTED = 3;
     */
    PUBLIC_UNLISTED = 3
}
/**
 * @generated from protobuf enum viam.app.v1.AppType
 */
export enum AppType {
    /**
     * @generated from protobuf enum value: APP_TYPE_UNSPECIFIED = 0;
     */
    UNSPECIFIED = 0,
    /**
     * @generated from protobuf enum value: APP_TYPE_SINGLE_MACHINE = 1;
     */
    SINGLE_MACHINE = 1,
    /**
     * @generated from protobuf enum value: APP_TYPE_MULTI_MACHINE = 2;
     */
    MULTI_MACHINE = 2
}
/**
 * @generated from protobuf enum viam.app.v1.ClientAuthentication
 */
export enum ClientAuthentication {
    /**
     * @generated from protobuf enum value: CLIENT_AUTHENTICATION_UNSPECIFIED = 0;
     */
    UNSPECIFIED = 0,
    /**
     * @generated from protobuf enum value: CLIENT_AUTHENTICATION_REQUIRED = 1;
     */
    REQUIRED = 1,
    /**
     * @generated from protobuf enum value: CLIENT_AUTHENTICATION_NOT_REQUIRED = 2;
     */
    NOT_REQUIRED = 2,
    /**
     * @generated from protobuf enum value: CLIENT_AUTHENTICATION_NOT_REQUIRED_WHEN_USING_PKCE = 3;
     */
    NOT_REQUIRED_WHEN_USING_PKCE = 3
}
/**
 * @generated from protobuf enum viam.app.v1.PKCE
 */
export enum PKCE {
    /**
     * @generated from protobuf enum value: PKCE_UNSPECIFIED = 0;
     */
    PKCE_UNSPECIFIED = 0,
    /**
     * @generated from protobuf enum value: PKCE_REQUIRED = 1;
     */
    PKCE_REQUIRED = 1,
    /**
     * @generated from protobuf enum value: PKCE_NOT_REQUIRED = 2;
     */
    PKCE_NOT_REQUIRED = 2,
    /**
     * @generated from protobuf enum value: PKCE_NOT_REQUIRED_WHEN_USING_CLIENT_AUTHENTICATION = 3;
     */
    PKCE_NOT_REQUIRED_WHEN_USING_CLIENT_AUTHENTICATION = 3
}
/**
 * @generated from protobuf enum viam.app.v1.URLValidation
 */
export enum URLValidation {
    /**
     * @generated from protobuf enum value: URL_VALIDATION_UNSPECIFIED = 0;
     */
    URL_VALIDATION_UNSPECIFIED = 0,
    /**
     * @generated from protobuf enum value: URL_VALIDATION_EXACT_MATCH = 1;
     */
    URL_VALIDATION_EXACT_MATCH = 1,
    /**
     * @generated from protobuf enum value: URL_VALIDATION_ALLOW_WILDCARDS = 2;
     */
    URL_VALIDATION_ALLOW_WILDCARDS = 2
}
/**
 * @generated from protobuf enum viam.app.v1.EnabledGrant
 */
export enum EnabledGrant {
    /**
     * @generated from protobuf enum value: ENABLED_GRANT_UNSPECIFIED = 0;
     */
    UNSPECIFIED = 0,
    /**
     * @generated from protobuf enum value: ENABLED_GRANT_AUTHORIZATION_CODE = 1;
     */
    AUTHORIZATION_CODE = 1,
    /**
     * @generated from protobuf enum value: ENABLED_GRANT_IMPLICIT = 2;
     */
    IMPLICIT = 2,
    /**
     * @generated from protobuf enum value: ENABLED_GRANT_PASSWORD = 3;
     */
    PASSWORD = 3,
    /**
     * @generated from protobuf enum value: ENABLED_GRANT_REFRESH_TOKEN = 4;
     */
    REFRESH_TOKEN = 4,
    /**
     * @generated from protobuf enum value: ENABLED_GRANT_DEVICE_CODE = 5;
     */
    DEVICE_CODE = 5
}
// @generated message type with reflection information, may provide speed optimized methods
class Robot$Type extends MessageType<Robot> {
    constructor() {
        super("viam.app.v1.Robot", [
            { no: 1, name: "id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "tagger.v1.tags": "bson:\"_id\" json:\"id,omitempty\"" } },
            { no: 2, name: "name", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "tagger.v1.tags": "bson:\"name\" json:\"name\"" } },
            { no: 3, name: "location", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "tagger.v1.tags": "bson:\"location\" json:\"location\"" } },
            { no: 4, name: "last_access", kind: "message", T: () => Timestamp, options: { "tagger.v1.tags": "bson:\"last_access\" json:\"last_access\"" } },
            { no: 5, name: "created_on", kind: "message", T: () => Timestamp, options: { "tagger.v1.tags": "bson:\"created_on\"" } },
            { no: 6, name: "online_state", kind: "enum", T: () => ["viam.app.v1.OnlineState", OnlineState, "ONLINE_STATE_"], options: { "tagger.v1.tags": "bson:\"online_state\" json:\"online_state,omitempty\"" } },
            { no: 7, name: "seconds_since_online", kind: "scalar", T: 3 /*ScalarType.INT64*/, options: { "tagger.v1.tags": "bson:\"seconds_since_online\" json:\"seconds_since_online,omitempty\"" } }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message viam.app.v1.Robot
 */
export const Robot = new Robot$Type();
// @generated message type with reflection information, may provide speed optimized methods
class RobotPart$Type extends MessageType<RobotPart> {
    constructor() {
        super("viam.app.v1.RobotPart", [
            { no: 1, name: "id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "tagger.v1.tags": "bson:\"_id\" json:\"id,omitempty\"" } },
            { no: 2, name: "name", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "tagger.v1.tags": "bson:\"name\" json:\"name\"" } },
            { no: 10, name: "dns_name", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "tagger.v1.tags": "bson:\"dns_name\" json:\"dns_name\"" } },
            { no: 3, name: "secret", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "tagger.v1.tags": "bson:\"secret\" json:\"secret,omitempty\"" } },
            { no: 4, name: "robot", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "tagger.v1.tags": "bson:\"robot\" json:\"robot\"" } },
            { no: 12, name: "location_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "tagger.v1.tags": "bson:\"location_id\" json:\"-\"" } },
            { no: 5, name: "robot_config", kind: "message", T: () => Struct, options: { "tagger.v1.tags": "bson:\"config\" json:\"robot_config\"" } },
            { no: 6, name: "last_access", kind: "message", T: () => Timestamp, options: { "tagger.v1.tags": "bson:\"last_access\" json:\"last_access\"" } },
            { no: 7, name: "user_supplied_info", kind: "message", T: () => Struct, options: { "tagger.v1.tags": "bson:\"user_supplied_info\" json:\"user_supplied_info\"" } },
            { no: 8, name: "main_part", kind: "scalar", T: 8 /*ScalarType.BOOL*/, options: { "tagger.v1.tags": "bson:\"main_part\" json:\"main_part\"" } },
            { no: 9, name: "fqdn", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 11, name: "local_fqdn", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 13, name: "created_on", kind: "message", T: () => Timestamp, options: { "tagger.v1.tags": "bson:\"created_on\"" } },
            { no: 14, name: "secrets", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => SharedSecret, options: { "tagger.v1.tags": "bson:\"secrets\"" } },
            { no: 15, name: "last_updated", kind: "message", T: () => Timestamp, options: { "tagger.v1.tags": "bson:\"last_updated_at\"" } },
            { no: 16, name: "online_state", kind: "enum", T: () => ["viam.app.v1.OnlineState", OnlineState, "ONLINE_STATE_"], options: { "tagger.v1.tags": "bson:\"online_state\" json:\"online_state,omitempty\"" } },
            { no: 17, name: "seconds_since_online", kind: "scalar", T: 3 /*ScalarType.INT64*/, options: { "tagger.v1.tags": "bson:\"seconds_since_online\" json:\"seconds_since_online,omitempty\"" } },
            { no: 18, name: "robot_config_json", kind: "scalar", opt: true, T: 9 /*ScalarType.STRING*/, options: { "tagger.v1.tags": "bson:\"config_json,omitempty\" json:\"config_json,omitempty\"" } }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message viam.app.v1.RobotPart
 */
export const RobotPart = new RobotPart$Type();
// @generated message type with reflection information, may provide speed optimized methods
class RobotPartHistoryEntry$Type extends MessageType<RobotPartHistoryEntry> {
    constructor() {
        super("viam.app.v1.RobotPartHistoryEntry", [
            { no: 1, name: "part", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "tagger.v1.tags": "bson:\"part\" json:\"part\"" } },
            { no: 2, name: "robot", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "tagger.v1.tags": "bson:\"robot\" json:\"robot\"" } },
            { no: 3, name: "when", kind: "message", T: () => Timestamp, options: { "tagger.v1.tags": "bson:\"when\" json:\"when\"" } },
            { no: 4, name: "old", kind: "message", T: () => RobotPart, options: { "tagger.v1.tags": "bson:\"old\" json:\"old\"" } },
            { no: 5, name: "edited_by", kind: "message", T: () => AuthenticatorInfo, options: { "tagger.v1.tags": "bson:\"edited_by\" json:\"edited_by\"" } }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message viam.app.v1.RobotPartHistoryEntry
 */
export const RobotPartHistoryEntry = new RobotPartHistoryEntry$Type();
// @generated message type with reflection information, may provide speed optimized methods
class AuthenticatorInfo$Type extends MessageType<AuthenticatorInfo> {
    constructor() {
        super("viam.app.v1.AuthenticatorInfo", [
            { no: 1, name: "type", kind: "enum", T: () => ["viam.app.v1.AuthenticationType", AuthenticationType, "AUTHENTICATION_TYPE_"] },
            { no: 2, name: "value", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "is_deactivated", kind: "scalar", T: 8 /*ScalarType.BOOL*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message viam.app.v1.AuthenticatorInfo
 */
export const AuthenticatorInfo = new AuthenticatorInfo$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ListOrganizationsRequest$Type extends MessageType<ListOrganizationsRequest> {
    constructor() {
        super("viam.app.v1.ListOrganizationsRequest", []);
    }
}
/**
 * @generated MessageType for protobuf message viam.app.v1.ListOrganizationsRequest
 */
export const ListOrganizationsRequest = new ListOrganizationsRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class AllowedLoginMethods$Type extends MessageType<AllowedLoginMethods> {
    constructor() {
        super("viam.app.v1.AllowedLoginMethods", [
            { no: 1, name: "methods", kind: "enum", repeat: 1 /*RepeatType.PACKED*/, T: () => ["viam.app.v1.LoginMethod", LoginMethod, "LOGIN_METHOD_"] }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message viam.app.v1.AllowedLoginMethods
 */
export const AllowedLoginMethods = new AllowedLoginMethods$Type();
// @generated message type with reflection information, may provide speed optimized methods
class Organization$Type extends MessageType<Organization> {
    constructor() {
        super("viam.app.v1.Organization", [
            { no: 1, name: "id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "name", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "created_on", kind: "message", T: () => Timestamp },
            { no: 4, name: "public_namespace", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 5, name: "default_region", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 6, name: "cid", kind: "scalar", opt: true, T: 9 /*ScalarType.STRING*/ },
            { no: 7, name: "default_fragments", kind: "message", T: () => FragmentImportList },
            { no: 8, name: "allowed_login_methods", kind: "message", T: () => AllowedLoginMethods }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message viam.app.v1.Organization
 */
export const Organization = new Organization$Type();
// @generated message type with reflection information, may provide speed optimized methods
class OrganizationMember$Type extends MessageType<OrganizationMember> {
    constructor() {
        super("viam.app.v1.OrganizationMember", [
            { no: 1, name: "user_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "emails", kind: "scalar", repeat: 2 /*RepeatType.UNPACKED*/, T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "date_added", kind: "message", T: () => Timestamp },
            { no: 4, name: "last_login", kind: "message", T: () => Timestamp },
            { no: 5, name: "last_access", kind: "message", T: () => Timestamp }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message viam.app.v1.OrganizationMember
 */
export const OrganizationMember = new OrganizationMember$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ListOrganizationsResponse$Type extends MessageType<ListOrganizationsResponse> {
    constructor() {
        super("viam.app.v1.ListOrganizationsResponse", [
            { no: 1, name: "organizations", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => Organization }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message viam.app.v1.ListOrganizationsResponse
 */
export const ListOrganizationsResponse = new ListOrganizationsResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class OrganizationInvite$Type extends MessageType<OrganizationInvite> {
    constructor() {
        super("viam.app.v1.OrganizationInvite", [
            { no: 1, name: "organization_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "email", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "created_on", kind: "message", T: () => Timestamp },
            { no: 4, name: "authorizations", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => Authorization }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message viam.app.v1.OrganizationInvite
 */
export const OrganizationInvite = new OrganizationInvite$Type();
// @generated message type with reflection information, may provide speed optimized methods
class CreateOrganizationRequest$Type extends MessageType<CreateOrganizationRequest> {
    constructor() {
        super("viam.app.v1.CreateOrganizationRequest", [
            { no: 1, name: "name", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message viam.app.v1.CreateOrganizationRequest
 */
export const CreateOrganizationRequest = new CreateOrganizationRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class CreateOrganizationResponse$Type extends MessageType<CreateOrganizationResponse> {
    constructor() {
        super("viam.app.v1.CreateOrganizationResponse", [
            { no: 1, name: "organization", kind: "message", T: () => Organization }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message viam.app.v1.CreateOrganizationResponse
 */
export const CreateOrganizationResponse = new CreateOrganizationResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GetOrganizationRequest$Type extends MessageType<GetOrganizationRequest> {
    constructor() {
        super("viam.app.v1.GetOrganizationRequest", [
            { no: 1, name: "organization_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message viam.app.v1.GetOrganizationRequest
 */
export const GetOrganizationRequest = new GetOrganizationRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GetOrganizationResponse$Type extends MessageType<GetOrganizationResponse> {
    constructor() {
        super("viam.app.v1.GetOrganizationResponse", [
            { no: 1, name: "organization", kind: "message", T: () => Organization }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message viam.app.v1.GetOrganizationResponse
 */
export const GetOrganizationResponse = new GetOrganizationResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GetOrganizationNamespaceAvailabilityRequest$Type extends MessageType<GetOrganizationNamespaceAvailabilityRequest> {
    constructor() {
        super("viam.app.v1.GetOrganizationNamespaceAvailabilityRequest", [
            { no: 1, name: "public_namespace", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "organization_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message viam.app.v1.GetOrganizationNamespaceAvailabilityRequest
 */
export const GetOrganizationNamespaceAvailabilityRequest = new GetOrganizationNamespaceAvailabilityRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GetOrganizationNamespaceAvailabilityResponse$Type extends MessageType<GetOrganizationNamespaceAvailabilityResponse> {
    constructor() {
        super("viam.app.v1.GetOrganizationNamespaceAvailabilityResponse", [
            { no: 1, name: "available", kind: "scalar", T: 8 /*ScalarType.BOOL*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message viam.app.v1.GetOrganizationNamespaceAvailabilityResponse
 */
export const GetOrganizationNamespaceAvailabilityResponse = new GetOrganizationNamespaceAvailabilityResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class FragmentImportList$Type extends MessageType<FragmentImportList> {
    constructor() {
        super("viam.app.v1.FragmentImportList", [
            { no: 1, name: "fragments", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => FragmentImport }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message viam.app.v1.FragmentImportList
 */
export const FragmentImportList = new FragmentImportList$Type();
// @generated message type with reflection information, may provide speed optimized methods
class UpdateOrganizationRequest$Type extends MessageType<UpdateOrganizationRequest> {
    constructor() {
        super("viam.app.v1.UpdateOrganizationRequest", [
            { no: 1, name: "organization_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "name", kind: "scalar", opt: true, T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "public_namespace", kind: "scalar", opt: true, T: 9 /*ScalarType.STRING*/ },
            { no: 4, name: "region", kind: "scalar", opt: true, T: 9 /*ScalarType.STRING*/ },
            { no: 5, name: "cid", kind: "scalar", opt: true, T: 9 /*ScalarType.STRING*/ },
            { no: 6, name: "default_fragments", kind: "message", T: () => FragmentImportList },
            { no: 7, name: "allowed_login_methods", kind: "message", T: () => AllowedLoginMethods }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message viam.app.v1.UpdateOrganizationRequest
 */
export const UpdateOrganizationRequest = new UpdateOrganizationRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class UpdateOrganizationResponse$Type extends MessageType<UpdateOrganizationResponse> {
    constructor() {
        super("viam.app.v1.UpdateOrganizationResponse", [
            { no: 1, name: "organization", kind: "message", T: () => Organization }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message viam.app.v1.UpdateOrganizationResponse
 */
export const UpdateOrganizationResponse = new UpdateOrganizationResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class UpdateOrganizationNamespaceRequest$Type extends MessageType<UpdateOrganizationNamespaceRequest> {
    constructor() {
        super("viam.app.v1.UpdateOrganizationNamespaceRequest", [
            { no: 1, name: "organization_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "new_public_namespace", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message viam.app.v1.UpdateOrganizationNamespaceRequest
 */
export const UpdateOrganizationNamespaceRequest = new UpdateOrganizationNamespaceRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class UpdateOrganizationNamespaceResponse$Type extends MessageType<UpdateOrganizationNamespaceResponse> {
    constructor() {
        super("viam.app.v1.UpdateOrganizationNamespaceResponse", [
            { no: 1, name: "organization", kind: "message", T: () => Organization }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message viam.app.v1.UpdateOrganizationNamespaceResponse
 */
export const UpdateOrganizationNamespaceResponse = new UpdateOrganizationNamespaceResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class DeleteOrganizationRequest$Type extends MessageType<DeleteOrganizationRequest> {
    constructor() {
        super("viam.app.v1.DeleteOrganizationRequest", [
            { no: 1, name: "organization_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message viam.app.v1.DeleteOrganizationRequest
 */
export const DeleteOrganizationRequest = new DeleteOrganizationRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class DeleteOrganizationResponse$Type extends MessageType<DeleteOrganizationResponse> {
    constructor() {
        super("viam.app.v1.DeleteOrganizationResponse", []);
    }
}
/**
 * @generated MessageType for protobuf message viam.app.v1.DeleteOrganizationResponse
 */
export const DeleteOrganizationResponse = new DeleteOrganizationResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GetOrganizationMetadataRequest$Type extends MessageType<GetOrganizationMetadataRequest> {
    constructor() {
        super("viam.app.v1.GetOrganizationMetadataRequest", [
            { no: 1, name: "organization_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message viam.app.v1.GetOrganizationMetadataRequest
 */
export const GetOrganizationMetadataRequest = new GetOrganizationMetadataRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GetOrganizationMetadataResponse$Type extends MessageType<GetOrganizationMetadataResponse> {
    constructor() {
        super("viam.app.v1.GetOrganizationMetadataResponse", [
            { no: 1, name: "data", kind: "message", T: () => Struct }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message viam.app.v1.GetOrganizationMetadataResponse
 */
export const GetOrganizationMetadataResponse = new GetOrganizationMetadataResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class UpdateOrganizationMetadataRequest$Type extends MessageType<UpdateOrganizationMetadataRequest> {
    constructor() {
        super("viam.app.v1.UpdateOrganizationMetadataRequest", [
            { no: 1, name: "organization_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "data", kind: "message", T: () => Struct }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message viam.app.v1.UpdateOrganizationMetadataRequest
 */
export const UpdateOrganizationMetadataRequest = new UpdateOrganizationMetadataRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class UpdateOrganizationMetadataResponse$Type extends MessageType<UpdateOrganizationMetadataResponse> {
    constructor() {
        super("viam.app.v1.UpdateOrganizationMetadataResponse", []);
    }
}
/**
 * @generated MessageType for protobuf message viam.app.v1.UpdateOrganizationMetadataResponse
 */
export const UpdateOrganizationMetadataResponse = new UpdateOrganizationMetadataResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ListOrganizationMembersRequest$Type extends MessageType<ListOrganizationMembersRequest> {
    constructor() {
        super("viam.app.v1.ListOrganizationMembersRequest", [
            { no: 1, name: "organization_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message viam.app.v1.ListOrganizationMembersRequest
 */
export const ListOrganizationMembersRequest = new ListOrganizationMembersRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ListOrganizationMembersResponse$Type extends MessageType<ListOrganizationMembersResponse> {
    constructor() {
        super("viam.app.v1.ListOrganizationMembersResponse", [
            { no: 1, name: "organization_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "members", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => OrganizationMember },
            { no: 3, name: "invites", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => OrganizationInvite }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message viam.app.v1.ListOrganizationMembersResponse
 */
export const ListOrganizationMembersResponse = new ListOrganizationMembersResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class CreateOrganizationInviteRequest$Type extends MessageType<CreateOrganizationInviteRequest> {
    constructor() {
        super("viam.app.v1.CreateOrganizationInviteRequest", [
            { no: 1, name: "organization_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "email", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "authorizations", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => Authorization },
            { no: 4, name: "send_email_invite", kind: "scalar", opt: true, T: 8 /*ScalarType.BOOL*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message viam.app.v1.CreateOrganizationInviteRequest
 */
export const CreateOrganizationInviteRequest = new CreateOrganizationInviteRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class CreateOrganizationInviteResponse$Type extends MessageType<CreateOrganizationInviteResponse> {
    constructor() {
        super("viam.app.v1.CreateOrganizationInviteResponse", [
            { no: 1, name: "invite", kind: "message", T: () => OrganizationInvite }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message viam.app.v1.CreateOrganizationInviteResponse
 */
export const CreateOrganizationInviteResponse = new CreateOrganizationInviteResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class UpdateOrganizationInviteAuthorizationsRequest$Type extends MessageType<UpdateOrganizationInviteAuthorizationsRequest> {
    constructor() {
        super("viam.app.v1.UpdateOrganizationInviteAuthorizationsRequest", [
            { no: 1, name: "organization_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "email", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "add_authorizations", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => Authorization },
            { no: 4, name: "remove_authorizations", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => Authorization }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message viam.app.v1.UpdateOrganizationInviteAuthorizationsRequest
 */
export const UpdateOrganizationInviteAuthorizationsRequest = new UpdateOrganizationInviteAuthorizationsRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class UpdateOrganizationInviteAuthorizationsResponse$Type extends MessageType<UpdateOrganizationInviteAuthorizationsResponse> {
    constructor() {
        super("viam.app.v1.UpdateOrganizationInviteAuthorizationsResponse", [
            { no: 1, name: "invite", kind: "message", T: () => OrganizationInvite }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message viam.app.v1.UpdateOrganizationInviteAuthorizationsResponse
 */
export const UpdateOrganizationInviteAuthorizationsResponse = new UpdateOrganizationInviteAuthorizationsResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class DeleteOrganizationInviteRequest$Type extends MessageType<DeleteOrganizationInviteRequest> {
    constructor() {
        super("viam.app.v1.DeleteOrganizationInviteRequest", [
            { no: 1, name: "organization_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "email", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message viam.app.v1.DeleteOrganizationInviteRequest
 */
export const DeleteOrganizationInviteRequest = new DeleteOrganizationInviteRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class DeleteOrganizationInviteResponse$Type extends MessageType<DeleteOrganizationInviteResponse> {
    constructor() {
        super("viam.app.v1.DeleteOrganizationInviteResponse", []);
    }
}
/**
 * @generated MessageType for protobuf message viam.app.v1.DeleteOrganizationInviteResponse
 */
export const DeleteOrganizationInviteResponse = new DeleteOrganizationInviteResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ResendOrganizationInviteRequest$Type extends MessageType<ResendOrganizationInviteRequest> {
    constructor() {
        super("viam.app.v1.ResendOrganizationInviteRequest", [
            { no: 1, name: "organization_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "email", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "send_email_invite", kind: "scalar", opt: true, T: 8 /*ScalarType.BOOL*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message viam.app.v1.ResendOrganizationInviteRequest
 */
export const ResendOrganizationInviteRequest = new ResendOrganizationInviteRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ResendOrganizationInviteResponse$Type extends MessageType<ResendOrganizationInviteResponse> {
    constructor() {
        super("viam.app.v1.ResendOrganizationInviteResponse", [
            { no: 1, name: "invite", kind: "message", T: () => OrganizationInvite }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message viam.app.v1.ResendOrganizationInviteResponse
 */
export const ResendOrganizationInviteResponse = new ResendOrganizationInviteResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class DeleteOrganizationMemberRequest$Type extends MessageType<DeleteOrganizationMemberRequest> {
    constructor() {
        super("viam.app.v1.DeleteOrganizationMemberRequest", [
            { no: 1, name: "organization_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "user_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message viam.app.v1.DeleteOrganizationMemberRequest
 */
export const DeleteOrganizationMemberRequest = new DeleteOrganizationMemberRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class DeleteOrganizationMemberResponse$Type extends MessageType<DeleteOrganizationMemberResponse> {
    constructor() {
        super("viam.app.v1.DeleteOrganizationMemberResponse", []);
    }
}
/**
 * @generated MessageType for protobuf message viam.app.v1.DeleteOrganizationMemberResponse
 */
export const DeleteOrganizationMemberResponse = new DeleteOrganizationMemberResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class BillingAddress$Type extends MessageType<BillingAddress> {
    constructor() {
        super("viam.app.v1.BillingAddress", [
            { no: 1, name: "address_line_1", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "address_line_2", kind: "scalar", opt: true, T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "city", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 4, name: "state", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 5, name: "zipcode", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 6, name: "country", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message viam.app.v1.BillingAddress
 */
export const BillingAddress = new BillingAddress$Type();
// @generated message type with reflection information, may provide speed optimized methods
class EnableBillingServiceRequest$Type extends MessageType<EnableBillingServiceRequest> {
    constructor() {
        super("viam.app.v1.EnableBillingServiceRequest", [
            { no: 1, name: "org_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "billing_address", kind: "message", T: () => BillingAddress }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message viam.app.v1.EnableBillingServiceRequest
 */
export const EnableBillingServiceRequest = new EnableBillingServiceRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class EnableBillingServiceResponse$Type extends MessageType<EnableBillingServiceResponse> {
    constructor() {
        super("viam.app.v1.EnableBillingServiceResponse", []);
    }
}
/**
 * @generated MessageType for protobuf message viam.app.v1.EnableBillingServiceResponse
 */
export const EnableBillingServiceResponse = new EnableBillingServiceResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class UpdateBillingServiceRequest$Type extends MessageType<UpdateBillingServiceRequest> {
    constructor() {
        super("viam.app.v1.UpdateBillingServiceRequest", [
            { no: 1, name: "org_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "billing_address", kind: "message", T: () => BillingAddress }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message viam.app.v1.UpdateBillingServiceRequest
 */
export const UpdateBillingServiceRequest = new UpdateBillingServiceRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class UpdateBillingServiceResponse$Type extends MessageType<UpdateBillingServiceResponse> {
    constructor() {
        super("viam.app.v1.UpdateBillingServiceResponse", []);
    }
}
/**
 * @generated MessageType for protobuf message viam.app.v1.UpdateBillingServiceResponse
 */
export const UpdateBillingServiceResponse = new UpdateBillingServiceResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GetBillingServiceConfigRequest$Type extends MessageType<GetBillingServiceConfigRequest> {
    constructor() {
        super("viam.app.v1.GetBillingServiceConfigRequest", [
            { no: 1, name: "org_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message viam.app.v1.GetBillingServiceConfigRequest
 */
export const GetBillingServiceConfigRequest = new GetBillingServiceConfigRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GetBillingServiceConfigResponse$Type extends MessageType<GetBillingServiceConfigResponse> {
    constructor() {
        super("viam.app.v1.GetBillingServiceConfigResponse", [
            { no: 1, name: "billing_address", kind: "message", T: () => BillingAddress },
            { no: 2, name: "support_email", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "logo_url", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 4, name: "billing_dashboard_url", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message viam.app.v1.GetBillingServiceConfigResponse
 */
export const GetBillingServiceConfigResponse = new GetBillingServiceConfigResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class DisableBillingServiceRequest$Type extends MessageType<DisableBillingServiceRequest> {
    constructor() {
        super("viam.app.v1.DisableBillingServiceRequest", [
            { no: 1, name: "org_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message viam.app.v1.DisableBillingServiceRequest
 */
export const DisableBillingServiceRequest = new DisableBillingServiceRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class DisableBillingServiceResponse$Type extends MessageType<DisableBillingServiceResponse> {
    constructor() {
        super("viam.app.v1.DisableBillingServiceResponse", []);
    }
}
/**
 * @generated MessageType for protobuf message viam.app.v1.DisableBillingServiceResponse
 */
export const DisableBillingServiceResponse = new DisableBillingServiceResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class OrganizationSetSupportEmailRequest$Type extends MessageType<OrganizationSetSupportEmailRequest> {
    constructor() {
        super("viam.app.v1.OrganizationSetSupportEmailRequest", [
            { no: 1, name: "org_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "email", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message viam.app.v1.OrganizationSetSupportEmailRequest
 */
export const OrganizationSetSupportEmailRequest = new OrganizationSetSupportEmailRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class OrganizationSetSupportEmailResponse$Type extends MessageType<OrganizationSetSupportEmailResponse> {
    constructor() {
        super("viam.app.v1.OrganizationSetSupportEmailResponse", []);
    }
}
/**
 * @generated MessageType for protobuf message viam.app.v1.OrganizationSetSupportEmailResponse
 */
export const OrganizationSetSupportEmailResponse = new OrganizationSetSupportEmailResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class OrganizationGetSupportEmailRequest$Type extends MessageType<OrganizationGetSupportEmailRequest> {
    constructor() {
        super("viam.app.v1.OrganizationGetSupportEmailRequest", [
            { no: 1, name: "org_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message viam.app.v1.OrganizationGetSupportEmailRequest
 */
export const OrganizationGetSupportEmailRequest = new OrganizationGetSupportEmailRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class OrganizationGetSupportEmailResponse$Type extends MessageType<OrganizationGetSupportEmailResponse> {
    constructor() {
        super("viam.app.v1.OrganizationGetSupportEmailResponse", [
            { no: 1, name: "email", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message viam.app.v1.OrganizationGetSupportEmailResponse
 */
export const OrganizationGetSupportEmailResponse = new OrganizationGetSupportEmailResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class OrganizationIdentity$Type extends MessageType<OrganizationIdentity> {
    constructor() {
        super("viam.app.v1.OrganizationIdentity", [
            { no: 1, name: "id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "name", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message viam.app.v1.OrganizationIdentity
 */
export const OrganizationIdentity = new OrganizationIdentity$Type();
// @generated message type with reflection information, may provide speed optimized methods
class LocationOrganization$Type extends MessageType<LocationOrganization> {
    constructor() {
        super("viam.app.v1.LocationOrganization", [
            { no: 1, name: "organization_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "primary", kind: "scalar", T: 8 /*ScalarType.BOOL*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message viam.app.v1.LocationOrganization
 */
export const LocationOrganization = new LocationOrganization$Type();
// @generated message type with reflection information, may provide speed optimized methods
class LocationAuth$Type extends MessageType<LocationAuth> {
    constructor() {
        super("viam.app.v1.LocationAuth", [
            { no: 1, name: "secret", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "location_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "secrets", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => SharedSecret }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message viam.app.v1.LocationAuth
 */
export const LocationAuth = new LocationAuth$Type();
// @generated message type with reflection information, may provide speed optimized methods
class StorageConfig$Type extends MessageType<StorageConfig> {
    constructor() {
        super("viam.app.v1.StorageConfig", [
            { no: 1, name: "region", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message viam.app.v1.StorageConfig
 */
export const StorageConfig = new StorageConfig$Type();
// @generated message type with reflection information, may provide speed optimized methods
class Location$Type extends MessageType<Location> {
    constructor() {
        super("viam.app.v1.Location", [
            { no: 1, name: "id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "name", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 4, name: "parent_location_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 5, name: "auth", kind: "message", T: () => LocationAuth },
            { no: 6, name: "organizations", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => LocationOrganization },
            { no: 3, name: "created_on", kind: "message", T: () => Timestamp },
            { no: 7, name: "robot_count", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 8, name: "config", kind: "message", T: () => StorageConfig },
            { no: 9, name: "primary_org_identity", kind: "message", T: () => OrganizationIdentity }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message viam.app.v1.Location
 */
export const Location = new Location$Type();
// @generated message type with reflection information, may provide speed optimized methods
class SharedSecret$Type extends MessageType<SharedSecret> {
    constructor() {
        super("viam.app.v1.SharedSecret", [
            { no: 1, name: "id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "tagger.v1.tags": "bson:\"id\"" } },
            { no: 2, name: "secret", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "tagger.v1.tags": "bson:\"secret\"" } },
            { no: 3, name: "created_on", kind: "message", T: () => Timestamp, options: { "tagger.v1.tags": "bson:\"created_on\" json:\"created_on\"" } },
            { no: 4, name: "state", kind: "enum", T: () => ["viam.app.v1.SharedSecret.State", SharedSecret_State, "STATE_"], options: { "tagger.v1.tags": "bson:\"state\"" } }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message viam.app.v1.SharedSecret
 */
export const SharedSecret = new SharedSecret$Type();
// @generated message type with reflection information, may provide speed optimized methods
class CreateLocationRequest$Type extends MessageType<CreateLocationRequest> {
    constructor() {
        super("viam.app.v1.CreateLocationRequest", [
            { no: 1, name: "organization_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "name", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "parent_location_id", kind: "scalar", opt: true, T: 9 /*ScalarType.STRING*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message viam.app.v1.CreateLocationRequest
 */
export const CreateLocationRequest = new CreateLocationRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class CreateLocationResponse$Type extends MessageType<CreateLocationResponse> {
    constructor() {
        super("viam.app.v1.CreateLocationResponse", [
            { no: 1, name: "location", kind: "message", T: () => Location }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message viam.app.v1.CreateLocationResponse
 */
export const CreateLocationResponse = new CreateLocationResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GetLocationRequest$Type extends MessageType<GetLocationRequest> {
    constructor() {
        super("viam.app.v1.GetLocationRequest", [
            { no: 1, name: "location_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message viam.app.v1.GetLocationRequest
 */
export const GetLocationRequest = new GetLocationRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GetLocationResponse$Type extends MessageType<GetLocationResponse> {
    constructor() {
        super("viam.app.v1.GetLocationResponse", [
            { no: 1, name: "location", kind: "message", T: () => Location }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message viam.app.v1.GetLocationResponse
 */
export const GetLocationResponse = new GetLocationResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class UpdateLocationRequest$Type extends MessageType<UpdateLocationRequest> {
    constructor() {
        super("viam.app.v1.UpdateLocationRequest", [
            { no: 1, name: "location_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "name", kind: "scalar", opt: true, T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "parent_location_id", kind: "scalar", opt: true, T: 9 /*ScalarType.STRING*/ },
            { no: 4, name: "region", kind: "scalar", opt: true, T: 9 /*ScalarType.STRING*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message viam.app.v1.UpdateLocationRequest
 */
export const UpdateLocationRequest = new UpdateLocationRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class UpdateLocationResponse$Type extends MessageType<UpdateLocationResponse> {
    constructor() {
        super("viam.app.v1.UpdateLocationResponse", [
            { no: 1, name: "location", kind: "message", T: () => Location }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message viam.app.v1.UpdateLocationResponse
 */
export const UpdateLocationResponse = new UpdateLocationResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class DeleteLocationRequest$Type extends MessageType<DeleteLocationRequest> {
    constructor() {
        super("viam.app.v1.DeleteLocationRequest", [
            { no: 1, name: "location_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message viam.app.v1.DeleteLocationRequest
 */
export const DeleteLocationRequest = new DeleteLocationRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class DeleteLocationResponse$Type extends MessageType<DeleteLocationResponse> {
    constructor() {
        super("viam.app.v1.DeleteLocationResponse", []);
    }
}
/**
 * @generated MessageType for protobuf message viam.app.v1.DeleteLocationResponse
 */
export const DeleteLocationResponse = new DeleteLocationResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GetLocationMetadataRequest$Type extends MessageType<GetLocationMetadataRequest> {
    constructor() {
        super("viam.app.v1.GetLocationMetadataRequest", [
            { no: 1, name: "location_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message viam.app.v1.GetLocationMetadataRequest
 */
export const GetLocationMetadataRequest = new GetLocationMetadataRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GetLocationMetadataResponse$Type extends MessageType<GetLocationMetadataResponse> {
    constructor() {
        super("viam.app.v1.GetLocationMetadataResponse", [
            { no: 1, name: "data", kind: "message", T: () => Struct }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message viam.app.v1.GetLocationMetadataResponse
 */
export const GetLocationMetadataResponse = new GetLocationMetadataResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class UpdateLocationMetadataRequest$Type extends MessageType<UpdateLocationMetadataRequest> {
    constructor() {
        super("viam.app.v1.UpdateLocationMetadataRequest", [
            { no: 1, name: "location_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "data", kind: "message", T: () => Struct }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message viam.app.v1.UpdateLocationMetadataRequest
 */
export const UpdateLocationMetadataRequest = new UpdateLocationMetadataRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class UpdateLocationMetadataResponse$Type extends MessageType<UpdateLocationMetadataResponse> {
    constructor() {
        super("viam.app.v1.UpdateLocationMetadataResponse", []);
    }
}
/**
 * @generated MessageType for protobuf message viam.app.v1.UpdateLocationMetadataResponse
 */
export const UpdateLocationMetadataResponse = new UpdateLocationMetadataResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GetOrganizationsWithAccessToLocationRequest$Type extends MessageType<GetOrganizationsWithAccessToLocationRequest> {
    constructor() {
        super("viam.app.v1.GetOrganizationsWithAccessToLocationRequest", [
            { no: 1, name: "location_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message viam.app.v1.GetOrganizationsWithAccessToLocationRequest
 */
export const GetOrganizationsWithAccessToLocationRequest = new GetOrganizationsWithAccessToLocationRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GetOrganizationsWithAccessToLocationResponse$Type extends MessageType<GetOrganizationsWithAccessToLocationResponse> {
    constructor() {
        super("viam.app.v1.GetOrganizationsWithAccessToLocationResponse", [
            { no: 1, name: "organization_identities", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => OrganizationIdentity }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message viam.app.v1.GetOrganizationsWithAccessToLocationResponse
 */
export const GetOrganizationsWithAccessToLocationResponse = new GetOrganizationsWithAccessToLocationResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ListLocationsRequest$Type extends MessageType<ListLocationsRequest> {
    constructor() {
        super("viam.app.v1.ListLocationsRequest", [
            { no: 1, name: "organization_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message viam.app.v1.ListLocationsRequest
 */
export const ListLocationsRequest = new ListLocationsRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ShareLocationRequest$Type extends MessageType<ShareLocationRequest> {
    constructor() {
        super("viam.app.v1.ShareLocationRequest", [
            { no: 1, name: "location_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "organization_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message viam.app.v1.ShareLocationRequest
 */
export const ShareLocationRequest = new ShareLocationRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ShareLocationResponse$Type extends MessageType<ShareLocationResponse> {
    constructor() {
        super("viam.app.v1.ShareLocationResponse", []);
    }
}
/**
 * @generated MessageType for protobuf message viam.app.v1.ShareLocationResponse
 */
export const ShareLocationResponse = new ShareLocationResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class UnshareLocationRequest$Type extends MessageType<UnshareLocationRequest> {
    constructor() {
        super("viam.app.v1.UnshareLocationRequest", [
            { no: 1, name: "location_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "organization_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message viam.app.v1.UnshareLocationRequest
 */
export const UnshareLocationRequest = new UnshareLocationRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class UnshareLocationResponse$Type extends MessageType<UnshareLocationResponse> {
    constructor() {
        super("viam.app.v1.UnshareLocationResponse", []);
    }
}
/**
 * @generated MessageType for protobuf message viam.app.v1.UnshareLocationResponse
 */
export const UnshareLocationResponse = new UnshareLocationResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ListLocationsResponse$Type extends MessageType<ListLocationsResponse> {
    constructor() {
        super("viam.app.v1.ListLocationsResponse", [
            { no: 1, name: "locations", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => Location }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message viam.app.v1.ListLocationsResponse
 */
export const ListLocationsResponse = new ListLocationsResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class CreateLocationSecretRequest$Type extends MessageType<CreateLocationSecretRequest> {
    constructor() {
        super("viam.app.v1.CreateLocationSecretRequest", [
            { no: 1, name: "location_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message viam.app.v1.CreateLocationSecretRequest
 */
export const CreateLocationSecretRequest = new CreateLocationSecretRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class CreateLocationSecretResponse$Type extends MessageType<CreateLocationSecretResponse> {
    constructor() {
        super("viam.app.v1.CreateLocationSecretResponse", [
            { no: 1, name: "auth", kind: "message", T: () => LocationAuth }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message viam.app.v1.CreateLocationSecretResponse
 */
export const CreateLocationSecretResponse = new CreateLocationSecretResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class DeleteLocationSecretRequest$Type extends MessageType<DeleteLocationSecretRequest> {
    constructor() {
        super("viam.app.v1.DeleteLocationSecretRequest", [
            { no: 1, name: "location_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "secret_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message viam.app.v1.DeleteLocationSecretRequest
 */
export const DeleteLocationSecretRequest = new DeleteLocationSecretRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class DeleteLocationSecretResponse$Type extends MessageType<DeleteLocationSecretResponse> {
    constructor() {
        super("viam.app.v1.DeleteLocationSecretResponse", []);
    }
}
/**
 * @generated MessageType for protobuf message viam.app.v1.DeleteLocationSecretResponse
 */
export const DeleteLocationSecretResponse = new DeleteLocationSecretResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class LocationAuthRequest$Type extends MessageType<LocationAuthRequest> {
    constructor() {
        super("viam.app.v1.LocationAuthRequest", [
            { no: 1, name: "location_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message viam.app.v1.LocationAuthRequest
 */
export const LocationAuthRequest = new LocationAuthRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class LocationAuthResponse$Type extends MessageType<LocationAuthResponse> {
    constructor() {
        super("viam.app.v1.LocationAuthResponse", [
            { no: 1, name: "auth", kind: "message", T: () => LocationAuth }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message viam.app.v1.LocationAuthResponse
 */
export const LocationAuthResponse = new LocationAuthResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GetRobotRequest$Type extends MessageType<GetRobotRequest> {
    constructor() {
        super("viam.app.v1.GetRobotRequest", [
            { no: 1, name: "id", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message viam.app.v1.GetRobotRequest
 */
export const GetRobotRequest = new GetRobotRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GetRoverRentalRobotsRequest$Type extends MessageType<GetRoverRentalRobotsRequest> {
    constructor() {
        super("viam.app.v1.GetRoverRentalRobotsRequest", [
            { no: 1, name: "org_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message viam.app.v1.GetRoverRentalRobotsRequest
 */
export const GetRoverRentalRobotsRequest = new GetRoverRentalRobotsRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class RoverRentalRobot$Type extends MessageType<RoverRentalRobot> {
    constructor() {
        super("viam.app.v1.RoverRentalRobot", [
            { no: 1, name: "robot_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "location_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "robot_name", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 4, name: "robot_main_part_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message viam.app.v1.RoverRentalRobot
 */
export const RoverRentalRobot = new RoverRentalRobot$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GetRoverRentalRobotsResponse$Type extends MessageType<GetRoverRentalRobotsResponse> {
    constructor() {
        super("viam.app.v1.GetRoverRentalRobotsResponse", [
            { no: 1, name: "robots", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => RoverRentalRobot }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message viam.app.v1.GetRoverRentalRobotsResponse
 */
export const GetRoverRentalRobotsResponse = new GetRoverRentalRobotsResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GetRobotResponse$Type extends MessageType<GetRobotResponse> {
    constructor() {
        super("viam.app.v1.GetRobotResponse", [
            { no: 1, name: "robot", kind: "message", T: () => Robot }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message viam.app.v1.GetRobotResponse
 */
export const GetRobotResponse = new GetRobotResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GetRobotPartsRequest$Type extends MessageType<GetRobotPartsRequest> {
    constructor() {
        super("viam.app.v1.GetRobotPartsRequest", [
            { no: 1, name: "robot_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message viam.app.v1.GetRobotPartsRequest
 */
export const GetRobotPartsRequest = new GetRobotPartsRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GetRobotPartsResponse$Type extends MessageType<GetRobotPartsResponse> {
    constructor() {
        super("viam.app.v1.GetRobotPartsResponse", [
            { no: 1, name: "parts", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => RobotPart }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message viam.app.v1.GetRobotPartsResponse
 */
export const GetRobotPartsResponse = new GetRobotPartsResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GetRobotPartRequest$Type extends MessageType<GetRobotPartRequest> {
    constructor() {
        super("viam.app.v1.GetRobotPartRequest", [
            { no: 1, name: "id", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message viam.app.v1.GetRobotPartRequest
 */
export const GetRobotPartRequest = new GetRobotPartRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GetRobotPartResponse$Type extends MessageType<GetRobotPartResponse> {
    constructor() {
        super("viam.app.v1.GetRobotPartResponse", [
            { no: 1, name: "part", kind: "message", T: () => RobotPart },
            { no: 2, name: "config_json", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message viam.app.v1.GetRobotPartResponse
 */
export const GetRobotPartResponse = new GetRobotPartResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GetRobotPartByNameAndLocationRequest$Type extends MessageType<GetRobotPartByNameAndLocationRequest> {
    constructor() {
        super("viam.app.v1.GetRobotPartByNameAndLocationRequest", [
            { no: 1, name: "name", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "location_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message viam.app.v1.GetRobotPartByNameAndLocationRequest
 */
export const GetRobotPartByNameAndLocationRequest = new GetRobotPartByNameAndLocationRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GetRobotPartByNameAndLocationResponse$Type extends MessageType<GetRobotPartByNameAndLocationResponse> {
    constructor() {
        super("viam.app.v1.GetRobotPartByNameAndLocationResponse", [
            { no: 1, name: "part", kind: "message", T: () => RobotPart }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message viam.app.v1.GetRobotPartByNameAndLocationResponse
 */
export const GetRobotPartByNameAndLocationResponse = new GetRobotPartByNameAndLocationResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GetRobotPartLogsRequest$Type extends MessageType<GetRobotPartLogsRequest> {
    constructor() {
        super("viam.app.v1.GetRobotPartLogsRequest", [
            { no: 1, name: "id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "errors_only", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 3, name: "filter", kind: "scalar", opt: true, T: 9 /*ScalarType.STRING*/ },
            { no: 4, name: "page_token", kind: "scalar", opt: true, T: 9 /*ScalarType.STRING*/ },
            { no: 5, name: "levels", kind: "scalar", repeat: 2 /*RepeatType.UNPACKED*/, T: 9 /*ScalarType.STRING*/ },
            { no: 6, name: "start", kind: "message", T: () => Timestamp },
            { no: 7, name: "end", kind: "message", T: () => Timestamp },
            { no: 8, name: "limit", kind: "scalar", opt: true, T: 3 /*ScalarType.INT64*/ },
            { no: 9, name: "source", kind: "scalar", opt: true, T: 9 /*ScalarType.STRING*/ },
            { no: 10, name: "user_facing_only", kind: "scalar", opt: true, T: 8 /*ScalarType.BOOL*/ },
            { no: 11, name: "order", kind: "enum", opt: true, T: () => ["viam.app.v1.LogOrder", LogOrder, "LOG_ORDER_"] },
            { no: 12, name: "range", kind: "scalar", opt: true, T: 9 /*ScalarType.STRING*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message viam.app.v1.GetRobotPartLogsRequest
 */
export const GetRobotPartLogsRequest = new GetRobotPartLogsRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GetRobotPartLogsResponse$Type extends MessageType<GetRobotPartLogsResponse> {
    constructor() {
        super("viam.app.v1.GetRobotPartLogsResponse", [
            { no: 1, name: "logs", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => LogEntry },
            { no: 2, name: "next_page_token", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message viam.app.v1.GetRobotPartLogsResponse
 */
export const GetRobotPartLogsResponse = new GetRobotPartLogsResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class TailRobotPartLogsRequest$Type extends MessageType<TailRobotPartLogsRequest> {
    constructor() {
        super("viam.app.v1.TailRobotPartLogsRequest", [
            { no: 1, name: "id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "errors_only", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 3, name: "filter", kind: "scalar", opt: true, T: 9 /*ScalarType.STRING*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message viam.app.v1.TailRobotPartLogsRequest
 */
export const TailRobotPartLogsRequest = new TailRobotPartLogsRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class TailRobotPartLogsResponse$Type extends MessageType<TailRobotPartLogsResponse> {
    constructor() {
        super("viam.app.v1.TailRobotPartLogsResponse", [
            { no: 1, name: "logs", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => LogEntry }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message viam.app.v1.TailRobotPartLogsResponse
 */
export const TailRobotPartLogsResponse = new TailRobotPartLogsResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GetRobotPartHistoryRequest$Type extends MessageType<GetRobotPartHistoryRequest> {
    constructor() {
        super("viam.app.v1.GetRobotPartHistoryRequest", [
            { no: 1, name: "id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "page_token", kind: "scalar", opt: true, T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "page_limit", kind: "scalar", opt: true, T: 3 /*ScalarType.INT64*/ },
            { no: 4, name: "start", kind: "message", T: () => Timestamp },
            { no: 5, name: "end", kind: "message", T: () => Timestamp }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message viam.app.v1.GetRobotPartHistoryRequest
 */
export const GetRobotPartHistoryRequest = new GetRobotPartHistoryRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GetRobotPartHistoryResponse$Type extends MessageType<GetRobotPartHistoryResponse> {
    constructor() {
        super("viam.app.v1.GetRobotPartHistoryResponse", [
            { no: 1, name: "history", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => RobotPartHistoryEntry },
            { no: 2, name: "next_page_token", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message viam.app.v1.GetRobotPartHistoryResponse
 */
export const GetRobotPartHistoryResponse = new GetRobotPartHistoryResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class UpdateRobotPartRequest$Type extends MessageType<UpdateRobotPartRequest> {
    constructor() {
        super("viam.app.v1.UpdateRobotPartRequest", [
            { no: 1, name: "id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "name", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "robot_config", kind: "message", T: () => Struct },
            { no: 4, name: "last_known_update", kind: "message", T: () => Timestamp },
            { no: 5, name: "robot_config_json", kind: "scalar", opt: true, T: 9 /*ScalarType.STRING*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message viam.app.v1.UpdateRobotPartRequest
 */
export const UpdateRobotPartRequest = new UpdateRobotPartRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class UpdateRobotPartResponse$Type extends MessageType<UpdateRobotPartResponse> {
    constructor() {
        super("viam.app.v1.UpdateRobotPartResponse", [
            { no: 1, name: "part", kind: "message", T: () => RobotPart }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message viam.app.v1.UpdateRobotPartResponse
 */
export const UpdateRobotPartResponse = new UpdateRobotPartResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ConfigPropertyChange$Type extends MessageType<ConfigPropertyChange> {
    constructor() {
        super("viam.app.v1.ConfigPropertyChange", [
            { no: 1, name: "path", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "value", kind: "message", T: () => Value }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message viam.app.v1.ConfigPropertyChange
 */
export const ConfigPropertyChange = new ConfigPropertyChange$Type();
// @generated message type with reflection information, may provide speed optimized methods
class SetConfigPropertyRequest$Type extends MessageType<SetConfigPropertyRequest> {
    constructor() {
        super("viam.app.v1.SetConfigPropertyRequest", [
            { no: 1, name: "robot_part_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "property_changes", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => ConfigPropertyChange }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message viam.app.v1.SetConfigPropertyRequest
 */
export const SetConfigPropertyRequest = new SetConfigPropertyRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ConfigPropertyChangeResult$Type extends MessageType<ConfigPropertyChangeResult> {
    constructor() {
        super("viam.app.v1.ConfigPropertyChangeResult", [
            { no: 1, name: "path", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "value", kind: "message", T: () => Value },
            { no: 3, name: "success", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 4, name: "error", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message viam.app.v1.ConfigPropertyChangeResult
 */
export const ConfigPropertyChangeResult = new ConfigPropertyChangeResult$Type();
// @generated message type with reflection information, may provide speed optimized methods
class SetConfigPropertyResponse$Type extends MessageType<SetConfigPropertyResponse> {
    constructor() {
        super("viam.app.v1.SetConfigPropertyResponse", [
            { no: 1, name: "property_changes", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => ConfigPropertyChangeResult }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message viam.app.v1.SetConfigPropertyResponse
 */
export const SetConfigPropertyResponse = new SetConfigPropertyResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class NewRobotPartRequest$Type extends MessageType<NewRobotPartRequest> {
    constructor() {
        super("viam.app.v1.NewRobotPartRequest", [
            { no: 1, name: "robot_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "part_name", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message viam.app.v1.NewRobotPartRequest
 */
export const NewRobotPartRequest = new NewRobotPartRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class NewRobotPartResponse$Type extends MessageType<NewRobotPartResponse> {
    constructor() {
        super("viam.app.v1.NewRobotPartResponse", [
            { no: 1, name: "part_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message viam.app.v1.NewRobotPartResponse
 */
export const NewRobotPartResponse = new NewRobotPartResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class DeleteRobotPartRequest$Type extends MessageType<DeleteRobotPartRequest> {
    constructor() {
        super("viam.app.v1.DeleteRobotPartRequest", [
            { no: 1, name: "part_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message viam.app.v1.DeleteRobotPartRequest
 */
export const DeleteRobotPartRequest = new DeleteRobotPartRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GetRobotPartMetadataRequest$Type extends MessageType<GetRobotPartMetadataRequest> {
    constructor() {
        super("viam.app.v1.GetRobotPartMetadataRequest", [
            { no: 1, name: "id", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message viam.app.v1.GetRobotPartMetadataRequest
 */
export const GetRobotPartMetadataRequest = new GetRobotPartMetadataRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GetRobotPartMetadataResponse$Type extends MessageType<GetRobotPartMetadataResponse> {
    constructor() {
        super("viam.app.v1.GetRobotPartMetadataResponse", [
            { no: 1, name: "data", kind: "message", T: () => Struct }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message viam.app.v1.GetRobotPartMetadataResponse
 */
export const GetRobotPartMetadataResponse = new GetRobotPartMetadataResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class UpdateRobotPartMetadataRequest$Type extends MessageType<UpdateRobotPartMetadataRequest> {
    constructor() {
        super("viam.app.v1.UpdateRobotPartMetadataRequest", [
            { no: 1, name: "id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "data", kind: "message", T: () => Struct }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message viam.app.v1.UpdateRobotPartMetadataRequest
 */
export const UpdateRobotPartMetadataRequest = new UpdateRobotPartMetadataRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class UpdateRobotPartMetadataResponse$Type extends MessageType<UpdateRobotPartMetadataResponse> {
    constructor() {
        super("viam.app.v1.UpdateRobotPartMetadataResponse", []);
    }
}
/**
 * @generated MessageType for protobuf message viam.app.v1.UpdateRobotPartMetadataResponse
 */
export const UpdateRobotPartMetadataResponse = new UpdateRobotPartMetadataResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GetRobotAPIKeysRequest$Type extends MessageType<GetRobotAPIKeysRequest> {
    constructor() {
        super("viam.app.v1.GetRobotAPIKeysRequest", [
            { no: 1, name: "robot_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message viam.app.v1.GetRobotAPIKeysRequest
 */
export const GetRobotAPIKeysRequest = new GetRobotAPIKeysRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class APIKey$Type extends MessageType<APIKey> {
    constructor() {
        super("viam.app.v1.APIKey", [
            { no: 1, name: "id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "key", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "name", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 4, name: "created_on", kind: "message", T: () => Timestamp }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message viam.app.v1.APIKey
 */
export const APIKey = new APIKey$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GetRobotAPIKeysResponse$Type extends MessageType<GetRobotAPIKeysResponse> {
    constructor() {
        super("viam.app.v1.GetRobotAPIKeysResponse", [
            { no: 1, name: "api_keys", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => APIKeyWithAuthorizations }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message viam.app.v1.GetRobotAPIKeysResponse
 */
export const GetRobotAPIKeysResponse = new GetRobotAPIKeysResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class DeleteRobotPartResponse$Type extends MessageType<DeleteRobotPartResponse> {
    constructor() {
        super("viam.app.v1.DeleteRobotPartResponse", []);
    }
}
/**
 * @generated MessageType for protobuf message viam.app.v1.DeleteRobotPartResponse
 */
export const DeleteRobotPartResponse = new DeleteRobotPartResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class Fragment$Type extends MessageType<Fragment> {
    constructor() {
        super("viam.app.v1.Fragment", [
            { no: 1, name: "id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "tagger.v1.tags": "bson:\"_id\" json:\"id,omitempty\"" } },
            { no: 2, name: "name", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "tagger.v1.tags": "bson:\"name\" json:\"name\"" } },
            { no: 3, name: "fragment", kind: "message", T: () => Struct, options: { "tagger.v1.tags": "bson:\"fragment\" json:\"fragment\"" } },
            { no: 4, name: "organization_owner", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "tagger.v1.tags": "bson:\"organization_owner\" json:\"owner\"" } },
            { no: 5, name: "public", kind: "scalar", T: 8 /*ScalarType.BOOL*/, options: { "tagger.v1.tags": "bson:\"public\" json:\"public\"" } },
            { no: 6, name: "created_on", kind: "message", T: () => Timestamp, options: { "tagger.v1.tags": "bson:\"created_on\"" } },
            { no: 7, name: "organization_name", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 9, name: "robot_part_count", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 10, name: "organization_count", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 11, name: "only_used_by_owner", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 12, name: "visibility", kind: "enum", T: () => ["viam.app.v1.FragmentVisibility", FragmentVisibility, "FRAGMENT_VISIBILITY_"] },
            { no: 13, name: "last_updated", kind: "message", T: () => Timestamp, options: { "tagger.v1.tags": "bson:\"last_updated_at\"" } },
            { no: 14, name: "revision", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 15, name: "public_namespace", kind: "scalar", opt: true, T: 9 /*ScalarType.STRING*/ },
            { no: 16, name: "fragment_config_json", kind: "scalar", opt: true, T: 9 /*ScalarType.STRING*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message viam.app.v1.Fragment
 */
export const Fragment = new Fragment$Type();
// @generated message type with reflection information, may provide speed optimized methods
class FragmentHistoryEntry$Type extends MessageType<FragmentHistoryEntry> {
    constructor() {
        super("viam.app.v1.FragmentHistoryEntry", [
            { no: 1, name: "fragment", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "tagger.v1.tags": "bson:\"fragment\" json:\"fragment\"" } },
            { no: 2, name: "edited_on", kind: "message", T: () => Timestamp, options: { "tagger.v1.tags": "bson:\"edited_on\" json:\"edited_on\"" } },
            { no: 3, name: "old", kind: "message", T: () => Fragment, options: { "tagger.v1.tags": "bson:\"old\" json:\"old\"" } },
            { no: 4, name: "edited_by", kind: "message", T: () => AuthenticatorInfo, options: { "tagger.v1.tags": "bson:\"edited_by\" json:\"edited_by\"" } },
            { no: 5, name: "revision", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "tagger.v1.tags": "bson:\"revision\" json:\"revision\"" } },
            { no: 6, name: "config", kind: "message", T: () => Struct, options: { "tagger.v1.tags": "bson:\"config\" json:\"config\"" } }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message viam.app.v1.FragmentHistoryEntry
 */
export const FragmentHistoryEntry = new FragmentHistoryEntry$Type();
// @generated message type with reflection information, may provide speed optimized methods
class FragmentRevision$Type extends MessageType<FragmentRevision> {
    constructor() {
        super("viam.app.v1.FragmentRevision", [
            { no: 1, name: "revision", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "created_at", kind: "message", T: () => Timestamp }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message viam.app.v1.FragmentRevision
 */
export const FragmentRevision = new FragmentRevision$Type();
// @generated message type with reflection information, may provide speed optimized methods
class FragmentTag$Type extends MessageType<FragmentTag> {
    constructor() {
        super("viam.app.v1.FragmentTag", [
            { no: 1, name: "tag", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "revision", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message viam.app.v1.FragmentTag
 */
export const FragmentTag = new FragmentTag$Type();
// @generated message type with reflection information, may provide speed optimized methods
class FragmentError$Type extends MessageType<FragmentError> {
    constructor() {
        super("viam.app.v1.FragmentError", [
            { no: 1, name: "error_type", kind: "enum", T: () => ["viam.app.v1.FragmentErrorType", FragmentErrorType, "FRAGMENT_ERROR_TYPE_"] },
            { no: 2, name: "fragment_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "detail", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message viam.app.v1.FragmentError
 */
export const FragmentError = new FragmentError$Type();
// @generated message type with reflection information, may provide speed optimized methods
class FragmentUsage$Type extends MessageType<FragmentUsage> {
    constructor() {
        super("viam.app.v1.FragmentUsage", [
            { no: 1, name: "fragment_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "organizations", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 3, name: "machines", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 4, name: "machines_in_current_org", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 5, name: "version", kind: "scalar", opt: true, T: 9 /*ScalarType.STRING*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message viam.app.v1.FragmentUsage
 */
export const FragmentUsage = new FragmentUsage$Type();
// @generated message type with reflection information, may provide speed optimized methods
class FragmentImport$Type extends MessageType<FragmentImport> {
    constructor() {
        super("viam.app.v1.FragmentImport", [
            { no: 1, name: "fragment_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "version", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "prefix", kind: "scalar", opt: true, T: 9 /*ScalarType.STRING*/ },
            { no: 4, name: "variables", kind: "map", K: 9 /*ScalarType.STRING*/, V: { kind: "scalar", T: 9 /*ScalarType.STRING*/ } },
            { no: 5, name: "fragment_variables", kind: "message", T: () => Struct }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message viam.app.v1.FragmentImport
 */
export const FragmentImport = new FragmentImport$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ResolvedFragment$Type extends MessageType<ResolvedFragment> {
    constructor() {
        super("viam.app.v1.ResolvedFragment", [
            { no: 1, name: "fragment_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "resolved_config", kind: "message", T: () => Struct },
            { no: 3, name: "error", kind: "message", T: () => FragmentError },
            { no: 4, name: "revision", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message viam.app.v1.ResolvedFragment
 */
export const ResolvedFragment = new ResolvedFragment$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ListFragmentsRequest$Type extends MessageType<ListFragmentsRequest> {
    constructor() {
        super("viam.app.v1.ListFragmentsRequest", [
            { no: 1, name: "organization_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "show_public", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 3, name: "fragment_visibility", kind: "enum", repeat: 1 /*RepeatType.PACKED*/, T: () => ["viam.app.v1.FragmentVisibility", FragmentVisibility, "FRAGMENT_VISIBILITY_"] }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message viam.app.v1.ListFragmentsRequest
 */
export const ListFragmentsRequest = new ListFragmentsRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ListFragmentsResponse$Type extends MessageType<ListFragmentsResponse> {
    constructor() {
        super("viam.app.v1.ListFragmentsResponse", [
            { no: 1, name: "fragments", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => Fragment },
            { no: 2, name: "fragment_usages", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => FragmentUsage }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message viam.app.v1.ListFragmentsResponse
 */
export const ListFragmentsResponse = new ListFragmentsResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GetFragmentRequest$Type extends MessageType<GetFragmentRequest> {
    constructor() {
        super("viam.app.v1.GetFragmentRequest", [
            { no: 1, name: "id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "current_organization_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "version", kind: "scalar", opt: true, T: 9 /*ScalarType.STRING*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message viam.app.v1.GetFragmentRequest
 */
export const GetFragmentRequest = new GetFragmentRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GetFragmentResponse$Type extends MessageType<GetFragmentResponse> {
    constructor() {
        super("viam.app.v1.GetFragmentResponse", [
            { no: 1, name: "fragment", kind: "message", T: () => Fragment },
            { no: 2, name: "fragment_usage", kind: "message", T: () => FragmentUsage },
            { no: 3, name: "revisions", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => FragmentRevision },
            { no: 4, name: "tags", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => FragmentTag }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message viam.app.v1.GetFragmentResponse
 */
export const GetFragmentResponse = new GetFragmentResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class CreateFragmentRequest$Type extends MessageType<CreateFragmentRequest> {
    constructor() {
        super("viam.app.v1.CreateFragmentRequest", [
            { no: 1, name: "name", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "config", kind: "message", T: () => Struct },
            { no: 3, name: "organization_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 4, name: "visibility", kind: "enum", opt: true, T: () => ["viam.app.v1.FragmentVisibility", FragmentVisibility, "FRAGMENT_VISIBILITY_"] }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message viam.app.v1.CreateFragmentRequest
 */
export const CreateFragmentRequest = new CreateFragmentRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class CreateFragmentResponse$Type extends MessageType<CreateFragmentResponse> {
    constructor() {
        super("viam.app.v1.CreateFragmentResponse", [
            { no: 1, name: "fragment", kind: "message", T: () => Fragment }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message viam.app.v1.CreateFragmentResponse
 */
export const CreateFragmentResponse = new CreateFragmentResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class UpdateFragmentRequest$Type extends MessageType<UpdateFragmentRequest> {
    constructor() {
        super("viam.app.v1.UpdateFragmentRequest", [
            { no: 1, name: "id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "name", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "config", kind: "message", T: () => Struct },
            { no: 4, name: "public", kind: "scalar", opt: true, T: 8 /*ScalarType.BOOL*/ },
            { no: 5, name: "visibility", kind: "enum", opt: true, T: () => ["viam.app.v1.FragmentVisibility", FragmentVisibility, "FRAGMENT_VISIBILITY_"] },
            { no: 6, name: "last_known_update", kind: "message", T: () => Timestamp },
            { no: 7, name: "fragment_config_json", kind: "scalar", opt: true, T: 9 /*ScalarType.STRING*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message viam.app.v1.UpdateFragmentRequest
 */
export const UpdateFragmentRequest = new UpdateFragmentRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class UpdateFragmentResponse$Type extends MessageType<UpdateFragmentResponse> {
    constructor() {
        super("viam.app.v1.UpdateFragmentResponse", [
            { no: 1, name: "fragment", kind: "message", T: () => Fragment }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message viam.app.v1.UpdateFragmentResponse
 */
export const UpdateFragmentResponse = new UpdateFragmentResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class DeleteFragmentRequest$Type extends MessageType<DeleteFragmentRequest> {
    constructor() {
        super("viam.app.v1.DeleteFragmentRequest", [
            { no: 1, name: "id", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message viam.app.v1.DeleteFragmentRequest
 */
export const DeleteFragmentRequest = new DeleteFragmentRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class DeleteFragmentResponse$Type extends MessageType<DeleteFragmentResponse> {
    constructor() {
        super("viam.app.v1.DeleteFragmentResponse", []);
    }
}
/**
 * @generated MessageType for protobuf message viam.app.v1.DeleteFragmentResponse
 */
export const DeleteFragmentResponse = new DeleteFragmentResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GetFragmentHistoryRequest$Type extends MessageType<GetFragmentHistoryRequest> {
    constructor() {
        super("viam.app.v1.GetFragmentHistoryRequest", [
            { no: 1, name: "id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "page_token", kind: "scalar", opt: true, T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "page_limit", kind: "scalar", opt: true, T: 3 /*ScalarType.INT64*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message viam.app.v1.GetFragmentHistoryRequest
 */
export const GetFragmentHistoryRequest = new GetFragmentHistoryRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GetFragmentHistoryResponse$Type extends MessageType<GetFragmentHistoryResponse> {
    constructor() {
        super("viam.app.v1.GetFragmentHistoryResponse", [
            { no: 1, name: "history", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => FragmentHistoryEntry },
            { no: 2, name: "next_page_token", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message viam.app.v1.GetFragmentHistoryResponse
 */
export const GetFragmentHistoryResponse = new GetFragmentHistoryResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GetFragmentUsageRequest$Type extends MessageType<GetFragmentUsageRequest> {
    constructor() {
        super("viam.app.v1.GetFragmentUsageRequest", [
            { no: 1, name: "fragment_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message viam.app.v1.GetFragmentUsageRequest
 */
export const GetFragmentUsageRequest = new GetFragmentUsageRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GetFragmentUsageResponse$Type extends MessageType<GetFragmentUsageResponse> {
    constructor() {
        super("viam.app.v1.GetFragmentUsageResponse", [
            { no: 1, name: "version_usages", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => FragmentUsage }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message viam.app.v1.GetFragmentUsageResponse
 */
export const GetFragmentUsageResponse = new GetFragmentUsageResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class SetFragmentTagRequest$Type extends MessageType<SetFragmentTagRequest> {
    constructor() {
        super("viam.app.v1.SetFragmentTagRequest", [
            { no: 1, name: "fragment_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "tag", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "revision", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message viam.app.v1.SetFragmentTagRequest
 */
export const SetFragmentTagRequest = new SetFragmentTagRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class SetFragmentTagResponse$Type extends MessageType<SetFragmentTagResponse> {
    constructor() {
        super("viam.app.v1.SetFragmentTagResponse", [
            { no: 1, name: "tags", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => FragmentTag }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message viam.app.v1.SetFragmentTagResponse
 */
export const SetFragmentTagResponse = new SetFragmentTagResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class DeleteFragmentTagRequest$Type extends MessageType<DeleteFragmentTagRequest> {
    constructor() {
        super("viam.app.v1.DeleteFragmentTagRequest", [
            { no: 1, name: "fragment_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "tag", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message viam.app.v1.DeleteFragmentTagRequest
 */
export const DeleteFragmentTagRequest = new DeleteFragmentTagRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class DeleteFragmentTagResponse$Type extends MessageType<DeleteFragmentTagResponse> {
    constructor() {
        super("viam.app.v1.DeleteFragmentTagResponse", [
            { no: 1, name: "tags", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => FragmentTag }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message viam.app.v1.DeleteFragmentTagResponse
 */
export const DeleteFragmentTagResponse = new DeleteFragmentTagResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ListRobotsRequest$Type extends MessageType<ListRobotsRequest> {
    constructor() {
        super("viam.app.v1.ListRobotsRequest", [
            { no: 1, name: "location_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message viam.app.v1.ListRobotsRequest
 */
export const ListRobotsRequest = new ListRobotsRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ListRobotsForLocationsRequest$Type extends MessageType<ListRobotsForLocationsRequest> {
    constructor() {
        super("viam.app.v1.ListRobotsForLocationsRequest", [
            { no: 1, name: "location_ids", kind: "scalar", repeat: 2 /*RepeatType.UNPACKED*/, T: 9 /*ScalarType.STRING*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message viam.app.v1.ListRobotsForLocationsRequest
 */
export const ListRobotsForLocationsRequest = new ListRobotsForLocationsRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ListRobotsForOrgRequest$Type extends MessageType<ListRobotsForOrgRequest> {
    constructor() {
        super("viam.app.v1.ListRobotsForOrgRequest", [
            { no: 1, name: "org_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message viam.app.v1.ListRobotsForOrgRequest
 */
export const ListRobotsForOrgRequest = new ListRobotsForOrgRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class AdditionalFragment$Type extends MessageType<AdditionalFragment> {
    constructor() {
        super("viam.app.v1.AdditionalFragment", [
            { no: 1, name: "fragment_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "version", kind: "scalar", opt: true, T: 9 /*ScalarType.STRING*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message viam.app.v1.AdditionalFragment
 */
export const AdditionalFragment = new AdditionalFragment$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ListNestedFragmentsRequest$Type extends MessageType<ListNestedFragmentsRequest> {
    constructor() {
        super("viam.app.v1.ListNestedFragmentsRequest", [
            { no: 1, name: "fragment_id", kind: "scalar", opt: true, T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "additional_fragments", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => AdditionalFragment }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message viam.app.v1.ListNestedFragmentsRequest
 */
export const ListNestedFragmentsRequest = new ListNestedFragmentsRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ListNestedFragmentsResponse$Type extends MessageType<ListNestedFragmentsResponse> {
    constructor() {
        super("viam.app.v1.ListNestedFragmentsResponse", [
            { no: 1, name: "fragments", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => Fragment },
            { no: 2, name: "resolved_fragments", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => ResolvedFragment }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message viam.app.v1.ListNestedFragmentsResponse
 */
export const ListNestedFragmentsResponse = new ListNestedFragmentsResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ListMachineFragmentsRequest$Type extends MessageType<ListMachineFragmentsRequest> {
    constructor() {
        super("viam.app.v1.ListMachineFragmentsRequest", [
            { no: 1, name: "machine_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "additional_fragment_ids", kind: "scalar", repeat: 2 /*RepeatType.UNPACKED*/, T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "additional_fragments", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => AdditionalFragment }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message viam.app.v1.ListMachineFragmentsRequest
 */
export const ListMachineFragmentsRequest = new ListMachineFragmentsRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ListMachineFragmentsResponse$Type extends MessageType<ListMachineFragmentsResponse> {
    constructor() {
        super("viam.app.v1.ListMachineFragmentsResponse", [
            { no: 1, name: "fragments", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => Fragment },
            { no: 2, name: "resolved_fragments", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => ResolvedFragment }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message viam.app.v1.ListMachineFragmentsResponse
 */
export const ListMachineFragmentsResponse = new ListMachineFragmentsResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ListMachineSummariesRequest$Type extends MessageType<ListMachineSummariesRequest> {
    constructor() {
        super("viam.app.v1.ListMachineSummariesRequest", [
            { no: 1, name: "organization_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "fragment_ids", kind: "scalar", repeat: 2 /*RepeatType.UNPACKED*/, T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "location_ids", kind: "scalar", repeat: 2 /*RepeatType.UNPACKED*/, T: 9 /*ScalarType.STRING*/ },
            { no: 4, name: "limit", kind: "scalar", opt: true, T: 5 /*ScalarType.INT32*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message viam.app.v1.ListMachineSummariesRequest
 */
export const ListMachineSummariesRequest = new ListMachineSummariesRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ListMachineSummariesResponse$Type extends MessageType<ListMachineSummariesResponse> {
    constructor() {
        super("viam.app.v1.ListMachineSummariesResponse", [
            { no: 1, name: "location_summaries", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => LocationSummary }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message viam.app.v1.ListMachineSummariesResponse
 */
export const ListMachineSummariesResponse = new ListMachineSummariesResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class LocationSummary$Type extends MessageType<LocationSummary> {
    constructor() {
        super("viam.app.v1.LocationSummary", [
            { no: 1, name: "location_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "location_name", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "machine_summaries", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => MachineSummary }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message viam.app.v1.LocationSummary
 */
export const LocationSummary = new LocationSummary$Type();
// @generated message type with reflection information, may provide speed optimized methods
class MachineSummary$Type extends MessageType<MachineSummary> {
    constructor() {
        super("viam.app.v1.MachineSummary", [
            { no: 1, name: "machine_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "machine_name", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "part_summaries", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => PartSummary }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message viam.app.v1.MachineSummary
 */
export const MachineSummary = new MachineSummary$Type();
// @generated message type with reflection information, may provide speed optimized methods
class FragmentSummary$Type extends MessageType<FragmentSummary> {
    constructor() {
        super("viam.app.v1.FragmentSummary", [
            { no: 1, name: "id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "name", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message viam.app.v1.FragmentSummary
 */
export const FragmentSummary = new FragmentSummary$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ViamServerVersion$Type extends MessageType<ViamServerVersion> {
    constructor() {
        super("viam.app.v1.ViamServerVersion", [
            { no: 1, name: "major", kind: "scalar", oneof: "version", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "minor", kind: "scalar", oneof: "version", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message viam.app.v1.ViamServerVersion
 */
export const ViamServerVersion = new ViamServerVersion$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ViamAgentVersion$Type extends MessageType<ViamAgentVersion> {
    constructor() {
        super("viam.app.v1.ViamAgentVersion", [
            { no: 1, name: "major", kind: "scalar", oneof: "version", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "minor", kind: "scalar", oneof: "version", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message viam.app.v1.ViamAgentVersion
 */
export const ViamAgentVersion = new ViamAgentVersion$Type();
// @generated message type with reflection information, may provide speed optimized methods
class PartSummary$Type extends MessageType<PartSummary> {
    constructor() {
        super("viam.app.v1.PartSummary", [
            { no: 1, name: "part_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "part_name", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 11, name: "is_main_part", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 12, name: "online_state", kind: "enum", T: () => ["viam.app.v1.OnlineState", OnlineState, "ONLINE_STATE_"] },
            { no: 13, name: "seconds_since_online", kind: "scalar", T: 3 /*ScalarType.INT64*/ },
            { no: 14, name: "last_access", kind: "message", T: () => Timestamp },
            { no: 3, name: "last_online", kind: "message", T: () => Timestamp },
            { no: 4, name: "viam_server_version", kind: "message", T: () => ViamServerVersion },
            { no: 5, name: "viam_agent_version", kind: "message", T: () => ViamAgentVersion },
            { no: 6, name: "os", kind: "scalar", opt: true, T: 9 /*ScalarType.STRING*/ },
            { no: 7, name: "platform", kind: "scalar", opt: true, T: 9 /*ScalarType.STRING*/ },
            { no: 8, name: "public_ip_address", kind: "scalar", opt: true, T: 9 /*ScalarType.STRING*/ },
            { no: 10, name: "dns_name", kind: "scalar", opt: true, T: 9 /*ScalarType.STRING*/ },
            { no: 9, name: "fragments", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => FragmentSummary }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message viam.app.v1.PartSummary
 */
export const PartSummary = new PartSummary$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ListRobotsResponse$Type extends MessageType<ListRobotsResponse> {
    constructor() {
        super("viam.app.v1.ListRobotsResponse", [
            { no: 1, name: "robots", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => Robot }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message viam.app.v1.ListRobotsResponse
 */
export const ListRobotsResponse = new ListRobotsResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ListRobotsForLocationsResponse$Type extends MessageType<ListRobotsForLocationsResponse> {
    constructor() {
        super("viam.app.v1.ListRobotsForLocationsResponse", [
            { no: 1, name: "robots", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => Robot }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message viam.app.v1.ListRobotsForLocationsResponse
 */
export const ListRobotsForLocationsResponse = new ListRobotsForLocationsResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ListRobotsForOrgResponse$Type extends MessageType<ListRobotsForOrgResponse> {
    constructor() {
        super("viam.app.v1.ListRobotsForOrgResponse", [
            { no: 1, name: "robots", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => Robot }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message viam.app.v1.ListRobotsForOrgResponse
 */
export const ListRobotsForOrgResponse = new ListRobotsForOrgResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class NewRobotRequest$Type extends MessageType<NewRobotRequest> {
    constructor() {
        super("viam.app.v1.NewRobotRequest", [
            { no: 1, name: "name", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "location", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message viam.app.v1.NewRobotRequest
 */
export const NewRobotRequest = new NewRobotRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class NewRobotResponse$Type extends MessageType<NewRobotResponse> {
    constructor() {
        super("viam.app.v1.NewRobotResponse", [
            { no: 1, name: "id", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message viam.app.v1.NewRobotResponse
 */
export const NewRobotResponse = new NewRobotResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class UpdateRobotRequest$Type extends MessageType<UpdateRobotRequest> {
    constructor() {
        super("viam.app.v1.UpdateRobotRequest", [
            { no: 1, name: "id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "name", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "location", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message viam.app.v1.UpdateRobotRequest
 */
export const UpdateRobotRequest = new UpdateRobotRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class UpdateRobotResponse$Type extends MessageType<UpdateRobotResponse> {
    constructor() {
        super("viam.app.v1.UpdateRobotResponse", [
            { no: 1, name: "robot", kind: "message", T: () => Robot }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message viam.app.v1.UpdateRobotResponse
 */
export const UpdateRobotResponse = new UpdateRobotResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class DeleteRobotRequest$Type extends MessageType<DeleteRobotRequest> {
    constructor() {
        super("viam.app.v1.DeleteRobotRequest", [
            { no: 1, name: "id", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message viam.app.v1.DeleteRobotRequest
 */
export const DeleteRobotRequest = new DeleteRobotRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class DeleteRobotResponse$Type extends MessageType<DeleteRobotResponse> {
    constructor() {
        super("viam.app.v1.DeleteRobotResponse", []);
    }
}
/**
 * @generated MessageType for protobuf message viam.app.v1.DeleteRobotResponse
 */
export const DeleteRobotResponse = new DeleteRobotResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class FavoriteMachine$Type extends MessageType<FavoriteMachine> {
    constructor() {
        super("viam.app.v1.FavoriteMachine", [
            { no: 1, name: "machine", kind: "message", T: () => Robot },
            { no: 2, name: "organization_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "created_on", kind: "message", T: () => Timestamp }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message viam.app.v1.FavoriteMachine
 */
export const FavoriteMachine = new FavoriteMachine$Type();
// @generated message type with reflection information, may provide speed optimized methods
class AddFavoriteMachineRequest$Type extends MessageType<AddFavoriteMachineRequest> {
    constructor() {
        super("viam.app.v1.AddFavoriteMachineRequest", [
            { no: 1, name: "machine_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message viam.app.v1.AddFavoriteMachineRequest
 */
export const AddFavoriteMachineRequest = new AddFavoriteMachineRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class AddFavoriteMachineResponse$Type extends MessageType<AddFavoriteMachineResponse> {
    constructor() {
        super("viam.app.v1.AddFavoriteMachineResponse", []);
    }
}
/**
 * @generated MessageType for protobuf message viam.app.v1.AddFavoriteMachineResponse
 */
export const AddFavoriteMachineResponse = new AddFavoriteMachineResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class RemoveFavoriteMachineRequest$Type extends MessageType<RemoveFavoriteMachineRequest> {
    constructor() {
        super("viam.app.v1.RemoveFavoriteMachineRequest", [
            { no: 1, name: "machine_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message viam.app.v1.RemoveFavoriteMachineRequest
 */
export const RemoveFavoriteMachineRequest = new RemoveFavoriteMachineRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class RemoveFavoriteMachineResponse$Type extends MessageType<RemoveFavoriteMachineResponse> {
    constructor() {
        super("viam.app.v1.RemoveFavoriteMachineResponse", []);
    }
}
/**
 * @generated MessageType for protobuf message viam.app.v1.RemoveFavoriteMachineResponse
 */
export const RemoveFavoriteMachineResponse = new RemoveFavoriteMachineResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ListFavoriteMachinesRequest$Type extends MessageType<ListFavoriteMachinesRequest> {
    constructor() {
        super("viam.app.v1.ListFavoriteMachinesRequest", []);
    }
}
/**
 * @generated MessageType for protobuf message viam.app.v1.ListFavoriteMachinesRequest
 */
export const ListFavoriteMachinesRequest = new ListFavoriteMachinesRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ListFavoriteMachinesResponse$Type extends MessageType<ListFavoriteMachinesResponse> {
    constructor() {
        super("viam.app.v1.ListFavoriteMachinesResponse", [
            { no: 1, name: "favorites", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => FavoriteMachine }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message viam.app.v1.ListFavoriteMachinesResponse
 */
export const ListFavoriteMachinesResponse = new ListFavoriteMachinesResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GetRobotMetadataRequest$Type extends MessageType<GetRobotMetadataRequest> {
    constructor() {
        super("viam.app.v1.GetRobotMetadataRequest", [
            { no: 1, name: "id", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message viam.app.v1.GetRobotMetadataRequest
 */
export const GetRobotMetadataRequest = new GetRobotMetadataRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GetRobotMetadataResponse$Type extends MessageType<GetRobotMetadataResponse> {
    constructor() {
        super("viam.app.v1.GetRobotMetadataResponse", [
            { no: 1, name: "data", kind: "message", T: () => Struct }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message viam.app.v1.GetRobotMetadataResponse
 */
export const GetRobotMetadataResponse = new GetRobotMetadataResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class UpdateRobotMetadataRequest$Type extends MessageType<UpdateRobotMetadataRequest> {
    constructor() {
        super("viam.app.v1.UpdateRobotMetadataRequest", [
            { no: 1, name: "id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "data", kind: "message", T: () => Struct }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message viam.app.v1.UpdateRobotMetadataRequest
 */
export const UpdateRobotMetadataRequest = new UpdateRobotMetadataRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class UpdateRobotMetadataResponse$Type extends MessageType<UpdateRobotMetadataResponse> {
    constructor() {
        super("viam.app.v1.UpdateRobotMetadataResponse", []);
    }
}
/**
 * @generated MessageType for protobuf message viam.app.v1.UpdateRobotMetadataResponse
 */
export const UpdateRobotMetadataResponse = new UpdateRobotMetadataResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class MarkPartAsMainRequest$Type extends MessageType<MarkPartAsMainRequest> {
    constructor() {
        super("viam.app.v1.MarkPartAsMainRequest", [
            { no: 1, name: "part_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message viam.app.v1.MarkPartAsMainRequest
 */
export const MarkPartAsMainRequest = new MarkPartAsMainRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class MarkPartAsMainResponse$Type extends MessageType<MarkPartAsMainResponse> {
    constructor() {
        super("viam.app.v1.MarkPartAsMainResponse", []);
    }
}
/**
 * @generated MessageType for protobuf message viam.app.v1.MarkPartAsMainResponse
 */
export const MarkPartAsMainResponse = new MarkPartAsMainResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class MarkPartForRestartRequest$Type extends MessageType<MarkPartForRestartRequest> {
    constructor() {
        super("viam.app.v1.MarkPartForRestartRequest", [
            { no: 1, name: "part_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message viam.app.v1.MarkPartForRestartRequest
 */
export const MarkPartForRestartRequest = new MarkPartForRestartRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class MarkPartForRestartResponse$Type extends MessageType<MarkPartForRestartResponse> {
    constructor() {
        super("viam.app.v1.MarkPartForRestartResponse", []);
    }
}
/**
 * @generated MessageType for protobuf message viam.app.v1.MarkPartForRestartResponse
 */
export const MarkPartForRestartResponse = new MarkPartForRestartResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class CreateRobotPartSecretRequest$Type extends MessageType<CreateRobotPartSecretRequest> {
    constructor() {
        super("viam.app.v1.CreateRobotPartSecretRequest", [
            { no: 1, name: "part_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message viam.app.v1.CreateRobotPartSecretRequest
 */
export const CreateRobotPartSecretRequest = new CreateRobotPartSecretRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class CreateRobotPartSecretResponse$Type extends MessageType<CreateRobotPartSecretResponse> {
    constructor() {
        super("viam.app.v1.CreateRobotPartSecretResponse", [
            { no: 1, name: "part", kind: "message", T: () => RobotPart }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message viam.app.v1.CreateRobotPartSecretResponse
 */
export const CreateRobotPartSecretResponse = new CreateRobotPartSecretResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class DeleteRobotPartSecretRequest$Type extends MessageType<DeleteRobotPartSecretRequest> {
    constructor() {
        super("viam.app.v1.DeleteRobotPartSecretRequest", [
            { no: 1, name: "part_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "secret_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message viam.app.v1.DeleteRobotPartSecretRequest
 */
export const DeleteRobotPartSecretRequest = new DeleteRobotPartSecretRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class DeleteRobotPartSecretResponse$Type extends MessageType<DeleteRobotPartSecretResponse> {
    constructor() {
        super("viam.app.v1.DeleteRobotPartSecretResponse", []);
    }
}
/**
 * @generated MessageType for protobuf message viam.app.v1.DeleteRobotPartSecretResponse
 */
export const DeleteRobotPartSecretResponse = new DeleteRobotPartSecretResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class Authorization$Type extends MessageType<Authorization> {
    constructor() {
        super("viam.app.v1.Authorization", [
            { no: 1, name: "authorization_type", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "authorization_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "resource_type", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 4, name: "resource_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 5, name: "identity_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 6, name: "organization_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 7, name: "identity_type", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message viam.app.v1.Authorization
 */
export const Authorization = new Authorization$Type();
// @generated message type with reflection information, may provide speed optimized methods
class AddRoleRequest$Type extends MessageType<AddRoleRequest> {
    constructor() {
        super("viam.app.v1.AddRoleRequest", [
            { no: 1, name: "authorization", kind: "message", T: () => Authorization }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message viam.app.v1.AddRoleRequest
 */
export const AddRoleRequest = new AddRoleRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class AddRoleResponse$Type extends MessageType<AddRoleResponse> {
    constructor() {
        super("viam.app.v1.AddRoleResponse", []);
    }
}
/**
 * @generated MessageType for protobuf message viam.app.v1.AddRoleResponse
 */
export const AddRoleResponse = new AddRoleResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class RemoveRoleRequest$Type extends MessageType<RemoveRoleRequest> {
    constructor() {
        super("viam.app.v1.RemoveRoleRequest", [
            { no: 1, name: "authorization", kind: "message", T: () => Authorization }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message viam.app.v1.RemoveRoleRequest
 */
export const RemoveRoleRequest = new RemoveRoleRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class RemoveRoleResponse$Type extends MessageType<RemoveRoleResponse> {
    constructor() {
        super("viam.app.v1.RemoveRoleResponse", []);
    }
}
/**
 * @generated MessageType for protobuf message viam.app.v1.RemoveRoleResponse
 */
export const RemoveRoleResponse = new RemoveRoleResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ChangeRoleRequest$Type extends MessageType<ChangeRoleRequest> {
    constructor() {
        super("viam.app.v1.ChangeRoleRequest", [
            { no: 1, name: "old_authorization", kind: "message", T: () => Authorization },
            { no: 2, name: "new_authorization", kind: "message", T: () => Authorization }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message viam.app.v1.ChangeRoleRequest
 */
export const ChangeRoleRequest = new ChangeRoleRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ChangeRoleResponse$Type extends MessageType<ChangeRoleResponse> {
    constructor() {
        super("viam.app.v1.ChangeRoleResponse", []);
    }
}
/**
 * @generated MessageType for protobuf message viam.app.v1.ChangeRoleResponse
 */
export const ChangeRoleResponse = new ChangeRoleResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ListAuthorizationsRequest$Type extends MessageType<ListAuthorizationsRequest> {
    constructor() {
        super("viam.app.v1.ListAuthorizationsRequest", [
            { no: 1, name: "organization_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "resource_ids", kind: "scalar", repeat: 2 /*RepeatType.UNPACKED*/, T: 9 /*ScalarType.STRING*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message viam.app.v1.ListAuthorizationsRequest
 */
export const ListAuthorizationsRequest = new ListAuthorizationsRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ListAuthorizationsResponse$Type extends MessageType<ListAuthorizationsResponse> {
    constructor() {
        super("viam.app.v1.ListAuthorizationsResponse", [
            { no: 1, name: "authorizations", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => Authorization }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message viam.app.v1.ListAuthorizationsResponse
 */
export const ListAuthorizationsResponse = new ListAuthorizationsResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class CheckPermissionsRequest$Type extends MessageType<CheckPermissionsRequest> {
    constructor() {
        super("viam.app.v1.CheckPermissionsRequest", [
            { no: 1, name: "permissions", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => AuthorizedPermissions }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message viam.app.v1.CheckPermissionsRequest
 */
export const CheckPermissionsRequest = new CheckPermissionsRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class AuthorizedPermissions$Type extends MessageType<AuthorizedPermissions> {
    constructor() {
        super("viam.app.v1.AuthorizedPermissions", [
            { no: 1, name: "resource_type", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "resource_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "permissions", kind: "scalar", repeat: 2 /*RepeatType.UNPACKED*/, T: 9 /*ScalarType.STRING*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message viam.app.v1.AuthorizedPermissions
 */
export const AuthorizedPermissions = new AuthorizedPermissions$Type();
// @generated message type with reflection information, may provide speed optimized methods
class CheckPermissionsResponse$Type extends MessageType<CheckPermissionsResponse> {
    constructor() {
        super("viam.app.v1.CheckPermissionsResponse", [
            { no: 1, name: "authorized_permissions", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => AuthorizedPermissions }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message viam.app.v1.CheckPermissionsResponse
 */
export const CheckPermissionsResponse = new CheckPermissionsResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ModuleVersion$Type extends MessageType<ModuleVersion> {
    constructor() {
        super("viam.app.v1.ModuleVersion", [
            { no: 1, name: "version", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "files", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => Uploads },
            { no: 3, name: "models", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => Model },
            { no: 4, name: "entrypoint", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 5, name: "first_run", kind: "scalar", opt: true, T: 9 /*ScalarType.STRING*/ },
            { no: 6, name: "markdown_description", kind: "scalar", opt: true, T: 9 /*ScalarType.STRING*/ },
            { no: 7, name: "apps", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => App },
            { no: 8, name: "deprecated_status", kind: "message", T: () => DeprecatedStatus },
            { no: 9, name: "min_viam_server_version", kind: "scalar", opt: true, T: 9 /*ScalarType.STRING*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message viam.app.v1.ModuleVersion
 */
export const ModuleVersion = new ModuleVersion$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ModuleMetadata$Type extends MessageType<ModuleMetadata> {
    constructor() {
        super("viam.app.v1.ModuleMetadata", [
            { no: 1, name: "models", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => Model },
            { no: 2, name: "versions", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => ModuleVersion },
            { no: 3, name: "entrypoint", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 4, name: "first_run", kind: "scalar", opt: true, T: 9 /*ScalarType.STRING*/ },
            { no: 5, name: "markdown_description", kind: "scalar", opt: true, T: 9 /*ScalarType.STRING*/ },
            { no: 6, name: "apps", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => App },
            { no: 7, name: "source_type", kind: "enum", opt: true, T: () => ["viam.app.v1.ModuleSourceType", ModuleSourceType, "MODULE_SOURCE_TYPE_"] },
            { no: 8, name: "language", kind: "enum", opt: true, T: () => ["viam.app.v1.ModuleLanguage", ModuleLanguage, "MODULE_LANGUAGE_"] },
            { no: 9, name: "min_viam_server_version", kind: "scalar", opt: true, T: 9 /*ScalarType.STRING*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message viam.app.v1.ModuleMetadata
 */
export const ModuleMetadata = new ModuleMetadata$Type();
// @generated message type with reflection information, may provide speed optimized methods
class MLModelVersion$Type extends MessageType<MLModelVersion> {
    constructor() {
        super("viam.app.v1.MLModelVersion", [
            { no: 1, name: "version", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "created_on", kind: "message", T: () => Timestamp }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message viam.app.v1.MLModelVersion
 */
export const MLModelVersion = new MLModelVersion$Type();
// @generated message type with reflection information, may provide speed optimized methods
class MLModelMetadata$Type extends MessageType<MLModelMetadata> {
    constructor() {
        super("viam.app.v1.MLModelMetadata", [
            { no: 1, name: "versions", kind: "scalar", repeat: 2 /*RepeatType.UNPACKED*/, T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "model_type", kind: "enum", T: () => ["viam.app.mltraining.v1.ModelType", ModelType, "MODEL_TYPE_"] },
            { no: 3, name: "model_framework", kind: "enum", T: () => ["viam.app.mltraining.v1.ModelFramework", ModelFramework, "MODEL_FRAMEWORK_"] },
            { no: 4, name: "detailed_versions", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => MLModelVersion },
            { no: 5, name: "deployment_modular_resources", kind: "scalar", repeat: 2 /*RepeatType.UNPACKED*/, T: 9 /*ScalarType.STRING*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message viam.app.v1.MLModelMetadata
 */
export const MLModelMetadata = new MLModelMetadata$Type();
// @generated message type with reflection information, may provide speed optimized methods
class MLTrainingVersion$Type extends MessageType<MLTrainingVersion> {
    constructor() {
        super("viam.app.v1.MLTrainingVersion", [
            { no: 1, name: "version", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "created_on", kind: "message", T: () => Timestamp }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message viam.app.v1.MLTrainingVersion
 */
export const MLTrainingVersion = new MLTrainingVersion$Type();
// @generated message type with reflection information, may provide speed optimized methods
class MLTrainingMetadata$Type extends MessageType<MLTrainingMetadata> {
    constructor() {
        super("viam.app.v1.MLTrainingMetadata", [
            { no: 5, name: "versions", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => MLTrainingVersion },
            { no: 2, name: "model_type", kind: "enum", T: () => ["viam.app.mltraining.v1.ModelType", ModelType, "MODEL_TYPE_"] },
            { no: 3, name: "model_framework", kind: "enum", T: () => ["viam.app.mltraining.v1.ModelFramework", ModelFramework, "MODEL_FRAMEWORK_"] },
            { no: 4, name: "draft", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 6, name: "deployment_modular_resources", kind: "scalar", repeat: 2 /*RepeatType.UNPACKED*/, T: 9 /*ScalarType.STRING*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message viam.app.v1.MLTrainingMetadata
 */
export const MLTrainingMetadata = new MLTrainingMetadata$Type();
// @generated message type with reflection information, may provide speed optimized methods
class DeprecatedStatus$Type extends MessageType<DeprecatedStatus> {
    constructor() {
        super("viam.app.v1.DeprecatedStatus", [
            { no: 1, name: "deprecated_at", kind: "message", T: () => Timestamp },
            { no: 2, name: "message", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message viam.app.v1.DeprecatedStatus
 */
export const DeprecatedStatus = new DeprecatedStatus$Type();
// @generated message type with reflection information, may provide speed optimized methods
class RegistryItemBilling$Type extends MessageType<RegistryItemBilling> {
    constructor() {
        super("viam.app.v1.RegistryItemBilling", [
            { no: 1, name: "cost_per_month", kind: "message", oneof: "frequency", T: () => RegistryItemCostByResource },
            { no: 2, name: "cost_per_year", kind: "message", oneof: "frequency", T: () => RegistryItemCostByResource }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message viam.app.v1.RegistryItemBilling
 */
export const RegistryItemBilling = new RegistryItemBilling$Type();
// @generated message type with reflection information, may provide speed optimized methods
class RegistryItemCostByResource$Type extends MessageType<RegistryItemCostByResource> {
    constructor() {
        super("viam.app.v1.RegistryItemCostByResource", [
            { no: 1, name: "per_machine", kind: "scalar", T: 1 /*ScalarType.DOUBLE*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message viam.app.v1.RegistryItemCostByResource
 */
export const RegistryItemCostByResource = new RegistryItemCostByResource$Type();
// @generated message type with reflection information, may provide speed optimized methods
class RegistryItem$Type extends MessageType<RegistryItem> {
    constructor() {
        super("viam.app.v1.RegistryItem", [
            { no: 1, name: "item_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "organization_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "public_namespace", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 4, name: "name", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 5, name: "type", kind: "enum", T: () => ["viam.app.packages.v1.PackageType", PackageType, "PACKAGE_TYPE_"] },
            { no: 6, name: "visibility", kind: "enum", T: () => ["viam.app.v1.Visibility", Visibility, "VISIBILITY_"] },
            { no: 7, name: "url", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 8, name: "description", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 9, name: "total_robot_usage", kind: "scalar", T: 3 /*ScalarType.INT64*/ },
            { no: 13, name: "total_external_robot_usage", kind: "scalar", T: 3 /*ScalarType.INT64*/ },
            { no: 10, name: "total_organization_usage", kind: "scalar", T: 3 /*ScalarType.INT64*/ },
            { no: 14, name: "total_external_organization_usage", kind: "scalar", T: 3 /*ScalarType.INT64*/ },
            { no: 11, name: "module_metadata", kind: "message", oneof: "metadata", T: () => ModuleMetadata },
            { no: 12, name: "ml_model_metadata", kind: "message", oneof: "metadata", T: () => MLModelMetadata },
            { no: 18, name: "ml_training_metadata", kind: "message", oneof: "metadata", T: () => MLTrainingMetadata },
            { no: 15, name: "created_at", kind: "message", T: () => Timestamp },
            { no: 16, name: "updated_at", kind: "message", T: () => Timestamp },
            { no: 17, name: "deprecated_status", kind: "message", T: () => DeprecatedStatus },
            { no: 19, name: "billing", kind: "message", T: () => RegistryItemBilling }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message viam.app.v1.RegistryItem
 */
export const RegistryItem = new RegistryItem$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GetRegistryItemRequest$Type extends MessageType<GetRegistryItemRequest> {
    constructor() {
        super("viam.app.v1.GetRegistryItemRequest", [
            { no: 1, name: "item_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "include_markdown_documentation", kind: "scalar", opt: true, T: 8 /*ScalarType.BOOL*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message viam.app.v1.GetRegistryItemRequest
 */
export const GetRegistryItemRequest = new GetRegistryItemRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GetRegistryItemResponse$Type extends MessageType<GetRegistryItemResponse> {
    constructor() {
        super("viam.app.v1.GetRegistryItemResponse", [
            { no: 1, name: "item", kind: "message", T: () => RegistryItem }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message viam.app.v1.GetRegistryItemResponse
 */
export const GetRegistryItemResponse = new GetRegistryItemResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class CreateRegistryItemRequest$Type extends MessageType<CreateRegistryItemRequest> {
    constructor() {
        super("viam.app.v1.CreateRegistryItemRequest", [
            { no: 1, name: "organization_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "name", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "type", kind: "enum", T: () => ["viam.app.packages.v1.PackageType", PackageType, "PACKAGE_TYPE_"] }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message viam.app.v1.CreateRegistryItemRequest
 */
export const CreateRegistryItemRequest = new CreateRegistryItemRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class CreateRegistryItemResponse$Type extends MessageType<CreateRegistryItemResponse> {
    constructor() {
        super("viam.app.v1.CreateRegistryItemResponse", []);
    }
}
/**
 * @generated MessageType for protobuf message viam.app.v1.CreateRegistryItemResponse
 */
export const CreateRegistryItemResponse = new CreateRegistryItemResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class UpdateRegistryItemRequest$Type extends MessageType<UpdateRegistryItemRequest> {
    constructor() {
        super("viam.app.v1.UpdateRegistryItemRequest", [
            { no: 1, name: "item_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "type", kind: "enum", T: () => ["viam.app.packages.v1.PackageType", PackageType, "PACKAGE_TYPE_"] },
            { no: 3, name: "description", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 4, name: "visibility", kind: "enum", T: () => ["viam.app.v1.Visibility", Visibility, "VISIBILITY_"] },
            { no: 5, name: "url", kind: "scalar", opt: true, T: 9 /*ScalarType.STRING*/ },
            { no: 6, name: "update_module_metadata", kind: "message", oneof: "metadata", T: () => UpdateModuleMetadata },
            { no: 7, name: "update_ml_model_metadata", kind: "message", oneof: "metadata", T: () => UpdateMLModelMetadata },
            { no: 8, name: "update_ml_training_metadata", kind: "message", oneof: "metadata", T: () => UpdateMLTrainingMetadata },
            { no: 9, name: "markdown_description", kind: "scalar", opt: true, T: 9 /*ScalarType.STRING*/ },
            { no: 10, name: "billing", kind: "message", T: () => RegistryItemBilling }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message viam.app.v1.UpdateRegistryItemRequest
 */
export const UpdateRegistryItemRequest = new UpdateRegistryItemRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class UpdateRegistryItemResponse$Type extends MessageType<UpdateRegistryItemResponse> {
    constructor() {
        super("viam.app.v1.UpdateRegistryItemResponse", []);
    }
}
/**
 * @generated MessageType for protobuf message viam.app.v1.UpdateRegistryItemResponse
 */
export const UpdateRegistryItemResponse = new UpdateRegistryItemResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ListRegistryItemsRequest$Type extends MessageType<ListRegistryItemsRequest> {
    constructor() {
        super("viam.app.v1.ListRegistryItemsRequest", [
            { no: 1, name: "organization_id", kind: "scalar", opt: true, T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "types", kind: "enum", repeat: 1 /*RepeatType.PACKED*/, T: () => ["viam.app.packages.v1.PackageType", PackageType, "PACKAGE_TYPE_"] },
            { no: 3, name: "visibilities", kind: "enum", repeat: 1 /*RepeatType.PACKED*/, T: () => ["viam.app.v1.Visibility", Visibility, "VISIBILITY_"] },
            { no: 4, name: "platforms", kind: "scalar", repeat: 2 /*RepeatType.UNPACKED*/, T: 9 /*ScalarType.STRING*/ },
            { no: 5, name: "statuses", kind: "enum", repeat: 1 /*RepeatType.PACKED*/, T: () => ["viam.app.v1.RegistryItemStatus", RegistryItemStatus, "REGISTRY_ITEM_STATUS_"] },
            { no: 6, name: "search_term", kind: "scalar", opt: true, T: 9 /*ScalarType.STRING*/ },
            { no: 7, name: "page_token", kind: "scalar", opt: true, T: 9 /*ScalarType.STRING*/ },
            { no: 8, name: "public_namespaces", kind: "scalar", repeat: 2 /*RepeatType.UNPACKED*/, T: 9 /*ScalarType.STRING*/ },
            { no: 9, name: "include_markdown_documentation", kind: "scalar", opt: true, T: 8 /*ScalarType.BOOL*/ },
            { no: 10, name: "module_source_types", kind: "enum", repeat: 1 /*RepeatType.PACKED*/, T: () => ["viam.app.v1.ModuleSourceType", ModuleSourceType, "MODULE_SOURCE_TYPE_"] },
            { no: 11, name: "module_languages", kind: "enum", repeat: 1 /*RepeatType.PACKED*/, T: () => ["viam.app.v1.ModuleLanguage", ModuleLanguage, "MODULE_LANGUAGE_"] },
            { no: 12, name: "show_owned_deprecated", kind: "scalar", opt: true, T: 8 /*ScalarType.BOOL*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message viam.app.v1.ListRegistryItemsRequest
 */
export const ListRegistryItemsRequest = new ListRegistryItemsRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ListRegistryItemsResponse$Type extends MessageType<ListRegistryItemsResponse> {
    constructor() {
        super("viam.app.v1.ListRegistryItemsResponse", [
            { no: 1, name: "items", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => RegistryItem }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message viam.app.v1.ListRegistryItemsResponse
 */
export const ListRegistryItemsResponse = new ListRegistryItemsResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class DeleteRegistryItemRequest$Type extends MessageType<DeleteRegistryItemRequest> {
    constructor() {
        super("viam.app.v1.DeleteRegistryItemRequest", [
            { no: 1, name: "item_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message viam.app.v1.DeleteRegistryItemRequest
 */
export const DeleteRegistryItemRequest = new DeleteRegistryItemRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class DeleteRegistryItemResponse$Type extends MessageType<DeleteRegistryItemResponse> {
    constructor() {
        super("viam.app.v1.DeleteRegistryItemResponse", []);
    }
}
/**
 * @generated MessageType for protobuf message viam.app.v1.DeleteRegistryItemResponse
 */
export const DeleteRegistryItemResponse = new DeleteRegistryItemResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class RenameRegistryItemRequest$Type extends MessageType<RenameRegistryItemRequest> {
    constructor() {
        super("viam.app.v1.RenameRegistryItemRequest", [
            { no: 1, name: "item_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "new_name", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message viam.app.v1.RenameRegistryItemRequest
 */
export const RenameRegistryItemRequest = new RenameRegistryItemRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class RenameRegistryItemResponse$Type extends MessageType<RenameRegistryItemResponse> {
    constructor() {
        super("viam.app.v1.RenameRegistryItemResponse", [
            { no: 1, name: "item", kind: "message", T: () => RegistryItem }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message viam.app.v1.RenameRegistryItemResponse
 */
export const RenameRegistryItemResponse = new RenameRegistryItemResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class TransferRegistryItemRequest$Type extends MessageType<TransferRegistryItemRequest> {
    constructor() {
        super("viam.app.v1.TransferRegistryItemRequest", [
            { no: 1, name: "item_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "new_public_namespace", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message viam.app.v1.TransferRegistryItemRequest
 */
export const TransferRegistryItemRequest = new TransferRegistryItemRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class TransferRegistryItemResponse$Type extends MessageType<TransferRegistryItemResponse> {
    constructor() {
        super("viam.app.v1.TransferRegistryItemResponse", []);
    }
}
/**
 * @generated MessageType for protobuf message viam.app.v1.TransferRegistryItemResponse
 */
export const TransferRegistryItemResponse = new TransferRegistryItemResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class DeprecateRegistryItemRequest$Type extends MessageType<DeprecateRegistryItemRequest> {
    constructor() {
        super("viam.app.v1.DeprecateRegistryItemRequest", [
            { no: 1, name: "item_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "message", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message viam.app.v1.DeprecateRegistryItemRequest
 */
export const DeprecateRegistryItemRequest = new DeprecateRegistryItemRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class DeprecateRegistryItemResponse$Type extends MessageType<DeprecateRegistryItemResponse> {
    constructor() {
        super("viam.app.v1.DeprecateRegistryItemResponse", []);
    }
}
/**
 * @generated MessageType for protobuf message viam.app.v1.DeprecateRegistryItemResponse
 */
export const DeprecateRegistryItemResponse = new DeprecateRegistryItemResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class UndeprecateRegistryItemRequest$Type extends MessageType<UndeprecateRegistryItemRequest> {
    constructor() {
        super("viam.app.v1.UndeprecateRegistryItemRequest", [
            { no: 1, name: "item_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message viam.app.v1.UndeprecateRegistryItemRequest
 */
export const UndeprecateRegistryItemRequest = new UndeprecateRegistryItemRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class UndeprecateRegistryItemResponse$Type extends MessageType<UndeprecateRegistryItemResponse> {
    constructor() {
        super("viam.app.v1.UndeprecateRegistryItemResponse", []);
    }
}
/**
 * @generated MessageType for protobuf message viam.app.v1.UndeprecateRegistryItemResponse
 */
export const UndeprecateRegistryItemResponse = new UndeprecateRegistryItemResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class CreateModuleRequest$Type extends MessageType<CreateModuleRequest> {
    constructor() {
        super("viam.app.v1.CreateModuleRequest", [
            { no: 1, name: "organization_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "name", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message viam.app.v1.CreateModuleRequest
 */
export const CreateModuleRequest = new CreateModuleRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class CreateModuleResponse$Type extends MessageType<CreateModuleResponse> {
    constructor() {
        super("viam.app.v1.CreateModuleResponse", [
            { no: 1, name: "module_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "url", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message viam.app.v1.CreateModuleResponse
 */
export const CreateModuleResponse = new CreateModuleResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class UpdateModuleRequest$Type extends MessageType<UpdateModuleRequest> {
    constructor() {
        super("viam.app.v1.UpdateModuleRequest", [
            { no: 1, name: "module_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "visibility", kind: "enum", T: () => ["viam.app.v1.Visibility", Visibility, "VISIBILITY_"] },
            { no: 3, name: "url", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 4, name: "description", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 5, name: "models", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => Model },
            { no: 6, name: "entrypoint", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 7, name: "first_run", kind: "scalar", opt: true, T: 9 /*ScalarType.STRING*/ },
            { no: 8, name: "apps", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => App },
            { no: 9, name: "markdown_description", kind: "scalar", opt: true, T: 9 /*ScalarType.STRING*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message viam.app.v1.UpdateModuleRequest
 */
export const UpdateModuleRequest = new UpdateModuleRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class AllowedOrgIDs$Type extends MessageType<AllowedOrgIDs> {
    constructor() {
        super("viam.app.v1.AllowedOrgIDs", [
            { no: 1, name: "ids", kind: "scalar", repeat: 2 /*RepeatType.UNPACKED*/, T: 9 /*ScalarType.STRING*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message viam.app.v1.AllowedOrgIDs
 */
export const AllowedOrgIDs = new AllowedOrgIDs$Type();
// @generated message type with reflection information, may provide speed optimized methods
class App$Type extends MessageType<App> {
    constructor() {
        super("viam.app.v1.App", [
            { no: 1, name: "name", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "type", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "entrypoint", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 4, name: "fragment_ids", kind: "scalar", repeat: 2 /*RepeatType.UNPACKED*/, T: 9 /*ScalarType.STRING*/ },
            { no: 5, name: "logo_path", kind: "scalar", opt: true, T: 9 /*ScalarType.STRING*/ },
            { no: 6, name: "customizations", kind: "message", T: () => AppCustomizations },
            { no: 7, name: "allowed_org_ids", kind: "message", T: () => AllowedOrgIDs }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message viam.app.v1.App
 */
export const App = new App$Type();
// @generated message type with reflection information, may provide speed optimized methods
class UpdateModuleResponse$Type extends MessageType<UpdateModuleResponse> {
    constructor() {
        super("viam.app.v1.UpdateModuleResponse", [
            { no: 1, name: "url", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message viam.app.v1.UpdateModuleResponse
 */
export const UpdateModuleResponse = new UpdateModuleResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class UpdateModuleMetadata$Type extends MessageType<UpdateModuleMetadata> {
    constructor() {
        super("viam.app.v1.UpdateModuleMetadata", [
            { no: 1, name: "models", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => Model },
            { no: 2, name: "entrypoint", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "apps", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => App },
            { no: 4, name: "source_type", kind: "enum", opt: true, T: () => ["viam.app.v1.ModuleSourceType", ModuleSourceType, "MODULE_SOURCE_TYPE_"] },
            { no: 5, name: "language", kind: "enum", opt: true, T: () => ["viam.app.v1.ModuleLanguage", ModuleLanguage, "MODULE_LANGUAGE_"] },
            { no: 6, name: "min_viam_server_version", kind: "scalar", opt: true, T: 9 /*ScalarType.STRING*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message viam.app.v1.UpdateModuleMetadata
 */
export const UpdateModuleMetadata = new UpdateModuleMetadata$Type();
// @generated message type with reflection information, may provide speed optimized methods
class UpdateMLModelMetadata$Type extends MessageType<UpdateMLModelMetadata> {
    constructor() {
        super("viam.app.v1.UpdateMLModelMetadata", [
            { no: 1, name: "model_type", kind: "enum", T: () => ["viam.app.mltraining.v1.ModelType", ModelType, "MODEL_TYPE_"] },
            { no: 2, name: "model_framework", kind: "enum", T: () => ["viam.app.mltraining.v1.ModelFramework", ModelFramework, "MODEL_FRAMEWORK_"] },
            { no: 3, name: "deployment_modular_resources", kind: "scalar", repeat: 2 /*RepeatType.UNPACKED*/, T: 9 /*ScalarType.STRING*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message viam.app.v1.UpdateMLModelMetadata
 */
export const UpdateMLModelMetadata = new UpdateMLModelMetadata$Type();
// @generated message type with reflection information, may provide speed optimized methods
class UpdateMLTrainingMetadata$Type extends MessageType<UpdateMLTrainingMetadata> {
    constructor() {
        super("viam.app.v1.UpdateMLTrainingMetadata", [
            { no: 1, name: "model_type", kind: "enum", T: () => ["viam.app.mltraining.v1.ModelType", ModelType, "MODEL_TYPE_"] },
            { no: 2, name: "model_framework", kind: "enum", T: () => ["viam.app.mltraining.v1.ModelFramework", ModelFramework, "MODEL_FRAMEWORK_"] },
            { no: 3, name: "draft", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 4, name: "deployment_modular_resources", kind: "scalar", repeat: 2 /*RepeatType.UNPACKED*/, T: 9 /*ScalarType.STRING*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message viam.app.v1.UpdateMLTrainingMetadata
 */
export const UpdateMLTrainingMetadata = new UpdateMLTrainingMetadata$Type();
// @generated message type with reflection information, may provide speed optimized methods
class Model$Type extends MessageType<Model> {
    constructor() {
        super("viam.app.v1.Model", [
            { no: 1, name: "api", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "model", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "markdown_documentation", kind: "scalar", opt: true, T: 9 /*ScalarType.STRING*/ },
            { no: 4, name: "description", kind: "scalar", opt: true, T: 9 /*ScalarType.STRING*/ },
            { no: 5, name: "supported_hardware", kind: "scalar", repeat: 2 /*RepeatType.UNPACKED*/, T: 9 /*ScalarType.STRING*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message viam.app.v1.Model
 */
export const Model = new Model$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ModuleFileInfo$Type extends MessageType<ModuleFileInfo> {
    constructor() {
        super("viam.app.v1.ModuleFileInfo", [
            { no: 1, name: "module_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "version", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "platform", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 5, name: "platform_tags", kind: "scalar", repeat: 2 /*RepeatType.UNPACKED*/, T: 9 /*ScalarType.STRING*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message viam.app.v1.ModuleFileInfo
 */
export const ModuleFileInfo = new ModuleFileInfo$Type();
// @generated message type with reflection information, may provide speed optimized methods
class UploadModuleFileRequest$Type extends MessageType<UploadModuleFileRequest> {
    constructor() {
        super("viam.app.v1.UploadModuleFileRequest", [
            { no: 1, name: "module_file_info", kind: "message", oneof: "moduleFile", T: () => ModuleFileInfo },
            { no: 2, name: "file", kind: "scalar", oneof: "moduleFile", T: 12 /*ScalarType.BYTES*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message viam.app.v1.UploadModuleFileRequest
 */
export const UploadModuleFileRequest = new UploadModuleFileRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class UploadModuleFileResponse$Type extends MessageType<UploadModuleFileResponse> {
    constructor() {
        super("viam.app.v1.UploadModuleFileResponse", [
            { no: 1, name: "url", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message viam.app.v1.UploadModuleFileResponse
 */
export const UploadModuleFileResponse = new UploadModuleFileResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GetModuleRequest$Type extends MessageType<GetModuleRequest> {
    constructor() {
        super("viam.app.v1.GetModuleRequest", [
            { no: 1, name: "module_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "include_markdown_documentation", kind: "scalar", opt: true, T: 8 /*ScalarType.BOOL*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message viam.app.v1.GetModuleRequest
 */
export const GetModuleRequest = new GetModuleRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GetModuleResponse$Type extends MessageType<GetModuleResponse> {
    constructor() {
        super("viam.app.v1.GetModuleResponse", [
            { no: 1, name: "module", kind: "message", T: () => Module }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message viam.app.v1.GetModuleResponse
 */
export const GetModuleResponse = new GetModuleResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class Module$Type extends MessageType<Module> {
    constructor() {
        super("viam.app.v1.Module", [
            { no: 1, name: "module_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "name", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "visibility", kind: "enum", T: () => ["viam.app.v1.Visibility", Visibility, "VISIBILITY_"] },
            { no: 4, name: "versions", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => VersionHistory },
            { no: 5, name: "url", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 6, name: "description", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 7, name: "models", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => Model },
            { no: 8, name: "total_robot_usage", kind: "scalar", T: 3 /*ScalarType.INT64*/ },
            { no: 9, name: "total_organization_usage", kind: "scalar", T: 3 /*ScalarType.INT64*/ },
            { no: 10, name: "organization_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 11, name: "entrypoint", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 12, name: "public_namespace", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 13, name: "first_run", kind: "scalar", opt: true, T: 9 /*ScalarType.STRING*/ },
            { no: 14, name: "markdown_description", kind: "scalar", opt: true, T: 9 /*ScalarType.STRING*/ },
            { no: 15, name: "apps", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => App },
            { no: 16, name: "deprecated_status", kind: "message", T: () => DeprecatedStatus }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message viam.app.v1.Module
 */
export const Module = new Module$Type();
// @generated message type with reflection information, may provide speed optimized methods
class VersionHistory$Type extends MessageType<VersionHistory> {
    constructor() {
        super("viam.app.v1.VersionHistory", [
            { no: 1, name: "version", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "files", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => Uploads },
            { no: 3, name: "models", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => Model },
            { no: 4, name: "entrypoint", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 5, name: "first_run", kind: "scalar", opt: true, T: 9 /*ScalarType.STRING*/ },
            { no: 6, name: "markdown_description", kind: "scalar", opt: true, T: 9 /*ScalarType.STRING*/ },
            { no: 7, name: "apps", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => App },
            { no: 8, name: "deprecated_status", kind: "message", T: () => DeprecatedStatus }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message viam.app.v1.VersionHistory
 */
export const VersionHistory = new VersionHistory$Type();
// @generated message type with reflection information, may provide speed optimized methods
class Uploads$Type extends MessageType<Uploads> {
    constructor() {
        super("viam.app.v1.Uploads", [
            { no: 1, name: "platform", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "uploaded_at", kind: "message", T: () => Timestamp }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message viam.app.v1.Uploads
 */
export const Uploads = new Uploads$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ListModulesRequest$Type extends MessageType<ListModulesRequest> {
    constructor() {
        super("viam.app.v1.ListModulesRequest", [
            { no: 1, name: "organization_id", kind: "scalar", opt: true, T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "include_markdown_documentation", kind: "scalar", opt: true, T: 8 /*ScalarType.BOOL*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message viam.app.v1.ListModulesRequest
 */
export const ListModulesRequest = new ListModulesRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ListModulesResponse$Type extends MessageType<ListModulesResponse> {
    constructor() {
        super("viam.app.v1.ListModulesResponse", [
            { no: 1, name: "modules", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => Module }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message viam.app.v1.ListModulesResponse
 */
export const ListModulesResponse = new ListModulesResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class DeprecateRegistryItemVersionRequest$Type extends MessageType<DeprecateRegistryItemVersionRequest> {
    constructor() {
        super("viam.app.v1.DeprecateRegistryItemVersionRequest", [
            { no: 1, name: "item_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "version", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "message", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message viam.app.v1.DeprecateRegistryItemVersionRequest
 */
export const DeprecateRegistryItemVersionRequest = new DeprecateRegistryItemVersionRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class DeprecateRegistryItemVersionResponse$Type extends MessageType<DeprecateRegistryItemVersionResponse> {
    constructor() {
        super("viam.app.v1.DeprecateRegistryItemVersionResponse", []);
    }
}
/**
 * @generated MessageType for protobuf message viam.app.v1.DeprecateRegistryItemVersionResponse
 */
export const DeprecateRegistryItemVersionResponse = new DeprecateRegistryItemVersionResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class UndeprecateRegistryItemVersionRequest$Type extends MessageType<UndeprecateRegistryItemVersionRequest> {
    constructor() {
        super("viam.app.v1.UndeprecateRegistryItemVersionRequest", [
            { no: 1, name: "item_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "version", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message viam.app.v1.UndeprecateRegistryItemVersionRequest
 */
export const UndeprecateRegistryItemVersionRequest = new UndeprecateRegistryItemVersionRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class UndeprecateRegistryItemVersionResponse$Type extends MessageType<UndeprecateRegistryItemVersionResponse> {
    constructor() {
        super("viam.app.v1.UndeprecateRegistryItemVersionResponse", []);
    }
}
/**
 * @generated MessageType for protobuf message viam.app.v1.UndeprecateRegistryItemVersionResponse
 */
export const UndeprecateRegistryItemVersionResponse = new UndeprecateRegistryItemVersionResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GetUserIDByEmailRequest$Type extends MessageType<GetUserIDByEmailRequest> {
    constructor() {
        super("viam.app.v1.GetUserIDByEmailRequest", [
            { no: 1, name: "email", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message viam.app.v1.GetUserIDByEmailRequest
 */
export const GetUserIDByEmailRequest = new GetUserIDByEmailRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GetUserIDByEmailResponse$Type extends MessageType<GetUserIDByEmailResponse> {
    constructor() {
        super("viam.app.v1.GetUserIDByEmailResponse", [
            { no: 1, name: "user_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message viam.app.v1.GetUserIDByEmailResponse
 */
export const GetUserIDByEmailResponse = new GetUserIDByEmailResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ListOrganizationsByUserRequest$Type extends MessageType<ListOrganizationsByUserRequest> {
    constructor() {
        super("viam.app.v1.ListOrganizationsByUserRequest", [
            { no: 1, name: "user_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message viam.app.v1.ListOrganizationsByUserRequest
 */
export const ListOrganizationsByUserRequest = new ListOrganizationsByUserRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class OrgDetails$Type extends MessageType<OrgDetails> {
    constructor() {
        super("viam.app.v1.OrgDetails", [
            { no: 1, name: "org_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "org_name", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "org_cid", kind: "scalar", opt: true, T: 9 /*ScalarType.STRING*/ },
            { no: 4, name: "public_namespace", kind: "scalar", opt: true, T: 9 /*ScalarType.STRING*/ },
            { no: 5, name: "billing_tier", kind: "scalar", opt: true, T: 9 /*ScalarType.STRING*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message viam.app.v1.OrgDetails
 */
export const OrgDetails = new OrgDetails$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ListOrganizationsByUserResponse$Type extends MessageType<ListOrganizationsByUserResponse> {
    constructor() {
        super("viam.app.v1.ListOrganizationsByUserResponse", [
            { no: 1, name: "orgs", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => OrgDetails }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message viam.app.v1.ListOrganizationsByUserResponse
 */
export const ListOrganizationsByUserResponse = new ListOrganizationsByUserResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class SearchOrganizationsRequest$Type extends MessageType<SearchOrganizationsRequest> {
    constructor() {
        super("viam.app.v1.SearchOrganizationsRequest", [
            { no: 1, name: "org_id", kind: "scalar", opt: true, T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "org_name", kind: "scalar", opt: true, T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "cid", kind: "scalar", opt: true, T: 9 /*ScalarType.STRING*/ },
            { no: 4, name: "public_namespace", kind: "scalar", opt: true, T: 9 /*ScalarType.STRING*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message viam.app.v1.SearchOrganizationsRequest
 */
export const SearchOrganizationsRequest = new SearchOrganizationsRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class SearchOrganizationsResponse$Type extends MessageType<SearchOrganizationsResponse> {
    constructor() {
        super("viam.app.v1.SearchOrganizationsResponse", [
            { no: 1, name: "organizations", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => OrgDetails }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message viam.app.v1.SearchOrganizationsResponse
 */
export const SearchOrganizationsResponse = new SearchOrganizationsResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class CreateKeyRequest$Type extends MessageType<CreateKeyRequest> {
    constructor() {
        super("viam.app.v1.CreateKeyRequest", [
            { no: 1, name: "authorizations", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => Authorization },
            { no: 2, name: "name", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message viam.app.v1.CreateKeyRequest
 */
export const CreateKeyRequest = new CreateKeyRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class CreateKeyResponse$Type extends MessageType<CreateKeyResponse> {
    constructor() {
        super("viam.app.v1.CreateKeyResponse", [
            { no: 1, name: "key", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "id", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message viam.app.v1.CreateKeyResponse
 */
export const CreateKeyResponse = new CreateKeyResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class DeleteKeyRequest$Type extends MessageType<DeleteKeyRequest> {
    constructor() {
        super("viam.app.v1.DeleteKeyRequest", [
            { no: 1, name: "id", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message viam.app.v1.DeleteKeyRequest
 */
export const DeleteKeyRequest = new DeleteKeyRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class DeleteKeyResponse$Type extends MessageType<DeleteKeyResponse> {
    constructor() {
        super("viam.app.v1.DeleteKeyResponse", []);
    }
}
/**
 * @generated MessageType for protobuf message viam.app.v1.DeleteKeyResponse
 */
export const DeleteKeyResponse = new DeleteKeyResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class RenameKeyRequest$Type extends MessageType<RenameKeyRequest> {
    constructor() {
        super("viam.app.v1.RenameKeyRequest", [
            { no: 1, name: "id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "name", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message viam.app.v1.RenameKeyRequest
 */
export const RenameKeyRequest = new RenameKeyRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class RenameKeyResponse$Type extends MessageType<RenameKeyResponse> {
    constructor() {
        super("viam.app.v1.RenameKeyResponse", [
            { no: 1, name: "id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "name", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message viam.app.v1.RenameKeyResponse
 */
export const RenameKeyResponse = new RenameKeyResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class AuthorizationDetails$Type extends MessageType<AuthorizationDetails> {
    constructor() {
        super("viam.app.v1.AuthorizationDetails", [
            { no: 1, name: "authorization_type", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "authorization_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "resource_type", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 4, name: "resource_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 5, name: "org_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message viam.app.v1.AuthorizationDetails
 */
export const AuthorizationDetails = new AuthorizationDetails$Type();
// @generated message type with reflection information, may provide speed optimized methods
class APIKeyWithAuthorizations$Type extends MessageType<APIKeyWithAuthorizations> {
    constructor() {
        super("viam.app.v1.APIKeyWithAuthorizations", [
            { no: 1, name: "api_key", kind: "message", T: () => APIKey },
            { no: 2, name: "authorizations", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => AuthorizationDetails }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message viam.app.v1.APIKeyWithAuthorizations
 */
export const APIKeyWithAuthorizations = new APIKeyWithAuthorizations$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ListKeysRequest$Type extends MessageType<ListKeysRequest> {
    constructor() {
        super("viam.app.v1.ListKeysRequest", [
            { no: 1, name: "org_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message viam.app.v1.ListKeysRequest
 */
export const ListKeysRequest = new ListKeysRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ListKeysResponse$Type extends MessageType<ListKeysResponse> {
    constructor() {
        super("viam.app.v1.ListKeysResponse", [
            { no: 1, name: "api_keys", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => APIKeyWithAuthorizations }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message viam.app.v1.ListKeysResponse
 */
export const ListKeysResponse = new ListKeysResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class RotateKeyRequest$Type extends MessageType<RotateKeyRequest> {
    constructor() {
        super("viam.app.v1.RotateKeyRequest", [
            { no: 1, name: "id", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message viam.app.v1.RotateKeyRequest
 */
export const RotateKeyRequest = new RotateKeyRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class RotateKeyResponse$Type extends MessageType<RotateKeyResponse> {
    constructor() {
        super("viam.app.v1.RotateKeyResponse", [
            { no: 1, name: "id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "key", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message viam.app.v1.RotateKeyResponse
 */
export const RotateKeyResponse = new RotateKeyResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class CreateKeyFromExistingKeyAuthorizationsRequest$Type extends MessageType<CreateKeyFromExistingKeyAuthorizationsRequest> {
    constructor() {
        super("viam.app.v1.CreateKeyFromExistingKeyAuthorizationsRequest", [
            { no: 1, name: "id", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message viam.app.v1.CreateKeyFromExistingKeyAuthorizationsRequest
 */
export const CreateKeyFromExistingKeyAuthorizationsRequest = new CreateKeyFromExistingKeyAuthorizationsRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class CreateKeyFromExistingKeyAuthorizationsResponse$Type extends MessageType<CreateKeyFromExistingKeyAuthorizationsResponse> {
    constructor() {
        super("viam.app.v1.CreateKeyFromExistingKeyAuthorizationsResponse", [
            { no: 1, name: "id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "key", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message viam.app.v1.CreateKeyFromExistingKeyAuthorizationsResponse
 */
export const CreateKeyFromExistingKeyAuthorizationsResponse = new CreateKeyFromExistingKeyAuthorizationsResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GetAppContentRequest$Type extends MessageType<GetAppContentRequest> {
    constructor() {
        super("viam.app.v1.GetAppContentRequest", [
            { no: 1, name: "public_namespace", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "name", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message viam.app.v1.GetAppContentRequest
 */
export const GetAppContentRequest = new GetAppContentRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GetAppContentResponse$Type extends MessageType<GetAppContentResponse> {
    constructor() {
        super("viam.app.v1.GetAppContentResponse", [
            { no: 1, name: "blob_path", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "entrypoint", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "app_type", kind: "enum", T: () => ["viam.app.v1.AppType", AppType, "APP_TYPE_"] },
            { no: 4, name: "public", kind: "scalar", T: 8 /*ScalarType.BOOL*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message viam.app.v1.GetAppContentResponse
 */
export const GetAppContentResponse = new GetAppContentResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class OrganizationSetLogoRequest$Type extends MessageType<OrganizationSetLogoRequest> {
    constructor() {
        super("viam.app.v1.OrganizationSetLogoRequest", [
            { no: 1, name: "org_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "logo", kind: "scalar", T: 12 /*ScalarType.BYTES*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message viam.app.v1.OrganizationSetLogoRequest
 */
export const OrganizationSetLogoRequest = new OrganizationSetLogoRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class OrganizationSetLogoResponse$Type extends MessageType<OrganizationSetLogoResponse> {
    constructor() {
        super("viam.app.v1.OrganizationSetLogoResponse", []);
    }
}
/**
 * @generated MessageType for protobuf message viam.app.v1.OrganizationSetLogoResponse
 */
export const OrganizationSetLogoResponse = new OrganizationSetLogoResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class OrganizationGetLogoRequest$Type extends MessageType<OrganizationGetLogoRequest> {
    constructor() {
        super("viam.app.v1.OrganizationGetLogoRequest", [
            { no: 1, name: "org_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message viam.app.v1.OrganizationGetLogoRequest
 */
export const OrganizationGetLogoRequest = new OrganizationGetLogoRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class OrganizationGetLogoResponse$Type extends MessageType<OrganizationGetLogoResponse> {
    constructor() {
        super("viam.app.v1.OrganizationGetLogoResponse", [
            { no: 1, name: "url", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message viam.app.v1.OrganizationGetLogoResponse
 */
export const OrganizationGetLogoResponse = new OrganizationGetLogoResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class EnableAuthServiceRequest$Type extends MessageType<EnableAuthServiceRequest> {
    constructor() {
        super("viam.app.v1.EnableAuthServiceRequest", [
            { no: 1, name: "org_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message viam.app.v1.EnableAuthServiceRequest
 */
export const EnableAuthServiceRequest = new EnableAuthServiceRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class EnableAuthServiceResponse$Type extends MessageType<EnableAuthServiceResponse> {
    constructor() {
        super("viam.app.v1.EnableAuthServiceResponse", []);
    }
}
/**
 * @generated MessageType for protobuf message viam.app.v1.EnableAuthServiceResponse
 */
export const EnableAuthServiceResponse = new EnableAuthServiceResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class DisableAuthServiceRequest$Type extends MessageType<DisableAuthServiceRequest> {
    constructor() {
        super("viam.app.v1.DisableAuthServiceRequest", [
            { no: 1, name: "org_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message viam.app.v1.DisableAuthServiceRequest
 */
export const DisableAuthServiceRequest = new DisableAuthServiceRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class DisableAuthServiceResponse$Type extends MessageType<DisableAuthServiceResponse> {
    constructor() {
        super("viam.app.v1.DisableAuthServiceResponse", []);
    }
}
/**
 * @generated MessageType for protobuf message viam.app.v1.DisableAuthServiceResponse
 */
export const DisableAuthServiceResponse = new DisableAuthServiceResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class CreateOAuthAppRequest$Type extends MessageType<CreateOAuthAppRequest> {
    constructor() {
        super("viam.app.v1.CreateOAuthAppRequest", [
            { no: 1, name: "org_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "client_name", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "oauth_config", kind: "message", T: () => OAuthConfig }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message viam.app.v1.CreateOAuthAppRequest
 */
export const CreateOAuthAppRequest = new CreateOAuthAppRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class CreateOAuthAppResponse$Type extends MessageType<CreateOAuthAppResponse> {
    constructor() {
        super("viam.app.v1.CreateOAuthAppResponse", [
            { no: 1, name: "client_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "client_secret", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message viam.app.v1.CreateOAuthAppResponse
 */
export const CreateOAuthAppResponse = new CreateOAuthAppResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ReadOAuthAppRequest$Type extends MessageType<ReadOAuthAppRequest> {
    constructor() {
        super("viam.app.v1.ReadOAuthAppRequest", [
            { no: 1, name: "org_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "client_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message viam.app.v1.ReadOAuthAppRequest
 */
export const ReadOAuthAppRequest = new ReadOAuthAppRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ReadOAuthAppResponse$Type extends MessageType<ReadOAuthAppResponse> {
    constructor() {
        super("viam.app.v1.ReadOAuthAppResponse", [
            { no: 1, name: "client_name", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "client_secret", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "oauth_config", kind: "message", T: () => OAuthConfig }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message viam.app.v1.ReadOAuthAppResponse
 */
export const ReadOAuthAppResponse = new ReadOAuthAppResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class UpdateOAuthAppRequest$Type extends MessageType<UpdateOAuthAppRequest> {
    constructor() {
        super("viam.app.v1.UpdateOAuthAppRequest", [
            { no: 1, name: "org_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "client_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "client_name", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 4, name: "oauth_config", kind: "message", T: () => OAuthConfig }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message viam.app.v1.UpdateOAuthAppRequest
 */
export const UpdateOAuthAppRequest = new UpdateOAuthAppRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class UpdateOAuthAppResponse$Type extends MessageType<UpdateOAuthAppResponse> {
    constructor() {
        super("viam.app.v1.UpdateOAuthAppResponse", []);
    }
}
/**
 * @generated MessageType for protobuf message viam.app.v1.UpdateOAuthAppResponse
 */
export const UpdateOAuthAppResponse = new UpdateOAuthAppResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class DeleteOAuthAppRequest$Type extends MessageType<DeleteOAuthAppRequest> {
    constructor() {
        super("viam.app.v1.DeleteOAuthAppRequest", [
            { no: 1, name: "org_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "client_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message viam.app.v1.DeleteOAuthAppRequest
 */
export const DeleteOAuthAppRequest = new DeleteOAuthAppRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class DeleteOAuthAppResponse$Type extends MessageType<DeleteOAuthAppResponse> {
    constructor() {
        super("viam.app.v1.DeleteOAuthAppResponse", []);
    }
}
/**
 * @generated MessageType for protobuf message viam.app.v1.DeleteOAuthAppResponse
 */
export const DeleteOAuthAppResponse = new DeleteOAuthAppResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ListOAuthAppsRequest$Type extends MessageType<ListOAuthAppsRequest> {
    constructor() {
        super("viam.app.v1.ListOAuthAppsRequest", [
            { no: 1, name: "org_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message viam.app.v1.ListOAuthAppsRequest
 */
export const ListOAuthAppsRequest = new ListOAuthAppsRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ListOAuthAppsResponse$Type extends MessageType<ListOAuthAppsResponse> {
    constructor() {
        super("viam.app.v1.ListOAuthAppsResponse", [
            { no: 1, name: "client_ids", kind: "scalar", repeat: 2 /*RepeatType.UNPACKED*/, T: 9 /*ScalarType.STRING*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message viam.app.v1.ListOAuthAppsResponse
 */
export const ListOAuthAppsResponse = new ListOAuthAppsResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class CreateOAuthAppUserRequest$Type extends MessageType<CreateOAuthAppUserRequest> {
    constructor() {
        super("viam.app.v1.CreateOAuthAppUserRequest", [
            { no: 1, name: "org_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "application_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "email", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 4, name: "first_name", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 5, name: "last_name", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 6, name: "password", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message viam.app.v1.CreateOAuthAppUserRequest
 */
export const CreateOAuthAppUserRequest = new CreateOAuthAppUserRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class CreateOAuthAppUserResponse$Type extends MessageType<CreateOAuthAppUserResponse> {
    constructor() {
        super("viam.app.v1.CreateOAuthAppUserResponse", [
            { no: 1, name: "auth_token", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "registration_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "user_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 4, name: "refresh_token", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message viam.app.v1.CreateOAuthAppUserResponse
 */
export const CreateOAuthAppUserResponse = new CreateOAuthAppUserResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class OAuthConfig$Type extends MessageType<OAuthConfig> {
    constructor() {
        super("viam.app.v1.OAuthConfig", [
            { no: 1, name: "client_authentication", kind: "enum", T: () => ["viam.app.v1.ClientAuthentication", ClientAuthentication, "CLIENT_AUTHENTICATION_"] },
            { no: 2, name: "pkce", kind: "enum", T: () => ["viam.app.v1.PKCE", PKCE] },
            { no: 3, name: "url_validation", kind: "enum", T: () => ["viam.app.v1.URLValidation", URLValidation] },
            { no: 4, name: "origin_uris", kind: "scalar", repeat: 2 /*RepeatType.UNPACKED*/, T: 9 /*ScalarType.STRING*/ },
            { no: 5, name: "redirect_uris", kind: "scalar", repeat: 2 /*RepeatType.UNPACKED*/, T: 9 /*ScalarType.STRING*/ },
            { no: 6, name: "logout_uri", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 7, name: "enabled_grants", kind: "enum", repeat: 1 /*RepeatType.PACKED*/, T: () => ["viam.app.v1.EnabledGrant", EnabledGrant, "ENABLED_GRANT_"] },
            { no: 8, name: "invite_redirect_uri", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message viam.app.v1.OAuthConfig
 */
export const OAuthConfig = new OAuthConfig$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GetAppBrandingRequest$Type extends MessageType<GetAppBrandingRequest> {
    constructor() {
        super("viam.app.v1.GetAppBrandingRequest", [
            { no: 1, name: "public_namespace", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "name", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message viam.app.v1.GetAppBrandingRequest
 */
export const GetAppBrandingRequest = new GetAppBrandingRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class TextOverrides$Type extends MessageType<TextOverrides> {
    constructor() {
        super("viam.app.v1.TextOverrides", [
            { no: 1, name: "fields", kind: "map", K: 9 /*ScalarType.STRING*/, V: { kind: "scalar", T: 9 /*ScalarType.STRING*/ } }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message viam.app.v1.TextOverrides
 */
export const TextOverrides = new TextOverrides$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GetAppBrandingResponse$Type extends MessageType<GetAppBrandingResponse> {
    constructor() {
        super("viam.app.v1.GetAppBrandingResponse", [
            { no: 1, name: "logo_path", kind: "scalar", opt: true, T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "text_customizations", kind: "map", K: 9 /*ScalarType.STRING*/, V: { kind: "message", T: () => TextOverrides } },
            { no: 3, name: "fragment_ids", kind: "scalar", repeat: 2 /*RepeatType.UNPACKED*/, T: 9 /*ScalarType.STRING*/ },
            { no: 4, name: "allowed_org_ids", kind: "scalar", repeat: 2 /*RepeatType.UNPACKED*/, T: 9 /*ScalarType.STRING*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message viam.app.v1.GetAppBrandingResponse
 */
export const GetAppBrandingResponse = new GetAppBrandingResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class AppCustomizations$Type extends MessageType<AppCustomizations> {
    constructor() {
        super("viam.app.v1.AppCustomizations", [
            { no: 1, name: "machine_picker", kind: "message", T: () => MachinePickerCustomizations }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message viam.app.v1.AppCustomizations
 */
export const AppCustomizations = new AppCustomizations$Type();
// @generated message type with reflection information, may provide speed optimized methods
class MachinePickerCustomizations$Type extends MessageType<MachinePickerCustomizations> {
    constructor() {
        super("viam.app.v1.MachinePickerCustomizations", [
            { no: 1, name: "heading", kind: "scalar", opt: true, T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "subheading", kind: "scalar", opt: true, T: 9 /*ScalarType.STRING*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message viam.app.v1.MachinePickerCustomizations
 */
export const MachinePickerCustomizations = new MachinePickerCustomizations$Type();
// @generated message type with reflection information, may provide speed optimized methods
class UploadDevicePushTokenRequest$Type extends MessageType<UploadDevicePushTokenRequest> {
    constructor() {
        super("viam.app.v1.UploadDevicePushTokenRequest", [
            { no: 1, name: "app_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "device_token", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "device_uuid", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message viam.app.v1.UploadDevicePushTokenRequest
 */
export const UploadDevicePushTokenRequest = new UploadDevicePushTokenRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class UploadDevicePushTokenResponse$Type extends MessageType<UploadDevicePushTokenResponse> {
    constructor() {
        super("viam.app.v1.UploadDevicePushTokenResponse", []);
    }
}
/**
 * @generated MessageType for protobuf message viam.app.v1.UploadDevicePushTokenResponse
 */
export const UploadDevicePushTokenResponse = new UploadDevicePushTokenResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class DeleteDevicePushTokenRequest$Type extends MessageType<DeleteDevicePushTokenRequest> {
    constructor() {
        super("viam.app.v1.DeleteDevicePushTokenRequest", [
            { no: 1, name: "app_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "device_uuid", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message viam.app.v1.DeleteDevicePushTokenRequest
 */
export const DeleteDevicePushTokenRequest = new DeleteDevicePushTokenRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class DeleteDevicePushTokenResponse$Type extends MessageType<DeleteDevicePushTokenResponse> {
    constructor() {
        super("viam.app.v1.DeleteDevicePushTokenResponse", []);
    }
}
/**
 * @generated MessageType for protobuf message viam.app.v1.DeleteDevicePushTokenResponse
 */
export const DeleteDevicePushTokenResponse = new DeleteDevicePushTokenResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GetDevicePushTokensRequest$Type extends MessageType<GetDevicePushTokensRequest> {
    constructor() {
        super("viam.app.v1.GetDevicePushTokensRequest", [
            { no: 1, name: "app_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message viam.app.v1.GetDevicePushTokensRequest
 */
export const GetDevicePushTokensRequest = new GetDevicePushTokensRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GetDevicePushTokensResponse$Type extends MessageType<GetDevicePushTokensResponse> {
    constructor() {
        super("viam.app.v1.GetDevicePushTokensResponse", [
            { no: 1, name: "device_tokens", kind: "scalar", repeat: 2 /*RepeatType.UNPACKED*/, T: 9 /*ScalarType.STRING*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message viam.app.v1.GetDevicePushTokensResponse
 */
export const GetDevicePushTokensResponse = new GetDevicePushTokensResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class SetFirebaseConfigRequest$Type extends MessageType<SetFirebaseConfigRequest> {
    constructor() {
        super("viam.app.v1.SetFirebaseConfigRequest", [
            { no: 1, name: "org_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "app_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "config_json", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message viam.app.v1.SetFirebaseConfigRequest
 */
export const SetFirebaseConfigRequest = new SetFirebaseConfigRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class SetFirebaseConfigResponse$Type extends MessageType<SetFirebaseConfigResponse> {
    constructor() {
        super("viam.app.v1.SetFirebaseConfigResponse", []);
    }
}
/**
 * @generated MessageType for protobuf message viam.app.v1.SetFirebaseConfigResponse
 */
export const SetFirebaseConfigResponse = new SetFirebaseConfigResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GetFirebaseConfigRequest$Type extends MessageType<GetFirebaseConfigRequest> {
    constructor() {
        super("viam.app.v1.GetFirebaseConfigRequest", [
            { no: 1, name: "org_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message viam.app.v1.GetFirebaseConfigRequest
 */
export const GetFirebaseConfigRequest = new GetFirebaseConfigRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GetFirebaseConfigResponse$Type extends MessageType<GetFirebaseConfigResponse> {
    constructor() {
        super("viam.app.v1.GetFirebaseConfigResponse", [
            { no: 1, name: "app_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message viam.app.v1.GetFirebaseConfigResponse
 */
export const GetFirebaseConfigResponse = new GetFirebaseConfigResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class DeleteFirebaseConfigRequest$Type extends MessageType<DeleteFirebaseConfigRequest> {
    constructor() {
        super("viam.app.v1.DeleteFirebaseConfigRequest", [
            { no: 1, name: "org_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "app_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message viam.app.v1.DeleteFirebaseConfigRequest
 */
export const DeleteFirebaseConfigRequest = new DeleteFirebaseConfigRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class DeleteFirebaseConfigResponse$Type extends MessageType<DeleteFirebaseConfigResponse> {
    constructor() {
        super("viam.app.v1.DeleteFirebaseConfigResponse", []);
    }
}
/**
 * @generated MessageType for protobuf message viam.app.v1.DeleteFirebaseConfigResponse
 */
export const DeleteFirebaseConfigResponse = new DeleteFirebaseConfigResponse$Type();
/**
 * @generated ServiceType for protobuf service viam.app.v1.AppService
 */
export const AppService = new ServiceType("viam.app.v1.AppService", [
    { name: "GetUserIDByEmail", options: {}, I: GetUserIDByEmailRequest, O: GetUserIDByEmailResponse },
    { name: "CreateOrganization", options: {}, I: CreateOrganizationRequest, O: CreateOrganizationResponse },
    { name: "ListOrganizations", options: {}, I: ListOrganizationsRequest, O: ListOrganizationsResponse },
    { name: "GetOrganizationsWithAccessToLocation", options: {}, I: GetOrganizationsWithAccessToLocationRequest, O: GetOrganizationsWithAccessToLocationResponse },
    { name: "ListOrganizationsByUser", options: {}, I: ListOrganizationsByUserRequest, O: ListOrganizationsByUserResponse },
    { name: "SearchOrganizations", options: {}, I: SearchOrganizationsRequest, O: SearchOrganizationsResponse },
    { name: "GetOrganization", options: {}, I: GetOrganizationRequest, O: GetOrganizationResponse },
    { name: "GetOrganizationNamespaceAvailability", options: {}, I: GetOrganizationNamespaceAvailabilityRequest, O: GetOrganizationNamespaceAvailabilityResponse },
    { name: "UpdateOrganization", options: {}, I: UpdateOrganizationRequest, O: UpdateOrganizationResponse },
    { name: "UpdateOrganizationNamespace", options: {}, I: UpdateOrganizationNamespaceRequest, O: UpdateOrganizationNamespaceResponse },
    { name: "DeleteOrganization", options: {}, I: DeleteOrganizationRequest, O: DeleteOrganizationResponse },
    { name: "GetOrganizationMetadata", options: {}, I: GetOrganizationMetadataRequest, O: GetOrganizationMetadataResponse },
    { name: "UpdateOrganizationMetadata", options: {}, I: UpdateOrganizationMetadataRequest, O: UpdateOrganizationMetadataResponse },
    { name: "ListOrganizationMembers", options: {}, I: ListOrganizationMembersRequest, O: ListOrganizationMembersResponse },
    { name: "CreateOrganizationInvite", options: {}, I: CreateOrganizationInviteRequest, O: CreateOrganizationInviteResponse },
    { name: "UpdateOrganizationInviteAuthorizations", options: {}, I: UpdateOrganizationInviteAuthorizationsRequest, O: UpdateOrganizationInviteAuthorizationsResponse },
    { name: "DeleteOrganizationMember", options: {}, I: DeleteOrganizationMemberRequest, O: DeleteOrganizationMemberResponse },
    { name: "DeleteOrganizationInvite", options: {}, I: DeleteOrganizationInviteRequest, O: DeleteOrganizationInviteResponse },
    { name: "ResendOrganizationInvite", options: {}, I: ResendOrganizationInviteRequest, O: ResendOrganizationInviteResponse },
    { name: "EnableBillingService", options: {}, I: EnableBillingServiceRequest, O: EnableBillingServiceResponse },
    { name: "DisableBillingService", options: {}, I: DisableBillingServiceRequest, O: DisableBillingServiceResponse },
    { name: "UpdateBillingService", options: {}, I: UpdateBillingServiceRequest, O: UpdateBillingServiceResponse },
    { name: "GetBillingServiceConfig", options: {}, I: GetBillingServiceConfigRequest, O: GetBillingServiceConfigResponse },
    { name: "OrganizationSetSupportEmail", options: {}, I: OrganizationSetSupportEmailRequest, O: OrganizationSetSupportEmailResponse },
    { name: "OrganizationGetSupportEmail", options: {}, I: OrganizationGetSupportEmailRequest, O: OrganizationGetSupportEmailResponse },
    { name: "OrganizationSetLogo", options: {}, I: OrganizationSetLogoRequest, O: OrganizationSetLogoResponse },
    { name: "OrganizationGetLogo", options: {}, I: OrganizationGetLogoRequest, O: OrganizationGetLogoResponse },
    { name: "EnableAuthService", options: {}, I: EnableAuthServiceRequest, O: EnableAuthServiceResponse },
    { name: "DisableAuthService", options: {}, I: DisableAuthServiceRequest, O: DisableAuthServiceResponse },
    { name: "CreateOAuthApp", options: {}, I: CreateOAuthAppRequest, O: CreateOAuthAppResponse },
    { name: "ReadOAuthApp", options: {}, I: ReadOAuthAppRequest, O: ReadOAuthAppResponse },
    { name: "UpdateOAuthApp", options: {}, I: UpdateOAuthAppRequest, O: UpdateOAuthAppResponse },
    { name: "DeleteOAuthApp", options: {}, I: DeleteOAuthAppRequest, O: DeleteOAuthAppResponse },
    { name: "ListOAuthApps", options: {}, I: ListOAuthAppsRequest, O: ListOAuthAppsResponse },
    { name: "CreateOAuthAppUser", options: {}, I: CreateOAuthAppUserRequest, O: CreateOAuthAppUserResponse },
    { name: "CreateLocation", options: {}, I: CreateLocationRequest, O: CreateLocationResponse },
    { name: "GetLocation", options: {}, I: GetLocationRequest, O: GetLocationResponse },
    { name: "UpdateLocation", options: {}, I: UpdateLocationRequest, O: UpdateLocationResponse },
    { name: "DeleteLocation", options: {}, I: DeleteLocationRequest, O: DeleteLocationResponse },
    { name: "GetLocationMetadata", options: {}, I: GetLocationMetadataRequest, O: GetLocationMetadataResponse },
    { name: "UpdateLocationMetadata", options: {}, I: UpdateLocationMetadataRequest, O: UpdateLocationMetadataResponse },
    { name: "ListLocations", options: {}, I: ListLocationsRequest, O: ListLocationsResponse },
    { name: "ShareLocation", options: {}, I: ShareLocationRequest, O: ShareLocationResponse },
    { name: "UnshareLocation", options: {}, I: UnshareLocationRequest, O: UnshareLocationResponse },
    { name: "LocationAuth", options: {}, I: LocationAuthRequest, O: LocationAuthResponse },
    { name: "CreateLocationSecret", options: {}, I: CreateLocationSecretRequest, O: CreateLocationSecretResponse },
    { name: "DeleteLocationSecret", options: {}, I: DeleteLocationSecretRequest, O: DeleteLocationSecretResponse },
    { name: "GetRobot", options: {}, I: GetRobotRequest, O: GetRobotResponse },
    { name: "GetRobotMetadata", options: {}, I: GetRobotMetadataRequest, O: GetRobotMetadataResponse },
    { name: "UpdateRobotMetadata", options: {}, I: UpdateRobotMetadataRequest, O: UpdateRobotMetadataResponse },
    { name: "GetRoverRentalRobots", options: {}, I: GetRoverRentalRobotsRequest, O: GetRoverRentalRobotsResponse },
    { name: "GetRobotParts", options: {}, I: GetRobotPartsRequest, O: GetRobotPartsResponse },
    { name: "GetRobotPart", options: {}, I: GetRobotPartRequest, O: GetRobotPartResponse },
    { name: "GetRobotPartByNameAndLocation", options: {}, I: GetRobotPartByNameAndLocationRequest, O: GetRobotPartByNameAndLocationResponse },
    { name: "GetRobotPartLogs", options: {}, I: GetRobotPartLogsRequest, O: GetRobotPartLogsResponse },
    { name: "TailRobotPartLogs", serverStreaming: true, options: {}, I: TailRobotPartLogsRequest, O: TailRobotPartLogsResponse },
    { name: "GetRobotPartHistory", options: {}, I: GetRobotPartHistoryRequest, O: GetRobotPartHistoryResponse },
    { name: "UpdateRobotPart", options: {}, I: UpdateRobotPartRequest, O: UpdateRobotPartResponse },
    { name: "SetConfigProperty", options: {}, I: SetConfigPropertyRequest, O: SetConfigPropertyResponse },
    { name: "NewRobotPart", options: {}, I: NewRobotPartRequest, O: NewRobotPartResponse },
    { name: "DeleteRobotPart", options: {}, I: DeleteRobotPartRequest, O: DeleteRobotPartResponse },
    { name: "GetRobotPartMetadata", options: {}, I: GetRobotPartMetadataRequest, O: GetRobotPartMetadataResponse },
    { name: "UpdateRobotPartMetadata", options: {}, I: UpdateRobotPartMetadataRequest, O: UpdateRobotPartMetadataResponse },
    { name: "GetRobotAPIKeys", options: {}, I: GetRobotAPIKeysRequest, O: GetRobotAPIKeysResponse },
    { name: "MarkPartAsMain", options: {}, I: MarkPartAsMainRequest, O: MarkPartAsMainResponse },
    { name: "MarkPartForRestart", options: {}, I: MarkPartForRestartRequest, O: MarkPartForRestartResponse },
    { name: "CreateRobotPartSecret", options: {}, I: CreateRobotPartSecretRequest, O: CreateRobotPartSecretResponse },
    { name: "DeleteRobotPartSecret", options: {}, I: DeleteRobotPartSecretRequest, O: DeleteRobotPartSecretResponse },
    { name: "ListRobots", options: {}, I: ListRobotsRequest, O: ListRobotsResponse },
    { name: "ListRobotsForLocations", options: {}, I: ListRobotsForLocationsRequest, O: ListRobotsForLocationsResponse },
    { name: "ListRobotsForOrg", options: {}, I: ListRobotsForOrgRequest, O: ListRobotsForOrgResponse },
    { name: "NewRobot", options: {}, I: NewRobotRequest, O: NewRobotResponse },
    { name: "UpdateRobot", options: {}, I: UpdateRobotRequest, O: UpdateRobotResponse },
    { name: "DeleteRobot", options: {}, I: DeleteRobotRequest, O: DeleteRobotResponse },
    { name: "AddFavoriteMachine", options: {}, I: AddFavoriteMachineRequest, O: AddFavoriteMachineResponse },
    { name: "RemoveFavoriteMachine", options: {}, I: RemoveFavoriteMachineRequest, O: RemoveFavoriteMachineResponse },
    { name: "ListFavoriteMachines", options: {}, I: ListFavoriteMachinesRequest, O: ListFavoriteMachinesResponse },
    { name: "ListFragments", options: {}, I: ListFragmentsRequest, O: ListFragmentsResponse },
    { name: "GetFragment", options: {}, I: GetFragmentRequest, O: GetFragmentResponse },
    { name: "CreateFragment", options: {}, I: CreateFragmentRequest, O: CreateFragmentResponse },
    { name: "UpdateFragment", options: {}, I: UpdateFragmentRequest, O: UpdateFragmentResponse },
    { name: "DeleteFragment", options: {}, I: DeleteFragmentRequest, O: DeleteFragmentResponse },
    { name: "ListNestedFragments", options: {}, I: ListNestedFragmentsRequest, O: ListNestedFragmentsResponse },
    { name: "ListMachineFragments", options: {}, I: ListMachineFragmentsRequest, O: ListMachineFragmentsResponse },
    { name: "ListMachineSummaries", options: {}, I: ListMachineSummariesRequest, O: ListMachineSummariesResponse },
    { name: "GetFragmentHistory", options: {}, I: GetFragmentHistoryRequest, O: GetFragmentHistoryResponse },
    { name: "GetFragmentUsage", options: {}, I: GetFragmentUsageRequest, O: GetFragmentUsageResponse },
    { name: "SetFragmentTag", options: {}, I: SetFragmentTagRequest, O: SetFragmentTagResponse },
    { name: "DeleteFragmentTag", options: {}, I: DeleteFragmentTagRequest, O: DeleteFragmentTagResponse },
    { name: "AddRole", options: {}, I: AddRoleRequest, O: AddRoleResponse },
    { name: "RemoveRole", options: {}, I: RemoveRoleRequest, O: RemoveRoleResponse },
    { name: "ChangeRole", options: {}, I: ChangeRoleRequest, O: ChangeRoleResponse },
    { name: "ListAuthorizations", options: {}, I: ListAuthorizationsRequest, O: ListAuthorizationsResponse },
    { name: "CheckPermissions", options: {}, I: CheckPermissionsRequest, O: CheckPermissionsResponse },
    { name: "GetRegistryItem", options: {}, I: GetRegistryItemRequest, O: GetRegistryItemResponse },
    { name: "CreateRegistryItem", options: {}, I: CreateRegistryItemRequest, O: CreateRegistryItemResponse },
    { name: "UpdateRegistryItem", options: {}, I: UpdateRegistryItemRequest, O: UpdateRegistryItemResponse },
    { name: "ListRegistryItems", options: {}, I: ListRegistryItemsRequest, O: ListRegistryItemsResponse },
    { name: "DeleteRegistryItem", options: {}, I: DeleteRegistryItemRequest, O: DeleteRegistryItemResponse },
    { name: "RenameRegistryItem", options: {}, I: RenameRegistryItemRequest, O: RenameRegistryItemResponse },
    { name: "TransferRegistryItem", options: {}, I: TransferRegistryItemRequest, O: TransferRegistryItemResponse },
    { name: "DeprecateRegistryItem", options: {}, I: DeprecateRegistryItemRequest, O: DeprecateRegistryItemResponse },
    { name: "UndeprecateRegistryItem", options: {}, I: UndeprecateRegistryItemRequest, O: UndeprecateRegistryItemResponse },
    { name: "CreateModule", options: {}, I: CreateModuleRequest, O: CreateModuleResponse },
    { name: "UpdateModule", options: {}, I: UpdateModuleRequest, O: UpdateModuleResponse },
    { name: "UploadModuleFile", clientStreaming: true, options: {}, I: UploadModuleFileRequest, O: UploadModuleFileResponse },
    { name: "GetModule", options: {}, I: GetModuleRequest, O: GetModuleResponse },
    { name: "ListModules", options: {}, I: ListModulesRequest, O: ListModulesResponse },
    { name: "DeprecateRegistryItemVersion", options: {}, I: DeprecateRegistryItemVersionRequest, O: DeprecateRegistryItemVersionResponse },
    { name: "UndeprecateRegistryItemVersion", options: {}, I: UndeprecateRegistryItemVersionRequest, O: UndeprecateRegistryItemVersionResponse },
    { name: "CreateKey", options: {}, I: CreateKeyRequest, O: CreateKeyResponse },
    { name: "DeleteKey", options: {}, I: DeleteKeyRequest, O: DeleteKeyResponse },
    { name: "ListKeys", options: {}, I: ListKeysRequest, O: ListKeysResponse },
    { name: "RenameKey", options: {}, I: RenameKeyRequest, O: RenameKeyResponse },
    { name: "RotateKey", options: {}, I: RotateKeyRequest, O: RotateKeyResponse },
    { name: "CreateKeyFromExistingKeyAuthorizations", options: {}, I: CreateKeyFromExistingKeyAuthorizationsRequest, O: CreateKeyFromExistingKeyAuthorizationsResponse },
    { name: "GetAppContent", options: {}, I: GetAppContentRequest, O: GetAppContentResponse },
    { name: "GetAppBranding", options: {}, I: GetAppBrandingRequest, O: GetAppBrandingResponse },
    { name: "UploadDevicePushToken", options: {}, I: UploadDevicePushTokenRequest, O: UploadDevicePushTokenResponse },
    { name: "DeleteDevicePushToken", options: {}, I: DeleteDevicePushTokenRequest, O: DeleteDevicePushTokenResponse },
    { name: "GetDevicePushTokens", options: {}, I: GetDevicePushTokensRequest, O: GetDevicePushTokensResponse },
    { name: "SetFirebaseConfig", options: {}, I: SetFirebaseConfigRequest, O: SetFirebaseConfigResponse },
    { name: "GetFirebaseConfig", options: {}, I: GetFirebaseConfigRequest, O: GetFirebaseConfigResponse },
    { name: "DeleteFirebaseConfig", options: {}, I: DeleteFirebaseConfigRequest, O: DeleteFirebaseConfigResponse }
]);
